<template>
  <div style="margin: 30px 0">
    <div style="display: flex; align-items: center">
      <el-button size="mini" @click="m__back_to_list">
        <strong><i style="font-weight: bold" class="el-icon-arrow-left"></i> {{ $t('base.back') }}</strong>
      </el-button>

      <div style="display: flex; gap: 40px; margin-left: 20px; align-items: center">
        <div style="font-size: 15px!important;">
          {{ $t('base.shop_campaign_detail') }}
          &nbsp;-&nbsp; Campaign ID:
          <strong style="font-size: 15px; cursor: pointer" class="text-primary" @click="copy_text(c__campaign_id )">
            {{ c__campaign_id }}
          </strong>

          &nbsp;-&nbsp; Mục tiêu:
          <strong v-if="c__campaign_bidding_type === 'auto'" style="font-size: 15px; cursor: pointer"
                  class="text-primary">
            Giá thầu Tự động
          </strong>
          <strong v-if="c__campaign_bidding_type === 'manual'" style="font-size: 15px; cursor: pointer"
                  class="text-primary">
            Giá thầu Thủ công
          </strong>
        </div>

        <div>
          <slot name="automatic_configuration"></slot>
        </div>
      </div>
    </div>

    <div id="detail-double-scroll-wrapper" style="position: fixed; z-index: 20; bottom: 0;">
      <div id="detail-double-scroll-bar">
      </div>
    </div>

    <el-row style="margin: 10px 0; margin-top: 30px">
      <el-col :sm="18" class="cut-text" style="padding-left: 5px">
        <table class="table">
          <tr>
            <td style="vertical-align: middle !important; width: 110px">
              <strong v-if="campaign.campaign.state === 'ongoing'"
                      class="text-success">[{{ $t('base.ongoing').toUpperCase() }}]</strong>
              <strong v-if="campaign.campaign.state === 'paused'"
                      class="text-warning">[{{ $t('base.paused').toUpperCase() }}]</strong>
              <strong v-if="campaign.campaign.state === 'ended'" class="text-danger">[{{
                  $t('base.ended').toUpperCase()
                }}]</strong>
              <strong v-if="campaign.campaign.state === 'deleted'" class="text-danger">[{{
                  $t('base.deleted')
                }}]</strong>
            </td>
            <td style="vertical-align: middle !important;">
              <div style="display: flex; gap: 20px">
                <div class="shop-ads-image" style="width: 50px; height: 50px; cursor: pointer; position: relative"
                     @click="m__show_upload_shop_ads_image">
                  <img :src="'https://cf.shopee.com/file/' + shop_ads_image_url" alt="img"
                       style="width: 100%; height: 100%">
                  <div class="shop-ads-image-hover"
                       style="display: none; width: 50px; height: 50px; position: absolute; top: 0; left: 0; background-color: rgba(255,255,255,0.5)">
                    <div style="display: flex; width: 100%; height: 100%; align-items: center; justify-content: center">
                      <i class="el-icon-camera-solid" style="font-size: 16px; font-weight: bold"></i>
                    </div>
                  </div>
                </div>
                <div>
                  <span style="font-size: 14px"></span>{{ $t('base.campaign_name') }}:
                  <strong style="font-size: 14px">{{ campaign.campaign.name }}</strong>
                  &nbsp;&nbsp;
                  <span style="color: #999; font-size: 13px">
                    {{
                      campaign.advertisements.length ? campaign.advertisements[0].extinfo.shop_customisation.display_title : ''
                    }}
                  </span>
                  &nbsp;&nbsp;
                  <a v-if="parent_campaign.campaign && parent_campaign.campaign.bidding_type === 'manual'"
                     href="javascript:void(0)" style="font-size: 13px; color: tomato; font-weight: 600"
                     @click="m__show_update_shop_ads_dialog">
                    ({{ $t('base.edit') }} <i class="el-icon-edit"></i>)
                  </a>

                  <div style="height: 5px;"></div>

                  <span>{{ $t('base.duration') }}: &nbsp;
                    <a style="color: #999" href="javascript:void(0)"
                       @click="m__show_update_campaign_date">
                      <template v-if="campaign.campaign.end_time === 0"> {{ $t('base.no_end_date') }}</template>
                      <template v-else>
                        {{ campaign.campaign.start_time * 1000 | moment('DD/MM/YYYY') }}
                        -
                        {{ campaign.campaign.end_time * 1000 | moment('DD/MM/YYYY') }}
                      </template>
                      <i class="el-icon-edit"></i>
                    </a>
                  </span>
                  &nbsp;
                  &nbsp;
                  &nbsp;
                  &nbsp;
                  <span>{{ $t('base.budget') }}: &nbsp;<a style="color: #999" href="javascript:void(0)"
                                                          @click="m__show_update_campaign_quota">
                    <template
                      v-if="m__calculate(campaign.campaign.daily_quota) === 0 && m__calculate(campaign.campaign.total_quota) === 0">
                      {{ $t('base.unlimited') }}
                    </template>
                    <template v-else-if="m__calculate(campaign.campaign.daily_quota)">
                      {{ campaign.campaign.daily_quota | currency }} {{ m__currency() }} ({{ $t('base.daily_budget') }})
                    </template>
                    <template v-else>
                      {{ campaign.campaign.total_quota | currency }} {{ m__currency() }} ({{ $t('base.total_budget') }})
                    </template>
                    <i class="el-icon-edit"></i>
                  </a></span>
                  &nbsp;
                  &nbsp;
                  &nbsp;
                  &nbsp;
                  <template v-if="c__campaign_bidding_type === 'manual'">
                    <a style="color: #666; font-size: 13px" href="javascript:void(0)"
                       @click="m__show_update_pricing_type">
                      {{ $t('base.shopee_advanced_settings') }}:&nbsp;
                      <strong v-if="m__get_pricing_type() === 1" class="text-danger"
                              style="font-size: 13px">{{ $t('base.turning_off') }}</strong>
                      <strong v-if="m__get_pricing_type() === 2" class="text-success"
                              style="font-size: 13px">{{ $t('base.turning_on') }}</strong>
                    </a>
                  </template>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :sm="6" class="text-right">
        <div v-if="campaign.campaign.state !== 'deleted'">
          <el-button v-if="campaign.campaign.state === 'ongoing'" size="mini" icon="el-icon-video-pause" type="warning"
                     @click="m__pause_campaign" plain>{{ $t('base.pause') }}
          </el-button>
          <el-button v-if="campaign.campaign.state === 'paused'" size="mini" icon="el-icon-refresh-right" type="success"
                     @click="m__ongoing_campaign" plain>{{ $t('base.resume') }}
          </el-button>
          <el-button v-if="campaign.campaign.state === 'ongoing' || campaign.campaign.state === 'paused'" size="mini"
                     icon="el-icon-circle-close" type="danger" plain @click="m__stop_campaign">{{ $t('base.stop') }}
          </el-button>
          <el-button v-if="campaign.campaign.state === 'ended'" size="mini" icon="el-icon-refresh-right" type="success"
                     @click="m__restart_campaign" plain>{{ $t('base.restart') }}
          </el-button>
          <el-button size="mini" icon="el-icon-delete" type="danger"
                     @click="m__delete_campaign" plain> {{ $t('base.delete') }}
          </el-button>
        </div>
      </el-col>
    </el-row>

    <div style="margin-top: 20px">
      <ComponentMetric :metrics="metrics" :reports="reports" :is_compare="is_compare_keyword" :show_checkout="true"
                       :compare_metrics="compare_metrics" :compare_reports="compare_reports"
                       :shop="shop"></ComponentMetric>
    </div>
    <br>

    <div style="margin-bottom: 20px">
      <div v-if="c__campaign_bidding_type === 'manual'" style="display: flex;">
        <div style="flex: 1">
          <el-button size="mini" type="primary" icon="el-icon-plus" @click="m__show_add_keywords_dialog"
                     :loading="loading.show_add_keyword" style="width: 150px; max-width: 100%">
            {{ $t('ads.add_keywords') }}
          </el-button>
          <el-button type="primary" size="mini" @click="m__show_report_analysis_dialog" icon="el-icon-s-marketing">
            {{ $t('keyword.report_analysis') }}
          </el-button>
        </div>
        <div style="flex: 2; text-align: right">
          <el-dropdown v-if="m__check_marketing_package('auto_campaign')" trigger="click"
                       @command="m__handle_bulk_configuration">
            <el-button type="info" size="mini" icon="el-icon-s-tools"
                       :disabled="!keywords.filter(i => i.checked).length">
              <span class="text-danger"> {{ $t('ads.automatic_configuration') }} </span>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="auto">
                {{ $t('ads.mass_setup_auto_configuration') }}
              </el-dropdown-item>
              <el-dropdown-item command="anti">
                {{ $t('ads.mass_setup_anti_click_configuration') }}
              </el-dropdown-item>
              <el-dropdown-item command="cir">
                {{ $t('ads.mass_setup_optimize_based_on_cir_configuration') }}
              </el-dropdown-item>
              <el-dropdown-item command="condition_action">
                <strong>{{ $t('ads.mass_setup_conditional_automatic_configuration') }}</strong>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          &nbsp;&nbsp;
          <el-dropdown v-if="m__check_marketing_package('auto_campaign')" trigger="click"
                       @command="m__handle_on_off_remove_bulk_configuration">
            <el-button size="mini" type="info" :disabled="!keywords.filter(i => i.checked).length"
                       :loading="loading.delete_all">
              {{ $t('ads.resume_pause_delete_configuration') }}
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="start_auto"> {{ $t('ads.resume') }} {{
                  $t('ads.auto_configuration')
                }}
              </el-dropdown-item>
              <el-dropdown-item command="start_anti_click"> {{ $t('ads.resume') }} {{
                  $t('ads.anti_click_configuration')
                }}
              </el-dropdown-item>
              <el-dropdown-item command="start_auto_cir"> {{
                  $t('ads.resume')
                }}
                {{ $t('ads.optimize_based_on_cir_configuration') }}
              </el-dropdown-item>
              <el-dropdown-item command="start_condition_action">
                {{ $t('ads.resume') }}
                {{ $t('ads.conditional_configuration') }}
              </el-dropdown-item>
              <div class="hr" style="padding: 0 10px"></div>

              <el-dropdown-item command="stop_auto"> {{ $t('ads.pause') }} {{
                  $t('ads.auto_configuration')
                }}
              </el-dropdown-item>
              <el-dropdown-item command="stop_anti_click"> {{ $t('ads.pause') }} {{
                  $t('ads.anti_click_configuration')
                }}
              </el-dropdown-item>
              <el-dropdown-item command="stop_auto_cir"> {{
                  $t('ads.pause')
                }}
                {{ $t('ads.optimize_based_on_cir_configuration') }}
              </el-dropdown-item>
              <el-dropdown-item command="stop_condition_action">
                {{ $t('ads.pause') }}
                {{ $t('ads.conditional_configuration') }}
              </el-dropdown-item>
              <div class="hr" style="padding: 0 10px"></div>

              <el-dropdown-item command="auto">
                {{ $t('ads.mass_delete_auto_configuration') }}
              </el-dropdown-item>
              <el-dropdown-item command="anti">
                {{ $t('ads.mass_delete_anti_click_configuration') }}
              </el-dropdown-item>
              <el-dropdown-item command="cir">
                {{ $t('ads.mass_delete_optimize_based_on_cir_configuration') }}
              </el-dropdown-item>
              <el-dropdown-item command="auto_condition_action">
                {{ $t('ads.mass_delete_conditional_automatic_configuration') }}
              </el-dropdown-item>

              <template v-if="c__has_advanced_ads">
                <el-dropdown-item command="auto_condition_action">
                  {{ $t('ads.mass_delete_conditional_automatic_configuration') }}
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
          &nbsp;&nbsp;
          <el-button size="mini" type="info" icon="el-icon-edit"
                     :disabled="!keywords.filter(i => i.checked).length"
                     @click="m__show_update_multiple_keyword_price">
            {{ $t('base.mass_edit_bid_price') }}
          </el-button>
          &nbsp;&nbsp;
          <el-dropdown @command="m__handle_dropdown2">
            <el-button size="mini" icon="el-icon-arrow-down">{{ $t('base.mass_update_keywords') }}
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="3">{{ $t('base.update_keywords_by_conditions') }}</el-dropdown-item>
              <el-dropdown-item command="1">{{ $t('base.change_keywords_type') }}</el-dropdown-item>
              <el-dropdown-item command="2">{{ $t('base.change_keywords_status') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div style="margin-top: 25px; text-align: right">
        <el-button size="mini" @click="m__show_compare_keyword">
          {{ $t('base.compare_data') }}
          <strong style="font-weight: 600" v-if="is_compare_keyword" class="text-success">[ ON ]</strong>
          <strong style="font-weight: 700" v-else class="text-danger">[ OFF ]</strong>
        </el-button>
        <el-button v-if="c__campaign_bidding_type === 'manual'" size="mini" @click="m__show_filter_dialog">
          <i class="ti-panel"></i>&nbsp; {{ $t('base.filter') }}
          <strong style="font-weight: 700" v-if="filter.some(i => i.value)" class="text-success">[ ON ]</strong>
          <strong style="font-weight: 700" v-else class="text-danger">[ OFF ]</strong>
        </el-button>
        <el-button size="mini" @click="show_dialog.operation_history = true" icon="el-icon-tickets">
          {{ $t('ads.operation_history') }}
        </el-button>
        <el-button v-if="c__campaign_bidding_type === 'manual'" size="mini" icon="ti-save"
                   @click="m__initial_save_keyword_file(false)">
          &nbsp;{{ $t('keyword.save_file') }}
        </el-button>
        &nbsp;&nbsp;
        <el-dropdown @command="m__handle_dropdown">
          <el-button size="mini" icon="el-icon-arrow-down" :loading="loading.export_report">{{
              $t('base.download_excel')
            }}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="c__campaign_bidding_type === 'manual'" command="1">
              {{ $t('base.download_x_file', {x: $t('base.keywords')}) }}
            </el-dropdown-item>
            <el-dropdown-item v-if="c__campaign_bidding_type === 'manual'" command="3">
              {{ $t('base.download_x_file', {x: $t('base.selected_keywords')}) }}
            </el-dropdown-item>
            <el-dropdown-item command="2">
              {{ $t('base.download_x_file', {x: $t('base.shopee_report')}) }}
            </el-dropdown-item>
            <el-dropdown-item v-if="c__campaign_bidding_type === 'manual'" command="4">
              {{ $t('base.download_x_file', {x: $t('base.keyword_metrics')}) }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        &nbsp;&nbsp;
        <el-button size="mini" @click="m__toggle_select_index">
          <i :class="show_dialog.select_index ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
          {{ $t('ads.select_metrics') }}
        </el-button>
      </div>

      <div v-if="show_dialog.select_index"
           style="border: 1px solid #e5e5e5;border-radius: 4px; padding: 20px 10px 10px 10px; margin-top: 10px">
        <div v-for="flag in flag_list" :key="flag.label"
             style="width: 20%; float: left; margin-bottom: 10px; font-size: 13px">
          <el-checkbox size="mini" v-model="flag.checked" @change="m__update_flag_list" class="cbx-black"
                       :disabled="flag.checked === true && flag_list.filter(i => i.checked === true).length <= 1">
            &nbsp;{{ flag.label }}
          </el-checkbox>
        </div>
        <div style="clear: both!important;"></div>

        <br>

        <div v-for="flag in atosa_flag_list" :key="flag.value"
             style="width: 20%; float: left; margin-bottom: 10px; font-size: 13px">
          <el-checkbox size="mini" v-model="flag.checked" @change="m__set_atosa_flag_list" class="cbx-black">
            &nbsp;{{ flag.label }}
          </el-checkbox>
        </div>
        <div style="clear: both!important;"></div>
      </div>

      <div v-if="c__campaign_bidding_type === 'manual'" style="display: flex; margin-top: 35px">
        <div style="flex: 1;">
          <a
            v-if="is_selected_all && c__show_keyword_display_list.filter(i => !i.auto && !i.summary).length < c__show_keyword_filter_list.length"
            href="javascript:void(0)" style="font-weight: 700; font-size: 13px"
            class="text-primary" @click="m__checked_by_page">
            {{ $t('base.select') }} {{ c__show_keyword_display_list.filter(i => !i.auto && !i.summary).length }}
            {{ $t('base.x_on_current_page', {x: $t('base.keywords')}) }}
          </a>
          <div v-else style="display: flex; gap: 10px">
            <el-select size="mini" value="" v-model="keyword_filter.page_size" style="width: 70px">
              <el-option v-for="item in keyword_filter.pages" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-select size="mini" value="" style="left: 0 !important;" v-model="keyword_filter.selected_type"
                       clearable>
              <el-option-group :label="$t('base.base')">
                <el-option value="" :label="$t('keyword.all')"></el-option>
                <el-option value="running" :label="$t('base.ongoing')"></el-option>
                <el-option value="paused" :label="$t('base.paused')"></el-option>
                <el-option value="match_type_0" :label="$t('keyword.exact')"></el-option>
                <el-option value="match_type_1" :label="$t('keyword.broad')"></el-option>
              </el-option-group>
              <el-option-group :label="$t('base.advanced')">
                <el-option value="lowest" :label="$t('keyword.with_very_low_performance')"></el-option>
                <el-option value="low" :label="$t('keyword.with_low_performance')"></el-option>
                <el-option value="medium" :label="$t('keyword.with_average_performance')"></el-option>
                <el-option value="high" :label="$t('keyword.with_high_performance')"></el-option>
              </el-option-group>
              <el-option-group :label="$t('base.other_options')">
                <el-option value="auto" :label="$t('base.applying_x', {x: $t('ads.auto_price')})"></el-option>
                <el-option value="auto_position"
                           :label="$t('base.applying_x', {x: $t('ads.auto_position')})"></el-option>
                <el-option value="auto_position_advanced"
                           :label="$t('base.applying_x', {x: $t('ads.advanced_auto_position')})"></el-option>
                <el-option value="auto_cir"
                           :label="$t('base.applying_x', {x: $t('ads.optimize_based_on_cir')})"></el-option>
                <el-option value="not_auto"
                           :label="$t('base.not_applying_x', {x: $t('ads.auto_configuration')})"></el-option>
                <el-option value="anti_click" :label="$t('base.applying_x', {x: $t('ads.anti_click')})"></el-option>
                <el-option value="not_anti_click"
                           :label="$t('base.not_applying_x', {x: $t('ads.anti_click')})"></el-option>
              </el-option-group>
            </el-select>
          </div>
        </div>
        <div style="flex: 2; display: flex; justify-content: right">
          <div style="width: 400px; display: flex; margin-left: 10px" class="merge-select-input">
            <el-select size="mini" v-model="search_keywords_type" style="width: 150px">
              <el-option :label="$t('base.expanded_search')" value=""></el-option>
              <el-option :label="$t('base.exact_search')" value="exact"></el-option>
            </el-select>
            <el-input v-model="search_keywords" size="mini" :placeholder="$t('input.placeholder')"
                      style="width: 250px"
                      suffix-icon="el-icon-search" class="input" clearable>
            </el-input>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-top: 20px">
      <el-table id="main-table-detail-fixed-header" :data="[]" @sort-change="m__sort_change"
                v-loading="loading.update_data || parent_campaign.loading" :header-row-style="{'min-height': '40px'}">
        <el-table-column v-if="c__campaign_bidding_type === 'manual'" width="40px" fixed="left">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-if="c__show_keyword_filter_list.length"
                         size="mini" :indeterminate="indeterminate" v-model="is_selected_all"
                         @change="m__select_all"></el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox v-if="!scope.row.auto && !scope.row.summary" size="mini" v-model="scope.row.checked"
                         @change="m__indeterminate"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.keyword')" prop="keyword" width="260px" show-tooltip-when-overflow
                         fixed="left">
          <template slot="header" slot-scope="scope">
            {{ $t('base.keyword') }} &nbsp;-&nbsp; <i class="el-icon-refresh text-primary"></i> <a
            href="javascript:void(0)"
            class="text-primary"
            @click="m__load_campaign_detail">{{ $t('base.reload_data') }}</a>
          </template>
          <template slot-scope="scope">
            <template v-if="scope.row.auto">
              <div style="padding: 5px">
                <strong>{{ $t('base.auto_bidding') }}</strong>
              </div>
            </template>
            <template v-else>
              <span class="atosa-keyword" style="font-size: 13px"
                    @click="copy_text(scope.row.keyword.normalize())"
                    v-on:dblclick="open_link_fixed(`https://shopee.vn/search?keyword=${scope.row.keyword.normalize()}`, shop)">
                {{ scope.row.keyword.normalize() }}
              </span>
              <br>
              <div style="height: 3px"></div>
              <el-row>
                <el-col :sm="8">
                  <small>
                    <a v-if="scope.row.status === 1" href="javascript:void(0)"
                       class="text-danger" style="color: #999" @click="m__pause_keyword(scope.row)">{{
                        $t('base.paused')
                      }}</a>
                    <a v-else-if="scope.row.status === 0" href="javascript:void(0)"
                       class="text-success" style="color: #999"
                       @click="m__recovery_keyword(scope.row)">{{ $t('base.restore') }}</a>
                    <a v-else href="javascript:void(0)">&nbsp;</a>
                  </small>
                </el-col>
                <el-col :sm="16" style="padding-right: 15px; display: flex; gap: 10px; justify-content: right">
                  <div v-if="m__is_auto_condition_action(scope.row.keyword)"
                       :class="m__is_auto_condition_action_running(scope.row.keyword) ? 'text-running' : 'text-paused'"
                       @click="m__show_keyword_auto_condition_action_dialog(scope.row.keyword)">
                    <el-tooltip placement="top" effect="light"
                                :content="$t('base.applying_x', {x: $t('ads.conditional_configuration')})">
                      <i style="font-size: 14px !important; font-weight: 500" class="el-icon-c-scale-to-original"></i>
                    </el-tooltip>
                  </div>
                  <div v-if="scope.row.anti_click"
                       :class="check_config_status(scope.row.anti_click) ? 'text-running' : 'text-paused'"
                       @click="m__show_config_anti_click_single(scope.row)">
                    <el-tooltip placement="top" effect="light"
                                :content="$t('base.applying_x', {x: $t('ads.anti_click')})">
                      <i style="font-size: 14px !important; font-weight: 500" class="el-icon-warning-outline"></i>
                    </el-tooltip>
                  </div>
                  <div v-if="scope.row.auto_cir" style="position: relative"
                       :class="check_config_status(scope.row.auto_cir) ? 'text-running' : 'text-paused'"
                       @click="m__show_config_auto_cir(scope.row)">
                    <el-tooltip placement="top" effect="light"
                                :content="$t('base.applying_x', {x: $t('ads.optimize_based_on_cir')})">
                      <i style="font-size: 14px !important; font-weight: 500" class="el-icon-s-help"></i>
                    </el-tooltip>

                    <div
                      v-if="scope.row.auto_cir && scope.row.auto_cir.advancedDays && scope.row.auto_cir.advancedDays.length"
                      style="width: 5px; height: 5px; background-color: #ee4d2d; border-radius: 50px; position: absolute; z-index: 10"></div>
                  </div>
                  <div v-if="scope.row.config_auto"
                       :class="check_config_status(scope.row.config_auto) ? 'text-running' : 'text-paused'"
                       @click="m__show_config_auto_campaign(scope.row)">
                    <el-tooltip placement="top" effect="light"
                                :content="$t('base.applying_x', {x: $t('ads.auto_price')})">
                      <i style="font-size: 14px !important; font-weight: 500" class="el-icon-setting"></i>
                    </el-tooltip>
                  </div>
                  <div v-if="scope.row.auto_position" style="position: relative"
                       :class="check_config_status(scope.row.auto_position) ? 'text-running' : 'text-paused'"
                       @click="m__show_config_auto_campaign(scope.row)">
                    <el-tooltip placement="top" effect="light"
                                :content="$t('base.applying_x', {x: $t('ads.auto_position')})">
                      <i style="font-size: 14px !important; font-weight: 500" class="el-icon-aim"></i>
                    </el-tooltip>
                    <div
                      v-if="scope.row.auto_position && scope.row.auto_position.advancedDays && scope.row.auto_position.advancedDays.length"
                      style="width: 5px; height: 5px; background-color: #ee4d2d; border-radius: 50px; position: absolute; z-index: 10"></div>
                  </div>
                </el-col>
              </el-row>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('keyword.type')" prop="match_type" width="120px" fixed="left">
          <template slot="header" slot-scope="scope">
            <el-dropdown trigger="click" @command="(command) => selected_keyword_type = command">
              <el-button type="text" size="mini">
                <strong :class="{'text-primary': selected_keyword_type !== 'all'}">
                  {{ $t('keyword.type') }}
                  <i :class="'el-icon-caret-bottom'"></i>
                </strong>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="all">
                  <div style="display: flex">
                    <span style="flex: auto">{{ $t('keyword.all') }}</span>
                    <span style="width: 10px">
                      <i v-if="selected_keyword_type === 'all'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="exact">
                  <div style="display: flex">
                    <span style="flex: auto">{{ $t('keyword.exact') }}</span>
                    <span style="width: 10px">
                      <i v-if="selected_keyword_type === 'exact'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="broad">
                  <div style="display: flex">
                    <span style="flex: auto">{{ $t('keyword.broad') }}</span>
                    <span style="width: 10px">
                      <i v-if="selected_keyword_type === 'broad'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <template v-if="scope.row.auto">
              {{ $t('ads.auto_bidding') }}
            </template>
            <template v-else-if="scope.row.summary">
            </template>
            <template v-else>
              <el-dropdown @command="(command) => {scope.row.match_type = command; m__change_keyword_type(scope.row)}"
                           trigger="click">
                <span class="el-dropdown-link">
                  <template v-if="scope.row.match_type === 0">{{ $t('base.exact') }}</template>
                  <template v-if="scope.row.match_type === 1">{{ $t('base.broad') }}</template>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="0" :style="scope.row.match_type === 0 ? 'color: tomato' : ''">
                    {{ $t('keyword.exact') }}
                  </el-dropdown-item>
                  <el-dropdown-item :command="1" :style="scope.row.match_type === 1 ? 'color: tomato' : ''">
                    {{ $t('keyword.broad') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.bid_price')" width="125px" fixed="left" prop="price" sortable="custom">
          <template slot-scope="scope">
            <template v-if="scope.row.auto">
              {{ $t('ads.auto_bidding') }}
            </template>
            <template v-else-if="scope.row.summary">
            </template>
            <template v-else>
              <span class="hover-class show-on-hover" @click="m__show_update_keyword_price(scope.row)">
                {{ m__calculate(scope.row.price) | currency }} {{ m__currency() }}
                <i class="el-icon-edit"></i>
              </span><br>
              <small style="color: #999">{{ $t('ads.recommend_price') }}</small>
              <small>{{ scope.row.recommend_price | currency }} {{ m__currency() }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="c__campaign_bidding_type === 'manual' && m__check_marketing_package('auto_campaign')"
                         :label="$t('base.action')" width="140" :fixed="is_fixed">
          <template slot="header" slot-scope="scope">
            {{ $t('base.action') }}
          </template>
          <template slot-scope="scope">
            <template v-if="scope.row.auto">-</template>
            <template v-else-if="scope.row.summary">-</template>
            <template v-else>
              <el-dropdown trigger="click"
                           @command="(command) => {if (command==='auto')m__show_config_auto_campaign(scope.row); if (command==='anti') m__show_config_anti_click_single(scope.row); if (command==='cir') m__show_config_auto_cir(scope.row)}">
                <el-button type="info" size="mini" icon="el-icon-s-tools">
                  <span class="text-danger">{{ $t('base.setup') }}</span>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="auto">
                    {{ $t('ads.auto_configuration') }} <br>
                    <span v-if="scope.row.config_auto || scope.row.auto_position" class="text-running">
                      <a href="javascript:void(0)">{{ $t('base.installed') }}</a>
                    </span>
                    <span v-else class="text-close">
                      <a href="javascript:void(0)">{{ $t('base.not_installed') }}</a>
                    </span>
                  </el-dropdown-item>

                  <div class="hr" style="padding: 0 5px"></div>
                  <el-dropdown-item command="anti">
                    {{ $t('ads.anti_click') }} <br>
                    <span v-if="scope.row.anti_click" class="text-running">
                      <a href="javascript:void(0)">{{ $t('base.installed') }}</a>
                    </span>
                    <span v-else class="text-close">
                      <a href="javascript:void(0)">{{ $t('base.not_installed') }}</a>
                    </span>
                  </el-dropdown-item>


                  <div v-if="auto_cir_fixed_list.some(i => $store.state.userInfo.username.includes(i))" class="hr"
                       style="padding: 0 5px"></div>
                  <el-dropdown-item command="cir"
                                    v-if="auto_cir_fixed_list.some(i => $store.state.userInfo.username.includes(i))">
                    {{ $t('ads.optimize_based_on_cir') }} <br>
                    <span v-if="scope.row.auto_cir" class="text-running">
                      <a href="javascript:void(0)">{{ $t('base.installed') }}</a>
                    </span>
                    <span v-else class="text-close">
                      <a href="javascript:void(0)">{{ $t('base.not_installed') }}</a>
                    </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="c__campaign_bidding_type === 'manual'" width="140px" :label="$t('base.add_tags')"
                         show-tooltip-when-overflow>
          <template slot="header" slot-scope="scope">
            <el-dropdown trigger="click" @command="m__handle_tag_command">
              <el-button type="text" size="mini">
                <strong :class="{'text-primary': tag_ids_selected.length}">
                  {{ $t('base.select_tags') }}
                  <i :class="show_dialog.select_index ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                </strong>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="added">
                  <div style="display: flex">
                    <span style="flex: auto">{{ $t('base.tags_added') }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected('added')" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="not_added">
                  <div style="display: flex">
                    <span style="flex: auto">{{ $t('base.no_tags_added') }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected('not_added')" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item v-for="tag in keyword_tag_list" :key="tag._id" :command="tag._id">
                  <div style="display: flex">
                    <span style="flex: auto">{{ tag.name }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected(tag._id)" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="create_tag" divided>
                  <i class="el-icon-plus"></i> {{ $t('base.create_tags') }}
                </el-dropdown-item>
                <el-dropdown-item command="add_to_keyword">
                  {{ $t('base.add_tags_for_selected_x', {x: $t('base.keywords')}) }}
                </el-dropdown-item>
                <el-dropdown-item command="remove_from_keyword">
                  {{ $t('base.remove_tags_of_selected_x', {x: $t('base.keywords')}) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <template v-if="!scope.row.auto && !scope.row.summary && keyword_tag_list.length">
              <el-dropdown trigger="click" @command="m__handle_keyword_tag_command">
                <template v-if="m__map_keyword_tag(scope.row)">
                  <strong class="text-primary">{{ m__map_keyword_tag(scope.row) }}</strong>
                </template>
                <template v-else>
                  <strong style="color: #3d3d3d">{{ $t('base.add_tags') }}</strong>
                </template>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="tag in keyword_tag_list" :key="tag._id"
                                    :command="JSON.stringify({keyword:scope.row, tag_id: tag._id})">
                    <div style="display: flex">
                      <span style="flex: auto">{{ tag.name }}</span>
                      <span style="width: 10px">
                        <i v-if="m__check_keyword_match(scope.row, tag._id)" class="el-icon-check"></i>
                      </span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="m__map_keyword_tag(scope.row)"
                                    :command="JSON.stringify({keyword:scope.row, tag_id: 'remove_tag'})" divided>
                    <i class="el-icon-close"></i> {{ $t('base.remove_tags') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="c__campaign_bidding_type === 'manual'" :label="$t('base.volume')" width="140px"
                         prop="report.shopee_volume" sortable="custom">
          <template slot-scope="scope">
            <template v-if="scope.row.auto">-</template>
            <template v-else-if="scope.row.summary">-</template>
            <template v-else>
              {{ scope.row.report ? scope.row.report.shopee_volume : 0 | currency }}
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.shop_impressions')" width="140x" sortable="custom" prop="report.impression"
                         v-if="m__is_show_index('impression')">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.impression : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.impression : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.shop_clicks')" width="140px" sortable="custom" prop="report.click"
                         v-if="m__is_show_index('click')">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.click : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.click : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="CPC" width="120px" prop="report.atosa_cpc"
                         v-if="m__is_show_index('click')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.atosa_cpc : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.atosa_cpc : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.shop_ctr')" width="150px" sortable="custom" prop="report.ctr"
                         v-if="m__is_show_index('ctr')">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.ctr) * 100).toFixed(2) : '0.00' }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.ctr) * 100).toFixed(2) : '0.00' }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.product_impressions')" width="140x" sortable="custom"
                         prop="report.shop_item_impression"
                         v-if="m__is_show_index('shopItemImpression')">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.shop_item_impression : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.shop_item_impression : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.product_clicks')" width="140px" sortable="custom"
                         prop="report.shop_item_click"
                         v-if="m__is_show_index('shopItemClick')">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.shop_item_click : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.shop_item_click : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.product_ctr')" width="150px" sortable="custom" prop="report.shop_ctr"
                         v-if="m__is_show_index('shopCtr')">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.shop_ctr) * 100).toFixed(2) : '0.00' }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.shop_ctr) * 100).toFixed(2) : '0.00' }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.conversions')" width="140px" prop="report.broad_order"
                         v-if="m__is_show_index('broad_order')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.broad_order : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.broad_order : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_conversions')" width="115px" prop="report.direct_order"
                         v-if="m__is_show_index('direct_order')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.direct_order : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.direct_order : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.items_sold')" width="150px" prop="report.broad_order_amount"
                         v-if="m__is_show_index('broad_order_amount')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.broad_order_amount : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.broad_order_amount : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_items_sold')" width="125px" prop="report.direct_order_amount"
                         v-if="m__is_show_index('direct_order_amount')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.direct_order_amount : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.direct_order_amount : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="GMV" width="120px" prop="report.broad_gmv"
                         v-if="m__is_show_index('broad_gmv')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.broad_gmv) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.broad_gmv) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_gmv')" width="130px" prop="report.direct_gmv"
                         v-if="m__is_show_index('direct_gmv')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.direct_gmv) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.direct_gmv) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.expense')" width="120px" prop="report.cost"
                         v-if="m__is_show_index('cost')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.cost) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.cost) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="ROI (ROAS)" width="120px" prop="report.broad_roi"
                         v-if="m__is_show_index('broad_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? parseFloat(scope.row.report.broad_roi).toFixed(2) : 0 }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? parseFloat(scope.row.c_report.broad_roi).toFixed(2) : 0 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_roi')" width="120px" prop="report.direct_roi"
                         v-if="m__is_show_index('direct_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? parseFloat(scope.row.report.direct_roi).toFixed(2) : 0 }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? parseFloat(scope.row.c_report.direct_roi).toFixed(2) : 0 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="CIR (ACOS)" width="120px" prop="report.broad_cir"
                         v-if="m__is_show_index('broad_cir')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.broad_cir) * 100).toFixed(1) : 0 }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.broad_cir) * 100).toFixed(1) : 0 }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_cir')" width="120px" prop="report.direct_cir"
                         v-if="m__is_show_index('direct_cir')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.direct_cir) * 100).toFixed(1) : 0 }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.direct_cir) * 100).toFixed(1) : 0 }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.conversion_rate')" width="140px" prop="report.cr"
                         v-if="m__is_show_index('cr')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.cr) * 100).toFixed(1) : 0 }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.cr) * 100).toFixed(1) : 0 }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_conversion_rate')" width="140px" prop="report.direct_cr"
                         v-if="m__is_show_index('direct_cr')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.direct_cr) * 100).toFixed(1) : 0 }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.direct_cr) * 100).toFixed(1) : 0 }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.cost_per_conversion')" width="150px" prop="report.cpc"
                         v-if="m__is_show_index('cpc')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.cpc) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.cpc) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.cost_per_direct_conversion')" width="140px" prop="report.cpdc"
                         v-if="m__is_show_index('cpdc')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.cpdc) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.cpdc) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="AOV" width="120px" prop="report.aov"
                         v-if="m__is_show_atosa_index('aov')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.aov) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.aov) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="CPM" width="120px" prop="report.cpm"
                         v-if="m__is_show_atosa_index('cpm')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.cpm) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.cpm) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="c__campaign_bidding_type === 'manual'" :label="$t('base.action')" width="150px">
          <template slot-scope="scope">
            <el-button v-if="false && !scope.row.auto && !scope.row.summary" type="danger" size="mini"
                       icon="el-icon-delete" class="text-danger" @click="m__delete_keyword(scope.row)">
              <span class="text-danger">{{ $t('base.delete_keyword') }}</span>
            </el-button>

            <el-button v-if="!scope.row.auto && !scope.row.summary"
                       type="text" size="mini" @click="m__show_keyword_metrics_dialog(scope.row)">
              <strong class="text-primary">{{ $t('base.see_data_by_date') }}</strong>
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-table id="main-table-detail" ref="main-table-detail" :data="c__show_keyword_display_list"
                @sort-change="m__sort_change" :row-style="m__style_for_summary"
                v-loading="loading.update_data || parent_campaign.loading" :key="c__campaign_bidding_type">
        <el-table-column v-if="c__campaign_bidding_type === 'manual'" width="40px" fixed="left">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-if="c__show_keyword_filter_list.length"
                         size="mini" :indeterminate="indeterminate" v-model="is_selected_all"
                         @change="m__select_all"></el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox v-if="!scope.row.auto && !scope.row.summary" size="mini" v-model="scope.row.checked"
                         @change="m__indeterminate"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.keyword')" prop="keyword" width="260px" show-tooltip-when-overflow
                         fixed="left">
          <template slot="header" slot-scope="scope">
            {{ $t('base.keyword') }} &nbsp;-&nbsp; <i class="el-icon-refresh text-primary"></i> <a
            href="javascript:void(0)"
            class="text-primary"
            @click="m__load_campaign_detail">{{ $t('base.reload_data') }}</a>
          </template>
          <template slot-scope="scope">
            <template v-if="scope.row.auto">
              <div style="padding: 5px">
                <strong>{{ $t('base.auto_bidding') }}</strong>
              </div>
            </template>
            <template v-else>
              <span class="atosa-keyword" style="font-size: 13px"
                    @click="copy_text(scope.row.keyword.normalize())"
                    v-on:dblclick="open_link_fixed(`https://shopee.vn/search?keyword=${scope.row.keyword.normalize()}`, shop)">
                {{ scope.row.keyword.normalize() }}
              </span>
              <br>
              <div style="height: 3px"></div>
              <el-row>
                <el-col :sm="8">
                  <small>
                    <a v-if="scope.row.status === 1" href="javascript:void(0)"
                       class="text-danger" style="color: #999" @click="m__pause_keyword(scope.row)">{{
                        $t('base.paused')
                      }}</a>
                    <a v-else-if="scope.row.status === 0" href="javascript:void(0)"
                       class="text-success" style="color: #999"
                       @click="m__recovery_keyword(scope.row)">{{ $t('base.restore') }}</a>
                    <a v-else href="javascript:void(0)">&nbsp;</a>
                  </small>
                </el-col>
                <el-col :sm="16" style="padding-right: 15px; display: flex; gap: 10px; justify-content: right">
                  <div v-if="m__is_auto_condition_action(scope.row.keyword)"
                       :class="m__is_auto_condition_action_running(scope.row.keyword) ? 'text-running' : 'text-paused'"
                       @click="m__show_keyword_auto_condition_action_dialog(scope.row.keyword)">
                    <el-tooltip placement="top" effect="light"
                                :content="$t('base.applying_x', {x: $t('ads.conditional_configuration')})">
                      <i style="font-size: 14px !important; font-weight: 500" class="el-icon-c-scale-to-original"></i>
                    </el-tooltip>
                  </div>
                  <div v-if="scope.row.anti_click"
                       :class="check_config_status(scope.row.anti_click) ? 'text-running' : 'text-paused'"
                       @click="m__show_config_anti_click_single(scope.row)">
                    <el-tooltip placement="top" effect="light"
                                :content="$t('base.applying_x', {x: $t('ads.anti_click')})">
                      <i style="font-size: 14px !important; font-weight: 500" class="el-icon-warning-outline"></i>
                    </el-tooltip>
                  </div>
                  <div v-if="scope.row.auto_cir" style="position: relative"
                       :class="check_config_status(scope.row.auto_cir) ? 'text-running' : 'text-paused'"
                       @click="m__show_config_auto_cir(scope.row)">
                    <el-tooltip placement="top" effect="light"
                                :content="$t('base.applying_x', {x: $t('ads.optimize_based_on_cir')})">
                      <i style="font-size: 14px !important; font-weight: 500" class="el-icon-s-help"></i>
                    </el-tooltip>

                    <div
                      v-if="scope.row.auto_cir && scope.row.auto_cir.advancedDays && scope.row.auto_cir.advancedDays.length"
                      style="width: 5px; height: 5px; background-color: #ee4d2d; border-radius: 50px; position: absolute; z-index: 10"></div>
                  </div>
                  <div v-if="scope.row.config_auto"
                       :class="check_config_status(scope.row.config_auto) ? 'text-running' : 'text-paused'"
                       @click="m__show_config_auto_campaign(scope.row)">
                    <el-tooltip placement="top" effect="light"
                                :content="$t('base.applying_x', {x: $t('ads.auto_price')})">
                      <i style="font-size: 14px !important; font-weight: 500" class="el-icon-setting"></i>
                    </el-tooltip>
                  </div>
                  <div v-if="scope.row.auto_position" style="position: relative"
                       :class="check_config_status(scope.row.auto_position) ? 'text-running' : 'text-paused'"
                       @click="m__show_config_auto_campaign(scope.row)">
                    <el-tooltip placement="top" effect="light"
                                :content="$t('base.applying_x', {x: $t('ads.auto_position')})">
                      <i style="font-size: 14px !important; font-weight: 500" class="el-icon-aim"></i>
                    </el-tooltip>
                    <div
                      v-if="scope.row.auto_position && scope.row.auto_position.advancedDays && scope.row.auto_position.advancedDays.length"
                      style="width: 5px; height: 5px; background-color: #ee4d2d; border-radius: 50px; position: absolute; z-index: 10"></div>
                  </div>
                </el-col>
              </el-row>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('keyword.type')" prop="match_type" width="120px" fixed="left">
          <template slot="header" slot-scope="scope">
            <el-dropdown trigger="click" @command="(command) => selected_keyword_type = command">
              <el-button type="text" size="mini">
                <strong :class="{'text-primary': selected_keyword_type !== 'all'}">
                  {{ $t('keyword.type') }}
                  <i :class="'el-icon-caret-bottom'"></i>
                </strong>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="all">
                  <div style="display: flex">
                    <span style="flex: auto">{{ $t('keyword.all') }}</span>
                    <span style="width: 10px">
                      <i v-if="selected_keyword_type === 'all'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="exact">
                  <div style="display: flex">
                    <span style="flex: auto">{{ $t('keyword.exact') }}</span>
                    <span style="width: 10px">
                      <i v-if="selected_keyword_type === 'exact'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="broad">
                  <div style="display: flex">
                    <span style="flex: auto">{{ $t('keyword.broad') }}</span>
                    <span style="width: 10px">
                      <i v-if="selected_keyword_type === 'broad'" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <template v-if="scope.row.auto">
              {{ $t('ads.auto_bidding') }}
            </template>
            <template v-else-if="scope.row.summary">
            </template>
            <template v-else>
              <el-dropdown @command="(command) => {scope.row.match_type = command; m__change_keyword_type(scope.row)}"
                           trigger="click">
                <span class="el-dropdown-link">
                  <template v-if="scope.row.match_type === 0">{{ $t('base.exact') }}</template>
                  <template v-if="scope.row.match_type === 1">{{ $t('base.broad') }}</template>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="0" :style="scope.row.match_type === 0 ? 'color: tomato' : ''">
                    {{ $t('keyword.exact') }}
                  </el-dropdown-item>
                  <el-dropdown-item :command="1" :style="scope.row.match_type === 1 ? 'color: tomato' : ''">
                    {{ $t('keyword.broad') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.bid_price')" width="125px" fixed="left" prop="price" sortable="custom">
          <template slot-scope="scope">
            <template v-if="scope.row.auto">
              {{ $t('ads.auto_bidding') }}
            </template>
            <template v-else-if="scope.row.summary">
            </template>
            <template v-else>
              <span class="hover-class show-on-hover" @click="m__show_update_keyword_price(scope.row)">
                {{ m__calculate(scope.row.price) | currency }} {{ m__currency() }}
                <i class="el-icon-edit"></i>
              </span><br>
              <small style="color: #999">{{ $t('ads.recommend_price') }}</small>
              <small>{{ scope.row.recommend_price | currency }} {{ m__currency() }}</small>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="c__campaign_bidding_type === 'manual' && m__check_marketing_package('auto_campaign')"
                         :label="$t('base.action')" width="140" :fixed="is_fixed">
          <template slot="header" slot-scope="scope">
            {{ $t('base.action') }}
          </template>
          <template slot-scope="scope">
            <template v-if="scope.row.auto">-</template>
            <template v-else-if="scope.row.summary">-</template>
            <template v-else>
              <el-dropdown trigger="click"
                           @command="(command) => {if (command==='auto')m__show_config_auto_campaign(scope.row); if (command==='anti') m__show_config_anti_click_single(scope.row); if (command==='cir') m__show_config_auto_cir(scope.row)}">
                <el-button type="info" size="mini" icon="el-icon-s-tools">
                  <span class="text-danger">{{ $t('base.setup') }}</span>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="auto">
                    {{ $t('ads.auto_configuration') }} <br>
                    <span v-if="scope.row.config_auto || scope.row.auto_position" class="text-running">
                      <a href="javascript:void(0)">{{ $t('base.installed') }}</a>
                    </span>
                    <span v-else class="text-close">
                      <a href="javascript:void(0)">{{ $t('base.not_installed') }}</a>
                    </span>
                  </el-dropdown-item>

                  <div class="hr" style="padding: 0 5px"></div>
                  <el-dropdown-item command="anti">
                    {{ $t('ads.anti_click') }} <br>
                    <span v-if="scope.row.anti_click" class="text-running">
                      <a href="javascript:void(0)">{{ $t('base.installed') }}</a>
                    </span>
                    <span v-else class="text-close">
                      <a href="javascript:void(0)">{{ $t('base.not_installed') }}</a>
                    </span>
                  </el-dropdown-item>


                  <div v-if="auto_cir_fixed_list.some(i => $store.state.userInfo.username.includes(i))" class="hr"
                       style="padding: 0 5px"></div>
                  <el-dropdown-item command="cir"
                                    v-if="auto_cir_fixed_list.some(i => $store.state.userInfo.username.includes(i))">
                    {{ $t('ads.optimize_based_on_cir') }} <br>
                    <span v-if="scope.row.auto_cir" class="text-running">
                      <a href="javascript:void(0)">{{ $t('base.installed') }}</a>
                    </span>
                    <span v-else class="text-close">
                      <a href="javascript:void(0)">{{ $t('base.not_installed') }}</a>
                    </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="c__campaign_bidding_type === 'manual'" width="140px" :label="$t('base.add_tags')"
                         show-tooltip-when-overflow>
          <template slot="header" slot-scope="scope">
            <el-dropdown trigger="click" @command="m__handle_tag_command">
              <el-button type="text" size="mini">
                <strong :class="{'text-primary': tag_ids_selected.length}">
                  {{ $t('base.select_tags') }}
                  <i :class="show_dialog.select_index ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                </strong>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="added">
                  <div style="display: flex">
                    <span style="flex: auto">{{ $t('base.tags_added') }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected('added')" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="not_added">
                  <div style="display: flex">
                    <span style="flex: auto">{{ $t('base.no_tags_added') }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected('not_added')" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item v-for="tag in keyword_tag_list" :key="tag._id" :command="tag._id">
                  <div style="display: flex">
                    <span style="flex: auto">{{ tag.name }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected(tag._id)" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="create_tag" divided>
                  <i class="el-icon-plus"></i> {{ $t('base.create_tags') }}
                </el-dropdown-item>
                <el-dropdown-item command="add_to_keyword">
                  {{ $t('base.add_tags_for_selected_x', {x: $t('base.keywords')}) }}
                </el-dropdown-item>
                <el-dropdown-item command="remove_from_keyword">
                  {{ $t('base.remove_tags_of_selected_x', {x: $t('base.keywords')}) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <template v-if="!scope.row.auto && !scope.row.summary && keyword_tag_list.length">
              <el-dropdown trigger="click" @command="m__handle_keyword_tag_command">
                <template v-if="m__map_keyword_tag(scope.row)">
                  <strong class="text-primary">{{ m__map_keyword_tag(scope.row) }}</strong>
                </template>
                <template v-else>
                  <strong style="color: #3d3d3d">{{ $t('base.add_tags') }}</strong>
                </template>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="tag in keyword_tag_list" :key="tag._id"
                                    :command="JSON.stringify({keyword:scope.row, tag_id: tag._id})">
                    <div style="display: flex">
                      <span style="flex: auto">{{ tag.name }}</span>
                      <span style="width: 10px">
                        <i v-if="m__check_keyword_match(scope.row, tag._id)" class="el-icon-check"></i>
                      </span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="m__map_keyword_tag(scope.row)"
                                    :command="JSON.stringify({keyword:scope.row, tag_id: 'remove_tag'})" divided>
                    <i class="el-icon-close"></i> {{ $t('base.remove_tags') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="c__campaign_bidding_type === 'manual'" :label="$t('base.volume')" width="140px"
                         prop="report.shopee_volume" sortable="custom">
          <template slot-scope="scope">
            <template v-if="scope.row.auto">-</template>
            <template v-else-if="scope.row.summary">-</template>
            <template v-else>
              {{ scope.row.report ? scope.row.report.shopee_volume : 0 | currency }}
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.shop_impressions')" width="140x" sortable="custom" prop="report.impression"
                         v-if="m__is_show_index('impression')">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.impression : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.impression : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.shop_clicks')" width="140px" sortable="custom" prop="report.click"
                         v-if="m__is_show_index('click')">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.click : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.click : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="CPC" width="120px" prop="report.atosa_cpc"
                         v-if="m__is_show_index('click')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.atosa_cpc : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.atosa_cpc : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.shop_ctr')" width="150px" sortable="custom" prop="report.ctr"
                         v-if="m__is_show_index('ctr')">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.ctr) * 100).toFixed(2) : '0.00' }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.ctr) * 100).toFixed(2) : '0.00' }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.product_impressions')" width="140x" sortable="custom"
                         prop="report.shop_item_impression"
                         v-if="m__is_show_index('shopItemImpression')">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.shop_item_impression : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.shop_item_impression : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.product_clicks')" width="140px" sortable="custom"
                         prop="report.shop_item_click"
                         v-if="m__is_show_index('shopItemClick')">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.shop_item_click : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.shop_item_click : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.product_ctr')" width="150px" sortable="custom" prop="report.shop_ctr"
                         v-if="m__is_show_index('shopCtr')">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.shop_ctr) * 100).toFixed(2) : '0.00' }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.shop_ctr) * 100).toFixed(2) : '0.00' }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.conversions')" width="140px" prop="report.broad_order"
                         v-if="m__is_show_index('broad_order')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.broad_order : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.broad_order : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_conversions')" width="115px" prop="report.direct_order"
                         v-if="m__is_show_index('direct_order')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.direct_order : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.direct_order : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.items_sold')" width="150px" prop="report.broad_order_amount"
                         v-if="m__is_show_index('broad_order_amount')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.broad_order_amount : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.broad_order_amount : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_items_sold')" width="125px" prop="report.direct_order_amount"
                         v-if="m__is_show_index('direct_order_amount')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.direct_order_amount : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.direct_order_amount : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="GMV" width="120px" prop="report.broad_gmv"
                         v-if="m__is_show_index('broad_gmv')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.broad_gmv) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.broad_gmv) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_gmv')" width="130px" prop="report.direct_gmv"
                         v-if="m__is_show_index('direct_gmv')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.direct_gmv) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.direct_gmv) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.expense')" width="120px" prop="report.cost"
                         v-if="m__is_show_index('cost')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.cost) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.cost) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="ROI (ROAS)" width="120px" prop="report.broad_roi"
                         v-if="m__is_show_index('broad_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? parseFloat(scope.row.report.broad_roi).toFixed(2) : 0 }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? parseFloat(scope.row.c_report.broad_roi).toFixed(2) : 0 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_roi')" width="120px" prop="report.direct_roi"
                         v-if="m__is_show_index('direct_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? parseFloat(scope.row.report.direct_roi).toFixed(2) : 0 }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? parseFloat(scope.row.c_report.direct_roi).toFixed(2) : 0 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="CIR (ACOS)" width="120px" prop="report.broad_cir"
                         v-if="m__is_show_index('broad_cir')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.broad_cir) * 100).toFixed(1) : 0 }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.broad_cir) * 100).toFixed(1) : 0 }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_cir')" width="120px" prop="report.direct_cir"
                         v-if="m__is_show_index('direct_cir')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.direct_cir) * 100).toFixed(1) : 0 }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.direct_cir) * 100).toFixed(1) : 0 }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.conversion_rate')" width="140px" prop="report.cr"
                         v-if="m__is_show_index('cr')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.cr) * 100).toFixed(1) : 0 }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.cr) * 100).toFixed(1) : 0 }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_conversion_rate')" width="140px" prop="report.direct_cr"
                         v-if="m__is_show_index('direct_cr')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.direct_cr) * 100).toFixed(1) : 0 }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.direct_cr) * 100).toFixed(1) : 0 }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.cost_per_conversion')" width="150px" prop="report.cpc"
                         v-if="m__is_show_index('cpc')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.cpc) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.cpc) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.cost_per_direct_conversion')" width="140px" prop="report.cpdc"
                         v-if="m__is_show_index('cpdc')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.cpdc) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.cpdc) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="AOV" width="120px" prop="report.aov"
                         v-if="m__is_show_atosa_index('aov')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.aov) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.aov) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="CPM" width="120px" prop="report.cpm"
                         v-if="m__is_show_atosa_index('cpm')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.cpm) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.cpm) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="c__campaign_bidding_type === 'manual'" :label="$t('base.action')" width="150px">
          <template slot-scope="scope">
            <el-button v-if="false && !scope.row.auto && !scope.row.summary" type="danger" size="mini"
                       icon="el-icon-delete" class="text-danger" @click="m__delete_keyword(scope.row)">
              <span class="text-danger">{{ $t('base.delete_keyword') }}</span>
            </el-button>

            <el-button v-if="!scope.row.auto && !scope.row.summary"
                       type="text" size="mini" @click="m__show_keyword_metrics_dialog(scope.row)">
              <strong class="text-primary">{{ $t('base.see_data_by_date') }}</strong>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination id="detail-main-pagination" :current-page.sync="keyword_filter.current_page"
                     :page-size="keyword_filter.page_size"
                     layout="prev, pager, next, total" :total="c__show_keyword_filter_list.length"/>
    </div>

    <div v-if="c__campaign_bidding_type === 'auto'" style="margin-top: 50px">
      <strong style="font-size: 13px">
        Báo cáo chi tiết dữ liệu
      </strong>

      <div style="margin-top: 10px">
        <ComponentMetricTableView :shop="shop" :data="c__reports" :is_compare="is_compare_keyword"
                                  :compare_data="c__compare_reports" :show_extend="true"></ComponentMetricTableView>
      </div>
    </div>

    <div v-if="c__campaign_bidding_type === 'auto'" style="margin-top: 50px">
      <strong style="font-size: 13px">
        Xem dữ liệu theo giờ
      </strong>

      <div style="margin-top: 10px">
        <ComponentTableView :shop="shop"
                            :campaign_id="c__campaign_id"
                            :campaign_type="c__campaign_type"></ComponentTableView>
      </div>
    </div>

    <el-dialog :visible.sync="show_dialog.update_keyword_price" :close-on-click-modal="false"
               width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit_bid_price') }}</strong>

        <p class="text-title" style="">{{ $t('base.bid_price') }}</p>
        <el-input type="number" size="mini" v-model="selected_keyword.price"></el-input>

        <div class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" style="margin-top: 10px"
                     @click="m__update_keyword_price" :loading="loading.update_keyword_price">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.add_keywords" :close-on-click-modal="false"
               width="1350px" class="dialog-height-keyword">
      <div slot="title" style="padding:10px">

        <el-row>
          <el-col :sm="14" style="padding-right: 10px">
            <strong style="font-size: 14px">{{ $t('keyword.add_keywords') }} </strong>
            <br>
            <br>
            <br>

            <div class="atosa-tab">
              <div class="atosa-tab-item" :class="radio === '1' ? 'atosa-tab-item-active': ''" @click="radio = '1'">
                {{ $t('base.shopee_recommend') }}
              </div>
              <div v-if="m__check_marketing_package('keyword_tool')"
                   class="atosa-tab-item" :class="radio === '4' ? 'atosa-tab-item-active': ''" @click="radio = '4'">
                {{ $t('menu.atosa_keyword_tool') }}
              </div>
              <div class="atosa-tab-item" :class="radio === '2' ? 'atosa-tab-item-active': ''" @click="radio = '2'">
                {{ $t('keyword.file') }} (Atosa)
              </div>
              <div class="atosa-tab-item" :class="radio === '3' ? 'atosa-tab-item-active': ''" @click="radio = '3'">
                {{ $t('base.search_keywords') }}
              </div>
              <div class="atosa-tab-item" :class="radio === '5' ? 'atosa-tab-item-active': ''" @click="radio = '5'">
                Import Excel
              </div>
            </div>
          </el-col>
          <el-col :sm="10" style="padding: 0 10px 0 40px">
            <strong style="font-size: 14px"> {{ $t('keyword.added_keywords') }} ({{ added_keywords.length }})</strong>
            <br>
            <br>
            <br>
            <el-row>
              <el-col :sm="24">
                <el-select v-model="added_keywords_type" size="mini" style="border: none !important;">
                  <el-option :value="0" :label="$t('keyword.exact')"></el-option>
                  <el-option :value="1" :label="$t('keyword.broad')"></el-option>
                </el-select>
                &nbsp;
                <el-button size="mini" @click="m__show_update_added_keyword_dialog"> {{ $t('base.edit_bid_price') }}
                </el-button>
                <el-button size="mini" type="info" @click="added_keywords = []">Clear</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="height: 50px">
          <el-col :sm="14" style="padding-right: 10px">

            <div v-if="radio === '2'">
              <div>
                <el-select size="mini" value="" v-model="selected_keyword_file" @change="m__get_keyword_file_detail"
                           style="width: 250px" filterable :placeholder="$t('select.keyword_file')">
                  <el-option v-for="keyword in keyword_file_list" :key="keyword._id"
                             :value="keyword._id" :label="keyword.filename"></el-option>
                </el-select> &nbsp;&nbsp;
                <strong style="color: orangered; cursor: pointer"
                        @click="m__get_keyword_file(); m__get_keyword_file_detail()">
                  ({{ $t('base.update') }})</strong>
              </div>
            </div>

            <div v-if="radio === '3'">
              <div>
                <el-autocomplete size="mini" :placeholder="$t('input.placeholder')" v-model="keyword"
                                 style="width: 250px" :fetch-suggestions="m__suggest_keyword" :debounce="800"
                                 @select="m__search_sp_keyword" @keyup.enter.native="m__search_sp_keyword">

                </el-autocomplete>
              </div>
            </div>

            <div v-if="radio === '4'">
              <div>
                <el-input size="mini" :placeholder="$t('input.placeholder')"
                          v-model="base_keyword" style="width: 250px"
                          @keyup.enter.native="m__enter_input"></el-input>
                &nbsp;
                <el-button size="mini" type="primary" icon="el-icon-search" :loading="fff_loading"
                           @click="m__try_get_keyword_result"> {{ $t('base.search') }}
                </el-button>
              </div>
            </div>

            <div v-if="radio === '5'">
              <div>
                <el-button size="mini" type="primary" icon="ti-harddrives" @click="m__show_import_excel_file">
                  &nbsp;&nbsp;&nbsp;{{ $t('base.import_excel_file') }}
                </el-button>
                &nbsp;&nbsp;&nbsp;<strong class="text-danger">*{{ $t('keyword.import_note') }}</strong>
              </div>
            </div>
          </el-col>
          <el-col :sm="10" style="padding: 0 10px 0 40px">
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="14" style="padding-right: 10px">
            <div v-if="radio === '1'">
              <el-table :data="shopee_suggest_keywords">
                <el-table-column :label="$t('base.keyword')" prop="keyword">
                  <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.volume')" prop="search_volume" sortable>
                  <template slot-scope="scope">{{ scope.row.search_volume | currency }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.relevance')" prop="relevance" sortable>
                  <template slot-scope="scope">{{ scope.row.relevance | currency }}/10</template>
                </el-table-column>
                <el-table-column :label="$t('base.recommend_price')" prop="recommend_price" sortable>
                  <template slot-scope="scope">{{ m__calculate(scope.row.recommend_price) | currency }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" width="110px" align="right">
                  <template slot-scope="scope">
                    <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" @click="m__add_keyword(scope.row)"
                            class="text-info">{{ $t('base.add') }} ></strong>
                    <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div v-if="radio === '2'">
              <el-table :data="c__mipee_suggest_keywords_display"
                        @sort-change="({prop, order}) => {mipee_suggest_keywords_filter.sort_option.order = order; mipee_suggest_keywords_filter.sort_option.prop = prop}">
                <el-table-column :label="$t('base.keyword')" prop="keyword">
                  <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.volume')" prop="now_volume" sortable="custom">
                  <template slot-scope="scope">{{ scope.row.now_volume | currency }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.recommend_price')" prop="recommend_price" sortable="custom">
                  <template slot-scope="scope">{{ m__calculate(scope.row.recommend_price) | currency }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" width="110px" align="right">
                  <template slot-scope="scope">
                    <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" @click="m__add_keyword(scope.row)"
                            class="text-info">{{ $t('base.add') }} ></strong>
                    <strong v-else href="javascript:void(0)">{{ $t('base.added') }}</strong>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="mipee_suggest_keywords_filter.current_page"
                             :page-size="mipee_suggest_keywords_filter.page_size"
                             layout="prev, pager, next, total" :total="mipee_suggest_keywords.length"/>
            </div>

            <div v-if="radio === '3'">
              <el-table :data="c__add_keyword_display_list"
                        @sort-change="({prop, order}) => {add_keyword_filter.sort_option.order = order; add_keyword_filter.sort_option.prop = prop}">
                <el-table-column :label="$t('base.keyword')" prop="keyword">
                  <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.volume')" prop="sp_volume" sortable="custom">
                  <template slot-scope="scope">{{ scope.row.sp_volume | currency }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.relevance')" prop="relevance" sortable="custom">
                  <template slot-scope="scope">{{ scope.row.relevance | currency }}/10</template>
                </el-table-column>
                <el-table-column :label="$t('base.recommend_price')" prop="sp_price" sortable="custom">
                  <template slot-scope="scope">{{ scope.row.sp_price | currency }}</template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" width="110px" align="right">
                  <template slot-scope="scope">
                    <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" @click="m__add_keyword(scope.row)"
                            class="text-info">{{ $t('base.add') }} ></strong>
                    <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="add_keyword_filter.current_page"
                             :page-size="add_keyword_filter.page_size"
                             layout="prev, pager, next, total" :total="add_keyword.length"/>
            </div>

            <div v-if="radio === '4'">
              <el-table :data="c__fff_result_display_list" @sort-change="m__fff_sort_change" class="fff-table">
                <el-table-column :label="$t('base.keyword')" show-tooltip-when-overflow>
                  <template slot-scope="scope">
                    {{ scope.row.keyword.normalize() }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="sp_volume"
                  :label="$t('base.volume')" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.sp_volume | currency }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="sp_price"
                  :label="$t('base.recommend_price')" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.sp_price | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" width="110px" align="right">
                  <template slot-scope="scope">
                    <div style="padding-top: 5px">
                      <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text" class="text-info"
                              @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                        <strong>{{ $t('base.add') }} ></strong></strong>
                      <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="add_keyword_filter.current_page"
                             :page-size="add_keyword_filter.page_size"
                             layout="prev, pager, next, total" :total="fff_result.length"/>
            </div>

            <div v-if="radio === '5'">
              <el-table
                :data="c__excel_keyword_display_list">
                <el-table-column
                  :label="$t('base.keyword')">
                  <template slot-scope="scope">
                    {{ scope.row.keyword.normalize() }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="search_volume"
                  :label="$t('base.volume')" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.search_volume | currency }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="recommend_price"
                  :label="$t('base.recommend_price')" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.recommend_price | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" width="110px" align="right">
                  <template slot-scope="scope">
                    <div style="padding-top: 5px">
                      <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text" class="text-info"
                              @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                        <strong>{{ $t('base.add') }} ></strong></strong>
                      <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="excel_keyword_filter.current_page"
                             :page-size="excel_keyword_filter.page_size"
                             layout="prev, pager, next, total" :total="excel_keyword.length"/>
            </div>
          </el-col>
          <el-col :sm="10" style="padding: 0 10px 0 40px">
            <el-table :data="c__added_keyword_display_list">
              <el-table-column :label="$t('base.keyword')" prop="keyword">
                <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
              </el-table-column>
              <el-table-column :label="$t('base.bid_price')" prop="recommend_price" width="150px">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.recommend_price"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.action')" width="110px" align="right">
                <template slot-scope="scope">
                  <strong href="javascript:void(0)" class="text-danger"
                          @click="m__remove_keyword(scope.row)">{{ $t('base.delete') }}</strong>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="added_keyword_filter.current_page"
                           :page-size="added_keyword_filter.page_size"
                           layout="prev, pager, next, total" :total="added_keywords.length"/>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px">
          <el-col :sm="12">
            <el-button size="mini" type="primary" @click="m__add_all">
              {{ radio !== '4' ? $t('keyword.add_all') : $t('keyword.add_top_x', {x: '100'}) }}
            </el-button>
            &nbsp;
            &nbsp;
            &nbsp;
            <el-select v-if="restricted_keyword_fixed_list.some(i => $store.state.userInfo.username.includes(i))"
                       v-model="selected_restricted_keywords" value="" size="mini">
              <el-option value="" :label="$t('keyword.dont_use_restricted')"></el-option>
              <el-option v-for="item of restricted_keywords_list" :key="item.id" :value="item.id"
                         :label="item.name"></el-option>
            </el-select>
            &nbsp;
            &nbsp;
            &nbsp;
            <el-checkbox v-model="omit_duplicated_keyword">{{ $t('base.remove_duplicated_keywords') }}</el-checkbox>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-button size="mini" type="primary" :disabled="!added_keywords.length" icon="el-icon-check"
                       :loading="this.loading.confirm_add_keywords" @click="m__confirm_add_keyword">
              {{ $t('keyword.confirm_and_add') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_multiple_keyword_price" :close-on-click-modal="false"
               width="700px">
      <div slot="title" style="padding:10px">
        <el-row>
          <el-col :sm="14">
            <strong class="strong-title"> {{ $t('base.mass_edit_x', {x: $t('base.bid_price')}) }} </strong>
          </el-col>
          <el-col :sm="10">
            <el-select size="mini" value="" class="full-w" v-model="form_update_multiple_keyword_price.type">
              <el-option value="suggest" :label="$t('base.use_recommend_price')"></el-option>
              <el-option value="cpc" :label="$t('base.use_cpc')"></el-option>
            </el-select>

            <template v-if="form_update_multiple_keyword_price.type === 'cpc'">
              <br>
              <br>

              <strong class="strong-label">{{ $t('ads.bid_price_when_not_cpc') }}</strong>
              <el-input v-model="form_update_multiple_keyword_price.default_cpc"
                        size="mini" type="number" :placeholder="$t('input.value')"></el-input>
            </template>
          </el-col>
        </el-row>
        <br>

        <el-row style="margin-top: 10px">
          <el-col :sm="14">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="1">
              {{ $t('base.i_or_d_x_by_amount', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="10">
            <el-row>
              <el-col :sm="8">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_cost" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 1">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="16" style="padding-left: 10px">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value"></el-input>
                <div style="height: 5px"></div>
                <el-input v-if="form_update_multiple_keyword_price.update_by_cost === 'increase'"
                          size="mini" type="number" :placeholder="$t('input.max_bid_price')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value_max"></el-input>
                <el-input v-if="form_update_multiple_keyword_price.update_by_cost === 'reduce'"
                          size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value_min"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="14">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="2">
              {{ $t('base.i_or_d_x_by_percent', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="10">
            <el-row>
              <el-col :sm="8">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_percent" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 2">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="16" style="padding-left: 10px">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value"></el-input>
                <div style="height: 5px"></div>
                <el-input v-if="form_update_multiple_keyword_price.update_by_percent === 'increase'"
                          size="mini" type="number" :placeholder="$t('input.max_bid_price')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value_max"></el-input>
                <el-input v-if="form_update_multiple_keyword_price.update_by_percent === 'reduce'"
                          size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value_min"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="14">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="3">
              {{ $t('ads.i_or_d_by_rmd_or_cpc_by_amount') }}
            </el-radio>
          </el-col>
          <el-col :sm="10">
            <el-row>
              <el-col :sm="8">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_suggest_cost"
                           :disabled="form_update_multiple_keyword_price.update_type !== 3" class="full-w">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="16" style="padding-left: 10px">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 3"
                          v-model="form_update_multiple_keyword_price.update_by_suggest_cost_value"></el-input>
                <div style="height: 5px"></div>
                <el-input v-if="form_update_multiple_keyword_price.update_by_suggest_cost === 'increase'"
                          size="mini" type="number" :placeholder="$t('input.max_bid_price')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 3"
                          v-model="form_update_multiple_keyword_price.update_by_suggest_cost_value_max"></el-input>
                <el-input v-if="form_update_multiple_keyword_price.update_by_suggest_cost === 'reduce'"
                          size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 3"
                          v-model="form_update_multiple_keyword_price.update_by_suggest_cost_value_min"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="14">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="4">
              {{ $t('ads.i_or_d_by_rmd_or_cpc_by_percent') }}
            </el-radio>
          </el-col>
          <el-col :sm="10">
            <el-row>
              <el-col :sm="8">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_suggest_percent"
                           :disabled="form_update_multiple_keyword_price.update_type !== 4" class="full-w">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="16" style="padding-left: 10px">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 4"
                          v-model="form_update_multiple_keyword_price.update_by_suggest_percent_value"></el-input>
                <div style="height: 5px"></div>
                <el-input v-if="form_update_multiple_keyword_price.update_by_suggest_percent === 'increase'"
                          size="mini" type="number" :placeholder="$t('input.max_bid_price')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 4"
                          v-model="form_update_multiple_keyword_price.update_by_suggest_percent_value_max"></el-input>
                <el-input v-if="form_update_multiple_keyword_price.update_by_suggest_percent === 'reduce'"
                          size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                          :disabled="form_update_multiple_keyword_price.update_type !== 4"
                          v-model="form_update_multiple_keyword_price.update_by_suggest_percent_value_min"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="14">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="5">
              {{ $t('base.set_x', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="10">
            <el-row>
              <el-col :sm="8">
                <div>&nbsp;</div>
              </el-col>
              <el-col :sm="16" style="padding-left: 10px">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_keyword_price.update_type !== 5"
                          v-model="form_update_multiple_keyword_price.cost_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="14">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="6">
              {{ $t('ads.set_by_rmd_or_cpc') }}
            </el-radio>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check"
                     :loading="this.loading.update_multiple_keyword_price"
                     @click="m__update_multiple_keyword_price">{{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_multiple_keyword_match_type" :close-on-click-modal="false"
               width="600px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.mass_change_keywords_type') }}</strong>

        <el-radio v-model="form_update_multiple_keyword_price.match_type" :label="1">{{
            $t('keyword.broad')
          }}
        </el-radio>
        <br>
        <br>
        <el-radio v-model="form_update_multiple_keyword_price.match_type" :label="0">{{
            $t('keyword.exact')
          }}
        </el-radio>
        <br>
        <br>
        <el-button size="mini" type="primary" :loading="loading.update_multiple_keyword_match_type"
                   @click="m__update_multiple_keyword_match_type">
          {{ $t('base.confirm') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_multiple_keyword_status" :close-on-click-modal="false"
               width="600px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.mass_change_keywords_status') }}</strong>

        <el-radio v-model="form_update_multiple_keyword_price.status" :label="1">{{ $t('base.restore') }}</el-radio>
        <br>
        <br>
        <el-radio v-model="form_update_multiple_keyword_price.status" :label="0">{{ $t('base.paused') }}</el-radio>
        <br>
        <br>
        <el-button size="mini" type="primary" :loading="loading.update_multiple_keyword_status"
                   @click="m__update_multiple_keyword_status">
          {{ $t('base.confirm') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.config_auto_campaign" :close-on-click-modal="false" width="1250px">
      <div slot="title" style="padding:10px">
        <el-row style="background-color: #F1F1F1">
          <el-col :sm="5" style="padding-top: 10px;">
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 2 ? 'config-tab-active': ''" @click="config_tab = 2">
              <span style="font-size: 13px; font-weight: 700;">
                {{ $t('ads.auto_position_configuration') }}
              </span>
              <div v-if="!select_multiple && selected_keyword.auto_position"
                   style="margin-left: 10px; width:8px; display: inline-block; height:8px; background-color: #11ce65; border-radius:50vh;">
              </div>
            </div>
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 1 ? 'config-tab-active': ''" @click="config_tab = 1">
              <span style="font-size: 13px;  font-weight: 700">
                {{ $t('ads.auto_price_configuration') }}
              </span>
              <div v-if="!select_multiple && selected_keyword.auto_campaign"
                   style="margin-left: 10px; width:8px; display: inline-block; height:8px; background-color: #11ce65; border-radius:50vh;">
              </div>
            </div>
            <div style="padding: 0 30px; width: 100%; margin-top: 10px; margin-bottom: 10px">
              <div style="height: 0; width: 100%; border-top: 1px solid #cecece"></div>
            </div>
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 3 ? 'config-tab-active': ''" @click="config_tab = 3">
              <span style="font-size: 13px;  font-weight: 700">{{ $t('base.configuration_setup_guide') }}</span>
            </div>
          </el-col>
          <el-col :sm="19" style="background-color: #FFF;">
            <template v-if="config_tab === 1">
              <div style="padding: 10px 0 0 15px">
                <strong class="text-danger" style="font-size: 13px;">&nbsp;&nbsp;*
                  {{ $t('ads.atosa_use_0_note') }}</strong>

                <el-row style="padding: 0 10px;">
                  <el-col :sm="13" style="padding-right: 30px">
                    <br>
                    <el-row>
                      <el-col :sm="15">
                        <p class="text-title" style="">{{ $t('base.set_bid_price') }}</p>
                      </el-col>
                      <el-col :sm="9" style="padding-top: 20px">
                        <el-select size="mini" value="" class="full-w" v-model="form_config_auto_campaign.type">
                          <el-option value="suggest" :label="$t('base.use_recommend_price')"></el-option>
                          <el-option value="cpc" :label="$t('base.use_cpc')"></el-option>
                        </el-select>
                        <template v-if="this.form_config_auto_campaign.type === 'cpc'">
                          <br>
                          <p class="text-title" style="font-weight: unset; font-size: 13px !important;">
                            {{ $t('base.select_cpc_duration') }}</p>
                          <el-select size="mini" value="" class="full-w" v-model="form_config_auto_campaign.time">
                            <el-option value="today" :label="$t('base.today')"></el-option>
                            <el-option value="yesterday" :label="$t('base.yesterday')"></el-option>
                            <el-option value="week" :label="$t('base.last_week')"></el-option>
                            <el-option value="month" :label="$t('base.last_month')"></el-option>
                          </el-select>
                        </template>
                      </el-col>
                    </el-row>
                    <br>
                    <br>


                    <el-row>
                      <el-col :sm="18">
                        <el-radio v-model="form_config_auto_campaign.quota_type" :label="5" style="margin-top: 7px">
                          {{ $t('ads.general_label.higher_message') }}
                        </el-radio>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.increase_value"
                                  :min="1" :max="100" :disabled="form_config_auto_campaign.quota_type !== 5"></el-input>
                      </el-col>
                    </el-row>
                    <el-row style="margin-top: 5px;">
                      <el-col :sm="18" style="padding-left: 20px">
                        <el-checkbox v-model="form_config_auto_campaign.not_exceed_5"
                                     :disabled="form_config_auto_campaign.quota_type !== 5">
                          {{ $t('ads.general_label.not_exceeding_max') }}
                        </el-checkbox>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.not_exceed_5_value"
                                  :disabled="form_config_auto_campaign.quota_type !== 5"></el-input>
                      </el-col>
                    </el-row>
                    <br>

                    <el-row style="margin-top: 10px">
                      <el-col :sm="18">
                        <el-radio v-model="form_config_auto_campaign.quota_type" :label="6" style="margin-top: 7px">
                          {{ $t('ads.auto_price_label.lower_message') }}
                        </el-radio>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.reduce_value"
                                  :min="1" :max="100" :disabled="form_config_auto_campaign.quota_type !== 6"></el-input>
                      </el-col>
                    </el-row>
                    <el-row style="margin-top: 5px;">
                      <el-col :sm="18" style="padding-left: 20px">
                        <el-checkbox v-model="form_config_auto_campaign.not_exceed_6"
                                     :disabled="form_config_auto_campaign.quota_type !== 6">
                          {{ $t('ads.general_label.not_exceeding_max') }}
                        </el-checkbox>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.not_exceed_6_value"
                                  :disabled="form_config_auto_campaign.quota_type !== 6"></el-input>
                      </el-col>
                    </el-row>
                    <br>

                    <el-row style="margin-top: 10px">
                      <el-col :sm="18">
                        <el-radio v-model="form_config_auto_campaign.quota_type" :label="2" style="margin-top: 7px">
                          {{
                            $t('ads.auto_price_label.higher_x_message', {x: form_config_auto_campaign.increase_value})
                          }}
                        </el-radio>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.increase_value"
                                  :min="1" :max="100" :disabled="form_config_auto_campaign.quota_type !== 2"></el-input>
                      </el-col>
                    </el-row>
                    <el-row style="margin-top: 5px;">
                      <el-col :sm="18" style="padding-left: 20px">
                        <el-checkbox v-model="form_config_auto_campaign.not_exceed_2"
                                     :disabled="form_config_auto_campaign.quota_type !== 2">
                          {{ $t('ads.general_label.not_exceeding_max') }}
                        </el-checkbox>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.not_exceed_2_value"
                                  :disabled="form_config_auto_campaign.quota_type !== 2"></el-input>
                      </el-col>
                    </el-row>
                    <br>

                    <el-row style="margin-top: 5px">
                      <el-col :sm="18">
                        <el-radio v-model="form_config_auto_campaign.quota_type" :label="3" style="margin-top: 7px">
                          {{
                            $t('ads.auto_price_label.lower_x_message', {x: form_config_auto_campaign.reduce_value})
                          }}
                        </el-radio>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.reduce_value"
                                  :min="1" :max="100" :disabled="form_config_auto_campaign.quota_type !== 3"></el-input>
                      </el-col>
                    </el-row>
                    <el-row style="margin-top: 5px;" :disabled="form_config_auto_campaign.quota_type !== 2">
                      <el-col :sm="18" style="padding-left: 20px">
                        <el-checkbox v-model="form_config_auto_campaign.not_exceed_3"
                                     :disabled="form_config_auto_campaign.quota_type !== 3">
                          {{ $t('ads.general_label.not_exceeding_max') }}
                        </el-checkbox>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.not_exceed_3_value"
                                  :disabled="form_config_auto_campaign.quota_type !== 3"></el-input>
                      </el-col>
                    </el-row>
                    <br>

                    <el-radio v-model="form_config_auto_campaign.quota_type" :label="4" style="margin-top: 5px">
                      {{ $t('ads.auto_price_label.by_amount_or_cpc') }}
                    </el-radio>
                    <el-row style="margin-top: 5px;" :disabled="form_config_auto_campaign.quota_type !== 4">
                      <el-col :sm="18" style="padding-left: 20px">
                        <el-checkbox v-model="form_config_auto_campaign.not_exceed_4"
                                     :disabled="form_config_auto_campaign.quota_type !== 4">
                          {{ $t('ads.general_label.not_exceeding_max') }}
                        </el-checkbox>
                      </el-col>
                      <el-col :sm="6">
                        <el-input size="mini" type="number" v-model="form_config_auto_campaign.not_exceed_4_value"
                                  :disabled="form_config_auto_campaign.quota_type !== 4"></el-input>
                      </el-col>
                    </el-row>
                    <br>
                  </el-col>
                  <el-col :sm="11" style="padding: 0 15px 0 15px">
                    <br>
                    <p class="text-title" style="">{{ $t('base.configuration_runtime_list') }}</p>
                    <br>
                    <br>

                    <ComponentCustomTimePicker
                      :value.sync="form_config_auto_campaign.times"></ComponentCustomTimePicker>

                    <br>
                    <hr>
                    <p class="text-title" style=""> {{ $t('base.set_when_outside_runtime') }}</p>
                    <el-select size="mini" value="" class="full-w" v-model="form_config_auto_campaign.stop_action">
                      <el-option :value="0" :label="$t('base.keep_bid_price')"></el-option>
                      <el-option :value="1" :label="$t('base.pause_keyword')"></el-option>
                      <el-option :value="3" :label="$t('ads.general_label.edit_amount')"></el-option>
                    </el-select>

                    <template v-if="form_config_auto_campaign.stop_action === 3">
                      <p class="text-title" style="">{{ $t('base.set_bid_price') }}</p>
                      <el-input type="number" size="mini" v-model="form_config_auto_campaign.stop_action_3"
                                :placeholder="$t('input.bid_price')"></el-input>
                    </template>
                  </el-col>
                </el-row>

                <div style="margin-top: 10px" class="text-right">
                  <el-button size="mini" type="danger"
                             v-if="form_config_auto_campaign.state === 'RUNNING' && !select_multiple"
                             @click="m__delete_config_auto_campaign" icon="el-icon-delete">
                    {{ $t('base.delete_config') }}
                  </el-button>
                  <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.config_auto_campaign"
                             @click="m__save_config_auto_campaign('RUNNING')">
                    {{ $t('base.save_config') }}
                  </el-button>
                </div>
              </div>
            </template>

            <template v-if="config_tab === 2">
              <el-row style="padding: 10px 30px;">
                <el-col :sm="12" style="padding-right: 50px">
                  <div style="height: 18px">
                  </div>
                  <p class="text-title">{{ $t('ads.auto_position_label.select_type') }}:</p>
                  <br>
                  <el-select size="mini" class="full-w" value="" v-model="form_config_auto_position.type">
                    <el-option value="search" :label="$t('ads.auto_position_label.select_type_search')"></el-option>
                    <el-option value="impression"
                               :label="$t('ads.auto_position_label.select_type_impression')"></el-option>
                    <el-option value="click" :label="$t('ads.auto_position_label.select_type_click')"></el-option>
                  </el-select>

                  <el-row style="padding-top: 15px">
                    <el-col :sm="12" style="padding-right: 10px">
                      <p class="text-title"> {{ $t('base.bonus_amount') }}:</p>
                      <el-input v-model="form_config_auto_position.maxValue" size="mini" type="number"></el-input>
                    </el-col>
                    <el-col :sm="12">
                      <p class="text-title">{{ $t('base.max_bid_price') }}:</p>
                      <el-input v-model="form_config_auto_position.maxPrice" size="mini" type="number"></el-input>
                    </el-col>
                  </el-row>

                  <template v-if="form_config_auto_position.type === 'search'">
                    <p class="text-title" style="padding-top: 15px">
                      {{ $t('ads.auto_position_label.reduce_if') }} ({{ $t('base.optional') }}):
                    </p>
                    <el-input v-model="form_config_auto_position.reduce_if" size="mini" type="number"></el-input>

                    <p class="text-title" style="padding-top: 15px">{{ $t('base.min_bid_price') }}
                      ({{ $t('base.not_required') }}):</p>
                    <el-input v-model="form_config_auto_position.minPrice" size="mini" type="number"></el-input>
                  </template>
                </el-col>
                <el-col :sm="12" style="padding: 0 15px 15px 15px">
                  <div style="height: 18px">
                  </div>
                  <p class="text-title">{{ $t('base.configuration_runtime_list') }}</p>

                  <ComponentCustomTimePicker style="margin-top: 30px"
                                             :value.sync="form_config_auto_position.times"></ComponentCustomTimePicker>

                  <br>
                  <hr>
                  <p class="text-title" style=""> {{ $t('base.set_when_outside_runtime') }}</p>
                  <el-select size="mini" value="" class="full-w" v-model="form_config_auto_position.stop_action">
                    <el-option :value="0" :label="$t('base.keep_bid_price')"></el-option>
                    <el-option :value="1" :label="$t('base.pause_keyword')"></el-option>
                    <el-option :value="3" :label="$t('ads.general_label.edit_amount')"></el-option>
                  </el-select>

                  <template v-if="form_config_auto_position.stop_action === 3">
                    <p class="text-title" style="">{{ $t('base.set_bid_price') }}</p>
                    <el-input type="number" size="mini" v-model="form_config_auto_position.stop_action_3"
                              :placeholder="$t('input.bid_price')"></el-input>
                  </template>
                </el-col>
              </el-row>
              <br>
              <el-row style="margin-top: 10px">
                <el-col :sm="14" style="padding-left: 15px; padding-top: 5px">
                  <strong class="text-danger" style="font-size: 13px">
                    &nbsp;
                  </strong>
                </el-col>
                <el-col :sm="10" class="text-right">
                  <el-button size="mini" type="danger"
                             v-if="selected_keyword && selected_keyword.auto_position && !select_multiple"
                             @click="m__delete_config_auto_position" icon="el-icon-delete">
                    {{ $t('base.delete_config') }}
                  </el-button>
                  <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.auto_position"
                             @click="m__save_config_auto_position">
                    {{ $t('base.save_config') }}
                  </el-button>
                </el-col>
              </el-row>
            </template>

            <template v-if="config_tab === 3">
              <ComponentShopAdsPositionGuide></ComponentShopAdsPositionGuide>
            </template>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="save_keyword_file.show" :close-on-click-modal="false" custom-class="no-body"
               width="450px">
      <div slot="title" style="padding:10px">
        <div style="">
          <el-radio label="add" v-model="save_keyword_file_type">
            <strong>{{ $t('keyword.save_file') }}</strong>
          </el-radio>
          <div v-if="save_keyword_file_type === 'add'">
            <p class="text-title">{{ $t('base.filename') }}</p>
            <div>
              <el-input size="mini" :placeholder="$t('input.filename')"
                        v-model="save_keyword_file.filename"></el-input>
            </div>
            <div style="margin-top: 10px">
              <el-select size="mini" value="" v-model="save_keyword_type" class="full-w" filterable>
                <el-option value="selected" :label="$t('keyword.save_selected')"></el-option>
                <el-option value="all" :label="$t('keyword.save_all')"></el-option>
              </el-select>
            </div>
            <div style="padding-top:20px;" class="text-right">
              <el-button size="mini" icon="ti-save" :loading="save_keyword_file.loading" type="primary"
                         @click="m__try_save_keyword_file"> &nbsp; {{ $t('base.save_file') }}
              </el-button>
            </div>
          </div>

          <div style="margin-top: 30px">
            <el-radio label="update" v-model="save_keyword_file_type">
              <strong>{{ $t('keyword.update_existed_file') }}</strong>
            </el-radio>
            <div v-if="save_keyword_file_type === 'update'">
              <p class="text-title">{{ $t('select.keyword_file') }}</p>
              <div>
                <el-select size="mini" value="" v-model="selected_keyword_file" class="full-w" filterable
                           :placeholder="$t('select.keyword_file')">
                  <el-option v-for="keyword in keyword_file_list" :key="keyword._id"
                             :value="keyword._id" :label="keyword.filename"></el-option>
                </el-select>
              </div>
              <div style="margin-top: 10px">
                <el-select size="mini" value="" v-model="save_keyword_type" class="full-w" filterable>
                  <el-option value="selected" :label="$t('keyword.save_selected')"></el-option>
                  <el-option value="all" :label="$t('keyword.save_all')"></el-option>
                </el-select>
              </div>
              <div style="padding-top:20px;" class="text-right">
                <el-button size="mini" icon="ti-save" :loading="save_keyword_file.loading" type="primary"
                           @click="m__try_save_keyword_file"> &nbsp; {{ $t('base.update') }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_campaign_quota" :close-on-click-modal="false"
               width="420">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit') }} {{ $t('base.budget') }}</strong>

        <div>
          <el-radio v-model="selected_quota_type" label="1">{{ $t('base.unlimited') }}</el-radio>
          <br>
          <el-radio v-model="selected_quota_type" label="2">{{ $t('base.set_budget') }}</el-radio>
          <el-row v-if="selected_quota_type === '2'">
            <el-col :sm="12" style="padding-right: 10px">
              <el-input size="mini" type="number" :min="DAILY_BUDGET_MIN" v-model="campaign_quota.quota"></el-input>
            </el-col>
            <el-col :sm="12" style="padding-right: 10px">
              <el-select size="mini" class="full-w" value="" v-model="campaign_quota.type">
                <el-option value="daily" :label="$t('base.daily_budget')"></el-option>
                <el-option value="total" :label="$t('base.total_budget')"></el-option>
              </el-select>
            </el-col>
          </el-row>

          <el-row class="text-right" style="margin-top: 10px">
            <el-button size="mini" type="primary" :loading="loading.update_campaign_quota"
                       @click="m__update_campaign_quota">{{ $t('base.confirm') }}
            </el-button>
          </el-row>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_campaign_date" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit') }} {{ $t('ads.duration') }}</strong>

        <el-radio v-model="selected_time_type" label="unlimited">{{ $t('base.no_end_date') }}</el-radio>
        <br>
        <el-radio v-model="selected_time_type" label="from_to">{{ $t('ads.select_duration') }}</el-radio>
        <el-row v-if="selected_time_type === 'from_to'">
          <el-col :sm="12">
            <el-date-picker v-model="campaign_time.start_time" format="dd-MM-yyyy" size="mini"></el-date-picker>
          </el-col>
          <el-col :sm="12">
            <el-date-picker :placeholder="$t('base.select_end_time')" v-model="campaign_time.end_time"
                            format="dd-MM-yyyy"
                            size="mini"></el-date-picker>
          </el-col>
        </el-row>

        <el-row class="text-right" style="margin-top: 10px">
          <el-button size="mini" type="primary" @click="m__update_campaign_date"
                     :loading="loading.update_campaign_date">{{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_added_keyword_price" :close-on-click-modal="false"
               width="800px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title"> {{ $t('base.mass_edit_x', {x: $t('base.bid_price')}) }} </strong>


        <el-row>
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_added_keyword_price.update_type" :label="1">
              {{ $t('base.i_or_d_x_by_amount', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_added_keyword_price.update_by_cost" class="full-w"
                           :disabled="form_update_multiple_added_keyword_price.update_type !== 1">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_added_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_added_keyword_price.update_by_cost_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_added_keyword_price.update_type" :label="2">
              {{ $t('base.i_or_d_x_by_percent', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_added_keyword_price.update_by_percent"
                           class="full-w"
                           :disabled="form_update_multiple_added_keyword_price.update_type !== 2">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_added_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_added_keyword_price.update_by_percent_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_added_keyword_price.update_type" :label="3">
              {{ $t('base.set_x', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                &nbsp;
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number"
                          :disabled="form_update_multiple_added_keyword_price.update_type !== 3"
                          v-model="form_update_multiple_added_keyword_price.price"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <div style="margin-top: 10px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__update_added_keyword_price">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.filter" :close-on-click-modal="false" width="600px">
      <div slot="title" style="padding:10px">
        <form @submit.prevent="m__start_filter">
          <div style="height: calc(100vh - 150px); overflow: auto" @keyup.enter.navtive="m__start_filter" tabindex="0">
            <el-table :data="c__filter_show_list">
              <el-table-column :label="$t('base.column')" prop="label">
                <template slot-scope="scope">
                  <span style="font-weight: 700" :class="scope.row.value ? 'text-success' : ''">{{
                      scope.row.label
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column label="" prop="value2" width="110px">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.expression === '< <'" size="mini" v-model="scope.row.value2"
                            type="number"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.expression')" prop="expression" width="110px">
                <template slot-scope="scope">
                  <el-select class="full-w" size="mini" v-model="scope.row.expression">
                    <el-option label=">" value=">"></el-option>
                    <el-option label="<" value="<"></el-option>
                    <el-option label="=" value="==="></el-option>
                    <el-option label="≠" value="!=">
                      <span style="font-size: 16px !important;">≠</span>
                    </el-option>
                    <el-option label="> =" value=">="></el-option>
                    <el-option label="< =" value="<="></el-option>
                    <el-option label="< x <" value="< <"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.value')" prop="value" width="110px">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.value" type="number"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.optional')" width="100px" align="right">
                <template slot-scope="scope">
                  <div style="height: 3px"></div>
                  <el-button size="mini" type="danger"
                             @click="() => {scope.row.value = null; scope.row.expression = '>'}">Reset
                  </el-button>
                  <div style="height: 3px"></div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <br><br>
          <el-row>
            <el-col :sm="12" style="padding-left: 10px">
              <el-checkbox v-model="filter_flag">{{ $t('base.display_by_selected_metrics') }}</el-checkbox>
            </el-col>
          </el-row>
          <br>
          <el-row>
            <el-col :sm="24" class="text-right">
              <el-button size="mini" type="success" @click="show_dialog.save_filter = true"> {{
                  $t('base.save_filter')
                }}
              </el-button>
              <el-button size="mini" type="default" @click="show_dialog.filter_list = true">
                {{ $t('base.use_saved_filter') }}
              </el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="m__delete_filter">
                {{ $t('base.delete_filter') }}
              </el-button>
              <el-button size="mini" type="primary" icon="el-icon-check" @submit.prevent="m__start_filter"
                         native-type="submit"> {{ $t('base.execute') }}
              </el-button>
            </el-col>
          </el-row>
        </form>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.compare_keyword" :close-on-click-modal="false" width="450px">
      <div slot="title" style="padding:10px">
        <strong style="font-size:14px">{{ $t('base.compare_data') }}</strong>

        <br>
        <br>
        <div style="line-height: 20px">
          <strong style="font-size:13px"> {{ $t('base.current_duration') }}:</strong>
          <br>
          <strong style="font-size: 13px" class="text-danger"> {{ $t('base.from_date') }}:
            {{ start_date | moment('DD-MM-YYYY') }} - {{ $t('base.to_date') }}: {{
              end_date | moment('DD-MM-YYYY')
            }}</strong>

          <br>
          <br>

          <strong style="font-size:13px"> {{ $t('select.compare_duration') }}:</strong>
          <br>
          <el-date-picker v-model="compare_date_range" type="daterange" range-separator="-"
                          :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
                          format="dd-MM-yyyy"
                          :clearable="false" :picker-options="picker_options">
          </el-date-picker>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button size="mini" type="danger" @click="is_compare_keyword = false; show_dialog.compare_keyword = false">
            {{ $t('base.disable_compare_data') }}
          </el-button>
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_compare_keyword"
                     :loading="loading.compare_keyword">{{ $t('base.execute') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_shop_ads" :close-on-click-modal="false" width="450px">
      <div slot="title" style="padding:10px">
        <strong style="font-size:14px">{{ $t('base.update_campaign') }}</strong>

        <br>
        <br>
        <el-row>
          <el-col :sm="24">
            <p class="text-title">{{ $t('base.campaign_name') }}
              <span style="color: #999">({{ shop_ads.tagline.length }}/50)</span></p>
            <el-input size="mini" v-model="shop_ads.tagline" :placeholder="$t('input.tagline')"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24">
            <p class="text-title">{{ $t('ads.linked_page') }}</p>
            <el-select size="mini" v-model="shop_ads.type" @change="m__select_shop_ads_type" class="full-w">
              <el-option :value="0" :label="$t('ads.shop_page')"></el-option>
            </el-select>
          </el-col>
        </el-row>

        <br>
        <div class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_update_shop_ads"
                     :loading="loading.update_shop_ads">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.config_auto_cir" :close-on-click-modal="false" width="800px">
      <div slot="title" style="padding:10px">
        <el-row style="background-color: #F1F1F1">
          <el-col :sm="7" style="padding-top: 10px;">
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 6 ? 'config-tab-active': ''" @click="config_tab = 6">
              <span style="font-size: 13px; font-weight: 700"> {{
                  $t('ads.optimize_based_on_cir_configuration')
                }}</span>
              <div v-if="!select_multiple && selected_keyword.auto_cir"
                   style="margin-left: 10px; width:8px; display: inline-block; height:8px; background-color: #11ce65; border-radius:50vh;">
              </div>
            </div>
            <div style="padding: 0 30px; width: 100%; margin-top: 10px; margin-bottom: 10px">
              <div style="height: 0; width: 100%; border-top: 1px solid #cecece"></div>
            </div>
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 7 ? 'config-tab-active': ''" @click="config_tab = 7">
              <span style="font-size: 13px;  font-weight: 700">{{ $t('base.configuration_setup_guide') }}</span>
            </div>
          </el-col>
          <el-col :sm="17" style="background-color: #FFF;">
            <template v-if="config_tab === 6">
              <div style="padding: 10px 10px 10px 30px">
                <el-row>
                  <el-col :sm="16" style="padding-right: 10px">
                    <p class="text-title"> {{ $t('base.expected_cir') }}(%):</p>
                    <el-input v-model="form_config_auto_cir.fromCir" size="mini" type="number"
                              :placeholder="$t('input.expected_cir')"></el-input>
                  </el-col>
                  <el-col :sm="8">
                    <p class="text-title">&nbsp</p>
                    <el-select v-model="form_config_auto_cir.cirType" size="mini" value="" class="full-w">
                      <el-option value="broad" :label="$t('ads.anti_click_label.broad_cir')"></el-option>
                      <el-option value="direct" :label="$t('ads.anti_click_label.direct_cir')"></el-option>
                    </el-select>
                  </el-col>
                </el-row>

                <el-row style="margin-top: 15px">
                  <strong class="strong-label">{{ $t('ads.get_cir_by') }}</strong>
                  <el-select v-model="form_config_auto_cir.timeType" size="mini" value="" class="full-w">
                    <el-option value="today" :label="$t('base.today')"></el-option>
                    <el-option value="yesterday" :label="$t('base.yesterday')"></el-option>
                    <el-option value="week" :label="$t('base.last_week')"></el-option>
                    <el-option value="month" :label="$t('base.last_month')"></el-option>
                  </el-select>
                </el-row>

                <hr>
                <div style="margin-top: 15px"></div>
                <strong> {{ $t('base.edit_bid_price') }} {{ $t('ads.auto_cir_label.to_reach_target') }}</strong>
                <el-row>
                  <el-col :sm="14" style="padding-right: 10px">
                    <p class="text-title"> {{ $t('base.bonus_amount') }}:</p>
                    <el-input v-model="form_config_auto_cir.price" size="mini" type="number"
                              :placeholder="$t('input.bonus_amount')"
                              :disabled="!form_config_auto_cir.allowBidPrice"></el-input>
                  </el-col>
                  <el-col :sm="10">
                    <p class="text-title">{{ $t('base.max_bid_price') }}:</p>
                    <el-input v-model="form_config_auto_cir.maxPrice" size="mini" type="number"
                              :placeholder="$t('input.max_bid_price')"
                              :disabled="!form_config_auto_cir.allowBidPrice"></el-input>
                  </el-col>
                </el-row>

                <div style="margin-top: 15px"></div>
                <hr>
                <el-checkbox v-model="form_config_auto_cir.allowAtCase1" size="small">
                  {{ $t('ads.auto_cir_label.allow_when_above_target') }}
                </el-checkbox>
                <p class="text-title">{{ $t('base.action_plan') }}</p>
                <div>
                  <el-select v-model="form_config_auto_cir.case1Type" value="" size="mini" class="full-w"
                             :disabled="!form_config_auto_cir.allowAtCase1">
                    <el-option value="stop" :label="$t('base.pause_keyword')"></el-option>
                    <el-option value="value" :label="$t('ads.general_label.edit_amount')"></el-option>
                    <el-option value="reduce" :label="$t('ads.time_based_bid_reduction')"></el-option>
                  </el-select>
                </div>
                <div v-if="form_config_auto_cir.case1Type === 'value'" style="margin-top: 10px">
                  <el-input v-model="form_config_auto_cir.case1Value"
                            size="mini" type="number" :placeholder="$t('input.amount')"
                            :disabled="!form_config_auto_cir.allowAtCase1"></el-input>
                </div>
                <div v-if="form_config_auto_cir.case1Type === 'reduce'" style="margin-top: 10px">
                  <el-row>
                    <el-col :sm="12" style="padding-right: 5px">
                      <el-input v-model="form_config_auto_cir.case1Reduce"
                                size="mini" type="number" :placeholder="$t('input.deduction_amount')"
                                :disabled="!form_config_auto_cir.allowAtCase1"></el-input>
                    </el-col>
                    <el-col :sm="12" style="padding-left: 5px">
                      <el-input v-model="form_config_auto_cir.case1ReduceMin"
                                size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                                :disabled="!form_config_auto_cir.allowAtCase1"></el-input>
                    </el-col>
                  </el-row>
                </div>

                <hr>
                <el-row style="margin-top: 15px">
                  <el-checkbox v-model="form_config_auto_cir.allowAtCase2" size="small">
                    {{ $t('ads.anti_click_label.check_if_gmv_by_0') }}
                  </el-checkbox>
                  <p class="text-title">{{ $t('ads.anti_click_label.max_cost_if_gmv_by_0') }}</p>
                  <el-input v-model="form_config_auto_cir.case2Min" size="mini" :placeholder="$t('input.max_cost')"
                            type="number"
                            :disabled="!form_config_auto_cir.allowAtCase2"></el-input>

                  <br>
                  <p class="text-title" style="margin-top: 10px !important;">{{ $t('base.action_plan') }}</p>
                  <div>
                    <el-select v-model="form_config_auto_cir.case2Type" value="" size="mini" class="full-w"
                               :disabled="!form_config_auto_cir.allowAtCase2">
                      <el-option value="stop" :label="$t('base.pause_keyword')"></el-option>
                      <el-option value="value" :label="$t('ads.general_label.edit_amount')"></el-option>
                      <el-option value="reduce" :label="$t('ads.time_based_bid_reduction')"></el-option>
                    </el-select>
                  </div>
                  <div v-if="form_config_auto_cir.case2Type === 'value'" style="margin-top: 10px">
                    <el-input v-model="form_config_auto_cir.case2Value"
                              size="mini" type="number" :placeholder="$t('input.amount')"
                              :disabled="!form_config_auto_cir.allowAtCase2"></el-input>
                  </div>
                  <div v-if="form_config_auto_cir.case2Type === 'reduce'" style="margin-top: 10px">
                    <el-row>
                      <el-col :sm="12" style="padding-right: 5px">
                        <el-input v-model="form_config_auto_cir.case2Reduce"
                                  size="mini" type="number" :placeholder="$t('input.deduction_amount')"
                                  :disabled="!form_config_auto_cir.allowAtCase2"></el-input>
                      </el-col>
                      <el-col :sm="12" style="padding-left: 5px">
                        <el-input v-model="form_config_auto_cir.case2ReduceMin"
                                  size="mini" type="number" :placeholder="$t('input.min_bid_price')"
                                  :disabled="!form_config_auto_cir.allowAtCase2"></el-input>
                      </el-col>
                    </el-row>
                  </div>
                </el-row>

                <el-row style="margin-top: 30px">
                  <el-col :sm="24" class="text-right">
                    <el-button v-if="is_advanced_ads"
                               @click="m__show_cir_advanced_dialog" size="mini" type="success" icon="el-icon-star-on">
                      {{ $t('ads.advanced_configuration') }}
                    </el-button>
                    <el-button v-if="selected_keyword.auto_cir" size="mini" type="danger" icon="el-icon-delete"
                               @click="m__delete_auto_cir">
                      {{ $t('base.delete_config') }}
                    </el-button>
                    <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_save_auto_cir"
                               :loading="loading.config_auto_cir">
                      {{ $t('base.save_config') }}
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </template>

            <template v-if="config_tab === 7">
              <ComponentAutoCirGuide></ComponentAutoCirGuide>
            </template>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.config_anti_click" :close-on-click-modal="false" width="1000px">
      <div slot="title" style="padding: 10px">
        <el-row style="background-color: #F1F1F1">
          <el-col :sm="6" style="padding-top: 10px;">
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 4 ? 'config-tab-active': ''" @click="config_tab = 4">
              <span style="font-size: 13px; font-weight: 700;">
                {{ $t('ads.anti_click_configuration') }}
              </span>
              <div v-if="!select_multiple && selected_keyword.anti_click"
                   style="margin-left: 10px; width:8px; display: inline-block; height:8px; background-color: #11ce65; border-radius:50vh;">
              </div>
            </div>
            <div style="padding: 0 30px; width: 100%; margin-top: 10px; margin-bottom: 10px">
              <div style="height: 0; width: 100%; border-top: 1px solid #cecece"></div>
            </div>
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 5 ? 'config-tab-active': ''" @click="config_tab = 5">
              <span style="font-size: 13px;  font-weight: 700">
                {{ $t('base.configuration_setup_guide') }}
              </span>
            </div>
          </el-col>
          <el-col :sm="18" style="background-color: #FFF;">
            <template v-if="config_tab === 4">
              <div style="padding: 20px 0 20px 30px">
                <el-row>
                  <el-col :sm="12" style="padding-right: 60px">
                    <p class="text-title" style="">
                      <el-radio v-model="form_anti_click.type" label="1"><strong>1. {{
                          $t('ads.anti_click_label.type1')
                        }}</strong>
                      </el-radio>
                    </p>
                    <el-input :disabled="form_anti_click.type === '2'" size="mini" type="number"
                              v-model="form_anti_click.ratio"></el-input>

                    <p class="text-title" style=""> {{ $t('ads.anti_click_label.minimum_clicks') }} </p>
                    <el-input :disabled="form_anti_click.type === '2'" size="mini" type="number"
                              v-model="form_anti_click.click_minimum_number"></el-input>

                    <p class="text-title" style=""> {{ $t('ads.anti_click_label.maximum_clicks') }} </p>
                    <el-input :disabled="form_anti_click.type === '2'" size="mini" type="number"
                              v-model="form_anti_click.click_maximum_number"></el-input>
                  </el-col>
                  <el-col :sm="12" style="padding-right: 30px">
                    <p class="text-title" style="">
                      <el-radio v-model="form_anti_click.type" label="2"><strong>2. {{
                          $t('ads.anti_click_label.type2')
                        }}</strong>
                      </el-radio>
                    </p>
                    <el-row>
                      <el-col :sm="15" style="padding-right: 10px">
                        <el-input :disabled="form_anti_click.type === '1'" size="mini" type="number"
                                  v-model="form_anti_click.cir"></el-input>
                      </el-col>
                      <el-col :sm="9">
                        <el-select size="mini" class="full-w" value="" v-model="form_anti_click.is_direct_cir"
                                   :disabled="form_anti_click.type === '1'">
                          <el-option :value="0" :label="$t('ads.anti_click_label.broad_cir')"></el-option>
                          <el-option :value="1" :label="$t('ads.anti_click_label.direct_cir')"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :sm="24">
                        <p class="text-title" style="">{{ $t('ads.anti_click_label.maximum_cost') }}
                          ({{ $t('base.not_required') }})</p>
                        <el-input v-model="form_anti_click.max_cost" size="mini" :placeholder="$t('input.max_cost')"
                                  type="number" :disabled="form_anti_click.type === '1'"></el-input>
                      </el-col>
                    </el-row>

                    <p class="text-title" style="">{{ $t('ads.get_cir_by') }}</p>
                    <el-select v-model="form_anti_click.time_type" size="mini" value="" class="full-w"
                               :disabled="form_anti_click.type === '1'">
                      <el-option value="today" :label="$t('base.today')"></el-option>
                      <el-option value="yesterday" :label="$t('base.yesterday')"></el-option>
                      <el-option value="week" :label="$t('base.last_week')"></el-option>
                      <el-option value="month" :label="$t('base.last_month')"></el-option>
                    </el-select>

                    <br>
                    <br>
                    <span style="padding-left: 1px">
                      <el-checkbox v-model="form_anti_click.not_order" :disabled="form_anti_click.type === '1'"
                                   size="small">
                        {{ $t('ads.anti_click_label.check_if_gmv_by_0') }}
                      </el-checkbox>
                    </span>
                    <p class="text-title" style="margin-top: 1px !important;">
                      {{ $t('ads.anti_click_label.max_cost_if_gmv_by_0') }}</p>
                    <el-input v-model="form_anti_click.min_cost" size="mini" :placeholder="$t('input.max_cost')"
                              type="number"
                              :disabled="form_anti_click.type === '1' || !form_anti_click.not_order"></el-input>
                  </el-col>
                </el-row>

                <div style="padding-right: 30px">
                  <p class="text-title" style="">{{ $t('ads.anti_click_label.action_when_detect') }}</p>
                  <el-select value="" v-model="form_anti_click.detect_type" size="mini" class="full-w">
                    <el-option :value="1" :label="$t('base.pause_keyword')"></el-option>
                    <el-option :value="3" :label="$t('ads.general_label.edit_amount')"></el-option>
                  </el-select>

                  <template v-if="form_anti_click.detect_type === 3">
                    <p class="text-title" style="">{{ $t('ads.general_label.edit_amount') }}</p>
                    <el-input size="mini" type="number" v-model="form_anti_click.detect_value_3"></el-input>
                  </template>
                </div>

                <div class="text-right" style="margin-top: 30px; padding-right: 30px">
                  <el-button v-if="selected_keyword && selected_keyword.anti_click" size="small" type="danger"
                             icon="el-icon-delete" @click="m__delete_anti_click_single">{{ $t('base.delete_config') }}
                  </el-button>
                  <el-button size="small" type="primary" icon="el-icon-check" @click="m__confirm_anti_click_single"
                             :loading="loading.config_anti_click">{{ $t('base.save_configuration') }}
                  </el-button>
                </div>
              </div>
            </template>

            <template v-if="config_tab === 5">
              <ComponentAntiClickGuide></ComponentAntiClickGuide>
            </template>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.upload_image" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit_image') }}</strong>

        <div>
          <div style="width: 400px; height: 400px">
            <img :src="'https://cf.shopee.com/file/' + shop_ads_image_url_upload" alt="shop ads image"
                 style="width: 100%; height: 100%">
          </div>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__update_shop_ads_image">
            {{ $t('base.update') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.create_tag" :close-on-click-modal="false" width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.manage_tags') }}</strong>

        <div style="margin-top: 30px">
          <template v-for="tag in keyword_tag_list">
            <div
              style="background-color: #eef0f1; padding: 10px; margin-bottom: 10px; border-radius: 4px; display: flex; align-items: center">
              <div style="flex: auto; font-size: 14px; padding-right: 10px">
                <template v-if="tag.editable">
                  <el-input size="mini" v-model="tag.temp_name"></el-input>
                </template>
                <template v-else>
                  {{ tag.name }}
                </template>
              </div>
              <div style="width: 60px">
                <template v-if="tag.editable">
                  <a href="javascript:void(0)" @click="m__update_keyword_tag(tag)">
                    <i class="el-icon-check" style="font-size: 14px; color: #000"></i>
                  </a>
                  &nbsp;&nbsp;
                  <a href="javascript:void(0)" @click="m__toggle_update_keyword_tag(tag, false)">
                    <i class="el-icon-close" style="font-size: 14px; color: #000"></i>
                  </a>
                </template>
                <template v-else>
                  <a href="javascript:void(0)" @click="m__toggle_update_keyword_tag(tag, true)">
                    <i class="el-icon-edit" style="font-size: 14px; color: #000"></i>
                  </a>
                  &nbsp;&nbsp;
                  <a href="javascript:void(0)">
                    <i class="el-icon-delete" style="font-size: 14px; color: #000"
                       @click="m__delete_keyword_tag(tag)"></i>
                  </a>
                </template>
              </div>
            </div>
          </template>
        </div>

        <div style="margin-top: 30px; display: flex; gap: 10px">
          <div style="flex: auto">
            <el-input size="mini" :placeholder="$t('input.tag_name')" v-model="keyword_tag_name"></el-input>
          </div>
          <div style="flex: 1">
            <el-button type="primary" size="mini" icon="el-icon-plus" :loading="loading.create_tag"
                       @click="m__create_keyword_tag"> {{ $t('base.create_tags') }}
            </el-button>
          </div>
        </div>

        <div style="margin-top: 10px"></div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.add_tag_to_keywords" :close-on-click-modal="false" width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('select.tags') }}</strong>

        <div style="margin-top: 30px">
          <el-radio-group v-model="keyword_tag_id_selected" class="full-w">
            <template v-for="tag in keyword_tag_list">
              <div
                style="background-color: #eef0f1; padding: 10px; margin-bottom: 10px; border-radius: 4px; display: flex; align-items: center">
                <div style="flex: auto; font-size: 14px; padding-right: 10px">
                  <el-radio :label="tag._id">
                    {{ tag.name }}
                  </el-radio>
                </div>
              </div>
            </template>
          </el-radio-group>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.add_tag_to_keywords"
                     @click="m__add_tag_to_keywords">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_keyword_by_condition" :close-on-click-modal="false" width="900px">
      <div slot="title" style="padding:10px">
        <el-tabs v-model="condition_action_tab">
          <el-tab-pane :label="$t('base.update_keyword_by_conditions')" name="main">
            <div style="margin-top: 30px">
              <div v-for="(item, index) in condition_action_list" :key="`item-${index}`">
                <div style="background-color: #f7f7f7; padding: 10px; margin-bottom: 30px; position: relative">
                  <div style="display: flex; gap: 20px">
                    <div style="width: 100px">
                      <strong class="strong-label">&nbsp;</strong>
                      <div
                        style="display: flex; height: 29px; background-color: #faedbb; align-items: center; justify-content: center; font-size: 13px; font-weight: bold; border-top-right-radius: 10px; border-bottom-right-radius: 10px">
                        {{ $t('base.conditions') }}
                      </div>
                    </div>
                    <div>
                      <div style="display: flex; gap: 10px">
                        <div style="flex: 1">
                          <strong class="strong-label">{{ $t('base.column') }}</strong>
                        </div>
                        <div style="flex: 1">
                          <strong class="strong-label">{{ $t('base.expression') }}</strong>
                        </div>
                        <div style="flex: 1">
                          <strong class="strong-label">{{ $t('base.value') }}</strong>
                        </div>
                        <div style="flex: 1">
                          <strong class="strong-label">{{ $t('keyword.type') }}</strong>
                        </div>
                        <div style="width: 50px">
                          <strong class="strong-label">&nbsp;</strong>
                        </div>
                      </div>
                      <div v-for="(condition, index) of item.condition_list" :key="`item-${index}`"
                           style="display: flex; gap: 10px; margin-bottom: 10px">
                        <div style="flex: 1">
                          <el-select size="mini" class="full-w" value="" v-model="condition.label" filterable>
                            <el-option v-for="i in filter" :key="i.camel_key" :value="i.camel_key" :label="i.label">
                            </el-option>
                          </el-select>
                        </div>
                        <div style="flex: 1">
                          <el-select size="mini" class="full-w" value="" v-model="condition.expression" filterable>
                            <el-option label=">" value=">"></el-option>
                            <el-option label="<" value="<"></el-option>
                            <el-option label="=" value="==="></el-option>
                            <el-option label="≠" value="!=">
                              <span style="font-size: 16px !important;">≠</span>
                            </el-option>
                            <el-option label="> =" value=">="></el-option>
                            <el-option label="< =" value="<="></el-option>
                          </el-select>
                        </div>
                        <div style="flex: 1">
                          <el-input type="number" size="mini" v-model="condition.value"></el-input>
                        </div>
                        <div style="flex: 1">
                          <el-select size="mini" class="full-w" value="" v-model="condition.match_type">
                            <el-option value="all" :label="$t('base.all')"></el-option>
                            <el-option value="match_type_0" :label="$t('base.exact')"></el-option>
                            <el-option value="match_type_1" :label="$t('base.broad')"></el-option>
                          </el-select>
                        </div>
                        <div style="width: 50px">
                          <el-button type="danger" size="mini" icon="el-icon-delete"
                                     :disabled="item.condition_list.length <= 1"
                                     @click="m__remove_condition(item.condition_list, index)">
                          </el-button>
                        </div>
                      </div>
                      <div>
                        <el-button type="text" size="mini" @click="m__add_condition(item.condition_list)">
                          <span class="text-primary"><i class="el-icon-plus"></i> {{ $t('base.add_condition') }}</span>
                        </el-button>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; gap: 20px; margin-top: 20px">
                    <div style="width: 100px">
                      <div
                        style="display: flex; height: 29px; background-color: #e1e5fa; align-items: center; justify-content: center; font-size: 13px; font-weight: bold; border-top-right-radius: 10px; border-bottom-right-radius: 10px">
                        {{ $t('base.actions') }}
                      </div>
                    </div>
                    <div>
                      <div style="display: flex; gap: 10px">
                        <el-select style="flex: 1" size="mini" value="" v-model="item.action">
                          <el-option value="increase" :label="$t('base.increase_bid_price')"></el-option>
                          <el-option value="reduce" :label="$t('base.decrease_bid_price')"></el-option>
                          <el-option value="cpc" :label="$t('base.set_by_cpc')"></el-option>
                          <el-option value="match_type_0" :label="$t('base.change_to_exact')"></el-option>
                          <el-option value="match_type_1" :label="$t('base.change_to_broad')"></el-option>
                          <el-option value="ongoing" :label="$t('base.resume_keyword')"></el-option>
                          <el-option value="pause" :label="$t('base.pause_keyword')"></el-option>
                        </el-select>

                        <el-select v-if="['increase', 'reduce'].includes(item.action)" style="flex: 1" size="mini"
                                   value=""
                                   v-model="item.update_price_type">
                          <el-option value="value" :label="$t('base.by_amount')"></el-option>
                          <el-option value="percent" :label="$t('base.by_percent')"></el-option>
                        </el-select>

                        <el-input v-if="['increase', 'reduce'].includes(item.action)" style="flex: 1"
                                  size="mini" type="number" v-model="item.update_price_value"></el-input>

                        <el-date-picker
                          v-if="item.action === 'cpc'"
                          style="flex: 1" v-model="item.cpc_range" type="daterange" range-separator="-"
                          :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
                          format="dd-MM-yyyy"
                          :clearable="false" :picker-options="picker_options">
                        </el-date-picker>
                      </div>
                    </div>
                  </div>
                  <div style="margin-top: 20px">
                    <strong v-if="item.error_msg" class="text-danger" style="font-size: 13px">
                      {{ $t('base.error') }}: {{ item.error_msg }}
                    </strong>
                  </div>
                  <span
                    v-if="condition_action_list.length > 1"
                    style="position: absolute; top: 10px; right: 15px; cursor: pointer"
                    @click="m__remove_condition_action(index)">
                    <i class="el-icon-close" style="font-size: 16px"></i>
                  </span>
                </div>
              </div>
              <div>
                <el-button type="text" size="mini" @click="m__add_condition_action">
                  <span class="text-primary" style="font-size: 14px">
                    <i class="el-icon-plus"></i> {{ $t('base.add_conditions_actions') }}</span>
                </el-button>
              </div>
            </div>

            <div style="margin-top: 30px" class="text-right">
              <el-button size="mini" @click="m__show__action_select_file_dialog">
                {{ $t('base.use_file') }}
              </el-button>
              <el-button size="mini" icon="el-icon-document-checked" @click="m__show_condition_action_save_file_dialog">
                {{ $t('base.save_file') }}
              </el-button>
              <el-button type="primary" size="mini" icon="el-icon-check" @click="m__confirm_condition_action"
                         :loading="loading.update_keyword_by_condition">
                {{ $t('base.confirm') }}
              </el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('base.saved_files')" name="file">
            <div class="text-right">
              <el-input size="mini" style="width: 250px" prefix-icon="el-icon-search"
                        :placeholder="$t('input.placeholder')" v-model="condition_action_file_filter">
              </el-input>
            </div>

            <el-table :data="c__condition_action_file_filter_list" style="margin-top: 20px">
              <el-table-column :label="$t('base.filename')" prop="filename"></el-table-column>
              <el-table-column :label="$t('base.created_at')" prop="created_at">
                <template slot-scope="scope">
                  {{ scope.row.created_at | moment('DD/MM/YYYY') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.optional')" prop="created_at" width="200px">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="m__confirm_action_select_file(scope.row)">
                    <strong class="text-info">{{ $t('base.use') }}</strong>
                  </el-button>
                  <el-button type="text" size="mini" @click="m__delete_condition_action_file(scope.row)">
                    <strong class="text-danger">{{ $t('base.delete') }}</strong>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.action_condition_save_file" :close-on-click-modal="false"
               custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <div>
          <el-radio v-model="condition_action_radio" label="1">
            <strong>{{ $t('base.create_new_file') }}</strong>
          </el-radio>
          <el-input size="mini" :placeholder="$t('input.filename')" :disabled="condition_action_radio !== '1'"
                    v-model="condition_action_filename"></el-input>
        </div>
        <div style="margin-top: 30px">
          <el-radio v-model="condition_action_radio" label="2">
            <strong>{{ $t('base.update_existed_file') }}</strong>
          </el-radio>
          <el-select size="mini" class="full-w" value="" :disabled="condition_action_radio !== '2'"
                     v-model="condition_action_file_selected">
            <el-option v-for="file in condition_action_file_list" :key="file._id"
                       :value="file._id" :label="file.filename"></el-option>
          </el-select>
        </div>

        <div style="padding-top: 30px;" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.action_condition_save_file"
                     @click="m__confirm_action_save_file">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.action_condition_select_file" :close-on-click-modal="false"
               custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <div>
          <strong class="strong-label">{{ $t('select.file') }}</strong>
          <el-select size="mini" class="full-w" value="" v-model="condition_action_file_selected">
            <el-option v-for="file in condition_action_file_list" :key="file._id"
                       :value="file._id" :label="file.filename"></el-option>
          </el-select>
        </div>

        <div style="padding-top: 30px;" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.action_condition_save_file"
                     @click="m__confirm_action_select_file(null)">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.save_filter" :close-on-click-modal="false" custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.filter_name') }}</p>
        <el-input size="mini" :placeholder="$t('input.filter_name')" v-model="filter_name"></el-input>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.save_filter"
                     @click="m__save_filter">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.filter_list" :close-on-click-modal="false" width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.saved_filter_list') }}</strong>

        <div style="margin-top: 30px">
          <el-table :data="filter_list">
            <el-table-column label="Tên" prop="name"></el-table-column>
            <el-table-column :label="$t('base.optional')" width="150px">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__use_filter(scope.row)">
                  <strong class="text-primary">{{ $t('base.use') }}</strong>
                </el-button>
                <el-button type="text" size="mini" @click="m__delete_atosa_filter(scope.row)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <el-drawer
      :visible.sync="show_dialog.report_analysis"
      :with-header="false"
      :title="''"
      :size="'80%'"
      :show-close="true">
      <ComponentReportAnalysis :sp_user="sp_user" :shop="shop" :campaign_id="c__campaign_id"
                               :parent_flag_list="flag_list"
                               :parent_atosa_flag_list="atosa_flag_list"
                               :parent_filter="filter" :parent_keyword_list="keywords"
                               :filter="filter" :filter_list="filter_list"
                               :has_showed_report_analysis.sync="has_showed_report_analysis"
                               :report_type="'shop_manual__single_detail'"
                               :parent_show_dialog.sync="show_dialog.report_analysis"
                               :keyword_file_list="keyword_file_list" :campaign_type="'shop'"
                               :ads_config="ads_config"
                               @reload_data="m__load_campaign_detail">

      </ComponentReportAnalysis>
    </el-drawer>

    <el-dialog :visible.sync="show_dialog.operation_history" :close-on-click-modal="false" width="1200px">
      <div slot="title" style="padding:10px">
        <div slot="title" style="padding:10px">
          <strong class="strong-title">{{ $t('ads.operation_history') }}</strong>

          <div style="margin-top: 30px">
            <ComponentShopeeOperationHistory :campaign_id="c__campaign_id" :shop="shop" :sp_user="sp_user"
                                             :show_dialog="show_dialog.operation_history"></ComponentShopeeOperationHistory>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.keyword_metrics" :close-on-click-modal="false" width="1300px">
      <div slot="title" style="padding:10px">
        <ComponentKeywordMetrics :shop="shop" :campaign="parent_campaign" :keyword="selected_keyword"
                                 :keyword_metrics="show_dialog.keyword_metrics"></ComponentKeywordMetrics>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_pricing_type" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.shopee_advanced_settings') }}</strong>

        <div style="display: flex; align-items: center; gap: 10px">
          <el-switch v-model="pricing_type" :active-value="2" :inactive-value="1"></el-switch>
          <span>{{ $t('base.enhanced_bid_price') }}</span>
        </div>

        <div style="margin-top: 20px">
          {{ $t('base.shopee_advanced_settings_note') }}
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.update_pricing_type"
                     @click="m__confirm_update_pricing_type">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" type="file"
           @change="m__import_excel_file" id="input_control_detail" style="display: none;">

    <input accept="image/*" type="file" id="input_shop_ads_image" style="display: none;"
           @change="m__upload_shop_ads_image">
  </div>
</template>

<script>
import {drop as _drop, orderBy as _orderBy, take as _take, uniqBy as _uniqBy} from 'lodash'
import readXlsxFile from 'read-excel-file'
import ComponentMetric from '../component/component_metric.vue'
import {
  atosa_flag,
  default_report,
  keyword_shop_ads_detail_filter,
  picker_options,
  shop_ads_flag
} from '../../../addon/options'
import {
  auto_cir_fixed_list,
  group_campaign_advanced_list,
  keyword_tag_fixed_list,
  new_buttons_fixed_list
} from '../../../addon/fixed_list'
import {ADS_CONSTANTS, make_uuid,} from '../../../addon/ads_function'
import ComponentReportAnalysis from "../component/component_report_analysis.vue";
import ComponentShopAdsPositionGuide from '../component/component_shop_ads_position_guide.vue'
import ComponentAutoCirGuide from "../component/component_auto_cir_guide.vue";
import ComponentAntiClickGuide from "../component/component_anti_click_guide.vue";
import {fix_ads_mixins} from "../../../mixins/fix_ads";
import ComponentShopeeOperationHistory from "../component/component_shopee_operation_history.vue";
import {package_mixins} from "../../../mixins/package";
import ComponentKeywordMetrics from "../component/component_keyword_metrics.vue";
import ComponentKeywordMetricsByHour from "../component/component_keyword_metrics_by_hour.vue";
import ComponentCustomTimePicker from "../component/component_custom_time_picker.vue";
import {validate_mixins} from "../../../mixins/validate";
import ComponentMetricTableView from '../component/component_metric_table_view.vue';
import ComponentTableView from '../component/component_table_view.vue';

export default {
  name: 'page__shop-ads-marketing-online-detail',

  mixins: [fix_ads_mixins, package_mixins, validate_mixins],

  components: {
    ComponentTableView,
    ComponentMetricTableView,
    ComponentKeywordMetricsByHour,
    ComponentKeywordMetrics,
    ComponentShopeeOperationHistory,
    ComponentReportAnalysis,
    ComponentMetric,
    ComponentShopAdsPositionGuide,
    ComponentAutoCirGuide,
    ComponentAntiClickGuide,
    ComponentCustomTimePicker,
  },

  props: {
    shop: {},
    parent_campaign: {},
    sp_user: {},
    start_date: null,
    end_date: null,
    parent_is_compare_campaign: false,
    parent_compare_date_range: null,
    auto_condition_action_config_list: null,
    auto_condition_action_detail_config_list: null,
    is_advanced_ads: false,
    ads_config: {},
    fff: null
  },

  data() {
    return {
      sort_option: {
        order: null,
        prop: null
      },
      fff_sort_option: {
        order: null,
        prop: null
      },
      campaign: {
        advertisements: [],
        campaign: {},
        product: {}
      },
      added_keyword_filter: {
        page_size: 10,
        current_page: 0
      },
      mipee_suggest_keywords_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null
        },
      },
      search_keywords: '',
      search_keywords_type: '',
      keyword: '',
      add_keyword_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null
        },
      },
      add_keyword: [],
      keyword_filter: {
        pages: [10, 20, 30, 40, 50, 100],
        page_size: 20,
        current_page: 0,
        total_record: 0,
        selected_type: 'running'
      },
      radio: '1',
      keywords: [],
      selected_keyword: {
        price: null
      },
      selected_keywords: [],
      indeterminate: false,
      is_selected_all: false,
      loading: {
        update_keyword_price: false,
        add_keywords: false,
        confirm_add_keywords: false,
        update_multiple_keyword_price: false,
        update_multiple_keyword_match_type: false,
        remove_multiple_keyword: false,
        config_auto_campaign: false,
        auto_position: false,
        show_add_keyword: false,
        update_campaign_quota: false,
        update_campaign_date: false,
        update_multiple_keyword_status: false,
        update_data: false,
        update_shop_ads: false,
        config_auto_cir: false,
        config_anti_click: false,
        compare_keyword: false,
        openai: false,
        create_tag: false,
        add_tag_to_keywords: false,
        update_keyword_by_condition: false,
        action_condition_save_file: false,
        export_report: false,
        save_filter: false,
        filter_list: false,
        update_pricing_type: false
      },
      show_dialog: {
        update_keyword_price: false,
        add_keywords: false,
        update_multiple_keyword_price: false,
        update_multiple_keyword_match_type: false,
        remove_multiple_keyword: false,
        config_auto_campaign: false,
        update_campaign_quota: false,
        update_campaign_date: false,
        update_multiple_keyword_status: false,
        select_index: false,
        update_added_keyword_price: false,
        filter: false,
        compare_keyword: false,
        update_shop_ads: false,
        shop_ads_categories: false,
        config_auto_cir: false,
        config_anti_click: false,
        openai: false,
        upload_image: false,
        create_tag: false,
        add_tag_to_keywords: false,
        update_keyword_by_condition: false,
        action_condition_save_file: false,
        action_condition_select_file: false,
        save_filter: false,
        filter_list: false,
        report_analysis: false,
        operation_history: false,
        keyword_metrics: false,
        update_pricing_type: false
      },
      selected_keyword_file: '',
      keyword_file_list: [],
      shopee_suggest_keywords: [],
      mipee_suggest_keywords: [],
      added_keywords: [],
      added_keywords_type: 0,
      form_update_multiple_keyword_price: {
        type: 'cpc',
        update_type: 1,
        update_by_cost: 'increase',
        update_by_percent: 'increase',
        update_by_suggest_cost: 'increase',
        update_by_suggest_percent: 'increase',
        update_by_cost_value: 0,
        update_by_cost_value_min: null,
        update_by_cost_value_max: null,
        update_by_percent_value: 0,
        update_by_percent_value_min: null,
        update_by_percent_value_max: null,
        update_by_suggest_cost_value: 1,
        update_by_suggest_cost_value_min: null,
        update_by_suggest_cost_value_max: null,
        update_by_suggest_percent_value: 1,
        update_by_suggest_percent_value_min: null,
        update_by_suggest_percent_value_max: null,
        cost_value: 0,
        match_type: 1,
        status: 1,
        default_cpc: null
      },
      form_config_auto_position: {
        keywords: [],
        times: [],
        type: 'search',
        fromValue: null,
        toValue: null,
        upValue: null,
        downValue: null,
        minValue: null,
        maxValue: null,
        minPrice: null,
        maxPrice: null,
        start_time: '',
        end_time: '',
        stop_action: 0,
        stop_action_2: null,
        stop_action_3: null,

        advanced: false,
        advanced_start_time: '',
        advanced_end_time: '',
        advanced_times: [
          {
            advanced_start_time: '00:00',
            advanced_end_time: '02:00'
          },
          {
            advanced_start_time: '06:00',
            advanced_end_time: '24:00'
          }
        ],
        advanced_days: [],
        advanced_day: '',
        advanced_day_number: null,
        advanced_max_value: null,
        advanced_max_price: null,
        advanced_start_price: null,

        device: 'web',
        reduce_if: null
      },
      form_config_auto_campaign: {
        type: 'suggest',
        time: 'week',
        keywords: [],
        times: [],
        start_time: '',
        end_time: '',
        quota_type: 5,
        reduce_value: 1,
        increase_value: 1,
        not_exceed_2: false,
        not_exceed_2_value: 0,
        not_exceed_3: false,
        not_exceed_3_value: 0,
        not_exceed_4: false,
        not_exceed_4_value: 0,
        not_exceed_5: false,
        not_exceed_5_value: 0,
        not_exceed_6: false,
        not_exceed_6_value: 0,
        stop_action: 0,
        stop_action_2: null,
        stop_action_3: null
      },
      config_tab: 2,
      base_keyword: '',
      fff_loading: false,
      fff_profile: {},
      fff_show: true,
      fff_result: [],
      fff_clone: [],
      fetch_loading: false,
      fetch_keyword: '',
      select_multiple: false,
      save_keyword_file: {
        show: false,
        loading: false,
        filename: 'Tệp keyword'
      },
      invalid_keywords: [],
      excel_keyword_filter: {
        page_size: 10,
        current_page: 0
      },
      excel_keyword: [],
      selected_time_type: '',
      campaign_time: {
        start_time: null,
        end_time: null
      },
      selected_quota_type: '',
      campaign_quota: {
        quota: null,
        type: 'daily'
      },
      flag_list: this.clone(shop_ads_flag),
      form_update_multiple_added_keyword_price: {
        update_type: 3,
        update_by_cost: 'increase',
        update_by_percent: 'increase',
        update_by_suggest_cost: 'increase',
        update_by_suggest_percent: 'increase',
        update_by_cost_value: 0,
        update_by_percent_value: 0,
        update_by_suggest_cost_value: 1,
        update_by_suggest_percent_value: 1,
        cost_value: 0,
        match_type: 1,
        price: 0
      },
      is_save_added_keywords: false,
      MATCH_TYPE_0_MIN: null, // TODO: exact
      MATCH_TYPE_1_MIN: null, // TODO: broad
      DAILY_BUDGET_MIN: null,
      interval: null,
      metrics: {},
      reports: [],
      save_and_result_list: [],
      default_report: default_report,
      placement20: {
        auto: true,
        keyword: 'auto',
        report: null,
        c_report: null
      },
      is_fixed: false,

      filter_flag: true,
      filter_clone: null,
      filter: JSON.parse(JSON.stringify(keyword_shop_ads_detail_filter)),

      is_compare_keyword: false,
      compare_date_range: [new Date().getTime() - 3600 * 1000 * 24 * 6, new Date().getTime() - 3600 * 1000 * 24],
      compare_metrics: {},
      compare_reports: [],

      picker_options: picker_options,
      compare_data: [],
      compare_auto: null,
      is_destroyed: false,
      omit_duplicated_keyword: false,

      shop_ads: {
        collection_name: '',
        category_list: [],
        tagline: '',
        type: 0,
        collection_id: '',
        radio: null,
        image_url: ''
      },

      auto_cir_fixed_list: auto_cir_fixed_list,

      form_config_auto_cir: {
        keywords: [],
        fromCir: 15,
        toCir: 15,
        cirType: 'broad',
        timeType: 'today',
        allowBidPrice: true,
        price: null,
        maxPrice: null,
        allowAtCase1: true,
        case1Type: 'value',
        case1Value: 600,
        case1Reduce: 80,
        case1ReduceMin: null,
        case1Percent: null,
        allowAtCase2: true,
        case2Type: 'stop',
        case2Value: 600,
        case2Reduce: 80,
        case2ReduceMin: null,
        case2Percent: null,
        case2Min: 20000,
        deleteAntiClick: false,
        configStatus: 1,

        advanced_times: [
          // {advanced_start_time: '00:00', advanced_end_time: '02:00'},
          // {advanced_start_time: '06:00', advanced_end_time: '24:00'}
        ],
        advanced_days: [],
        advanced_day: '',
        advanced_day_number: null,
        advanced_max_value: null,
        advanced_cir: null,
        advanced_cir_type: 'broad',
        advanced_cir_type2: '',
        advanced_price: null,
        advanced_price_type: '',
        advanced_max_price: null,
        advanced_start_price: null,
        advanced_max_cost: null,
        advanced_max_cost_type: 'value',
        advanced_max_cost_value: 600
      },

      form_anti_click: {
        keywords: [],
        shop_id: '',
        product_id: '',
        click_number: null,
        order_amount: null,
        ratio: null,
        click_minimum_number: null,
        click_maximum_number: null,
        detect_type: 1,
        detect_value_2: null,
        detect_value_3: null,
        detect_value_4: null,
        type: '2',
        cir: null,
        time_type: 'today',
        start_time: null,
        end_time: null,
        min_cost: null,
        max_cost: null,
        not_order: false,
        not_order_cost: null,
        is_direct_cir: 0
      },

      selected_restricted_keywords: '',
      restricted_keywords_list: [],
      restricted_keyword_fixed_list: [
        'vuducminhdev07',
        '0934824608',
        'nghiemchihuy@gmail.com'
      ],

      messages_log: [],
      openai_messages: [],
      openai_message: '',
      show_openai_message: false,
      openai_compare: [new Date().getTime() - 3600 * 1000 * 24 * 6, new Date().getTime() - 3600 * 1000 * 24],
      show_openai_compare: false,

      shop_ads_image_url: 'sg-11134201-7rbk0-louxtq64h8mw49',
      shop_ads_image_url_upload: '',

      keyword_tag_id_selected: null,
      keyword_tag_name: '',
      keyword_tag_list: [],
      keyword_tag_match: [],
      tag_ids_selected: [],

      keyword_tag_fixed_list,

      condition_template: {
        label: '',
        expression: '',
        value: '',
        match_type: 'all'
      },
      condition_action_template: {
        condition_list: [],
        action: '',
        update_price_type: 'value',
        update_price_value: '',
        default_cpc: '',
        error_msg: '',
        success_msg: '',
        cpc_range: null
      },
      condition_action_list: [],
      condition_action_tab: 'main',
      condition_action_file_list: [],
      condition_action_radio: '1',
      condition_action_filename: '',
      condition_action_file_selected: null,
      condition_action_file_filter: '',

      selected_keyword_type: 'all',

      group_campaign_advanced_list,

      atosa_flag_list: atosa_flag,

      filter_name: '',
      filter_list: [],

      save_keyword_file_type: 'add',
      save_keyword_type: 'selected',

      has_showed_report_analysis: false,

      pricing_type: 1,

      auto_condition_action_detail_config_list_map: new Map(),

      new_buttons_fixed_list: new_buttons_fixed_list,
    }
  },

  async beforeMount() {
    await Promise.all([
      this.m__load_campaign_detail(),
      this.m__get_flag_list(),
      this.m__get_keyword_file(),
      this.m__get_shop_ads_category(),
      this.m__get_restricted_keywords(),
      this.m__get_keyword_tag(),
      this.m__get_condition_action_list(),
      this.m__get_filter()
    ])

    if (this.parent_is_compare_campaign && this.parent_compare_date_range) {
      if (this.parent_compare_date_range[0] && this.parent_compare_date_range[1]) {
        this.compare_date_range = [new Date(this.parent_compare_date_range[0]), new Date(this.parent_compare_date_range[1])]
      }
      await this.m__confirm_compare_keyword()
    }

    await this.m__get_keyword_tag_match()

    this.m__update_auto_condition_action_detail_config_list_map()
  },

  mounted() {
    this.$nextTick(() => {
      const dashboard_wrapper = document.getElementById('dashboard-wrapper')
      const main_pagination = document.getElementById('detail-main-pagination')

      const main_table = document.querySelector('div#main-table-detail')
      const main_table_fixed = document.querySelector('div#main-table-detail-fixed-header')
      const main_table_wrapper = document.querySelector('div#main-table-detail div.el-table__body-wrapper')
      const main_table_wrapper_fixed = document.querySelector('div#main-table-detail-fixed-header div.el-table__header-wrapper')
      const scrollbar = document.getElementById('detail-double-scroll-bar')

      const scrollbar_wrapper = document.getElementById('detail-double-scroll-wrapper')
      scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'
      main_table_fixed.style.width = main_table.scrollWidth + 'px'

      scrollbar.appendChild(document.createElement('div'))
      scrollbar.style.overflow = 'auto'
      scrollbar.style.overflowY = 'hidden'
      scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
      this.interval = setInterval(() => {
        scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'
        main_table_fixed.style.width = main_table.scrollWidth + 'px'
        scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
      }, 1000)
      scrollbar.firstChild.style.paddingTop = '1px'
      scrollbar.firstChild.appendChild(document.createTextNode('\xA0'))
      scrollbar.onscroll = () => {
        main_table_wrapper.scrollLeft = scrollbar.scrollLeft
        main_table_wrapper_fixed.scrollLeft = main_table_wrapper.scrollLeft
      }
      main_table_wrapper.onscroll = () => {
        scrollbar.scrollLeft = main_table_wrapper.scrollLeft
        main_table_wrapper_fixed.scrollLeft = main_table_wrapper.scrollLeft
      }

      dashboard_wrapper.onscroll = () => {
        const rect = main_pagination.getBoundingClientRect()
        const elem_top = rect.top
        const is_visible = elem_top <= window.innerHeight
        if (is_visible) {
          scrollbar_wrapper.style.zIndex = '-1'
        } else {
          scrollbar_wrapper.style.zIndex = '2000'
        }

        const rect2 = main_table_wrapper.getBoundingClientRect()
        const elem_top2 = rect2.top
        const elem_bot2 = rect2.bottom
        if (elem_top2 > 0 || elem_bot2 <= 100) {
          main_table_fixed.style.zIndex = '-1'
        } else {
          main_table_fixed.style.zIndex = '2000'
        }
      }
    })
  },

  beforeDestroy() {
    this.is_destroyed = true
    clearInterval(this.interval)
    const dashboard_wrapper = document.getElementById('dashboard-wrapper')
    dashboard_wrapper.onscroll = () => {
    }
  },

  watch: {
    'start_date': function () {
      this.m__load_report()
    },

    'loading.update_data': function () {
      if (this.loading.update_data === false) {
        for (const keyword of this.keywords) {
          keyword.report.price = keyword.price
        }
      }
    },

    'ads_config': function () {
      // todo: set ads config
      if (this.ads_config && this.ads_config.bid_price) {
        this.MATCH_TYPE_0_MIN = this.m__calculate(this.ads_config.bid_price.search_shop.exact_match.min / 100000)
        this.MATCH_TYPE_1_MIN = this.m__calculate(this.ads_config.bid_price.search_shop.broad_match.min / 100000)
        this.TARGETING_MIN = this.m__calculate(this.ads_config.bid_price.targeting.min / 100000)
        this.DAILY_BUDGET_MIN = this.m__calculate(this.ads_config.ads_config.product_ads.manual.search_product.min_daily_budget / 100000)
        this.form_update_multiple_keyword_price.default_cpc = this.MATCH_TYPE_0_MIN
      }
    }
  },

  computed: {
    c__has_advanced_ads() {
      return this.$store.state.advanced_ads_list.some(i => this.$store.state.userInfo.username.includes(i))
    },

    c__campaign_id() {
      return this.campaign && this.campaign.campaign ? this.campaign.campaign.campaignid : null
    },

    c__campaign_type() {
      return this.parent_campaign && this.parent_campaign.campaign ? this.parent_campaign.campaign.shopee_type : 'shop'
    },

    c__campaign_bidding_type() {
      return this.parent_campaign && this.parent_campaign.campaign ? this.parent_campaign.campaign.bidding_type : 'manual'
    },

    c__filter_show_list() {
      if (this.filter_flag) {
        const result = []

        for (const item of this.filter) {
          const flag_found = this.flag_list.find(i => i.value === item.camel_key)
          if (flag_found && flag_found.checked) {
            result.push(item)
          }
        }

        return result
      } else {
        return this.filter
      }
    },

    c__show_keyword_filter_list() {
      let result = this.keywords

      if (this.keyword_filter.selected_type) {
        if (this.keyword_filter.selected_type === 'running') {
          result = result.filter(i => i.status === 1)
        }
        if (this.keyword_filter.selected_type === 'paused') {
          result = result.filter(i => i.status === 0)
        }
        if (this.keyword_filter.selected_type === 'match_type_0') {
          result = result.filter(i => i.match_type === 0)
        }
        if (this.keyword_filter.selected_type === 'match_type_1') {
          result = result.filter(i => i.match_type === 1)
        }
        if (this.keyword_filter.selected_type === 'auto') {
          result = result.filter(i => i.config_auto)
        }
        if (this.keyword_filter.selected_type === 'auto_position') {
          result = result.filter(i => i.auto_position)
        }
        if (this.keyword_filter.selected_type === 'not_auto') {
          result = result.filter(i => !i.config_auto && !i.auto_position)
        }
        if (this.keyword_filter.selected_type === 'anti_click') {
          result = result.filter(i => i.anti_click)
        }
        if (this.keyword_filter.selected_type === 'not_anti_click') {
          result = result.filter(i => !i.anti_click)
        }

        if (this.keyword_filter.selected_type === 'lowest') {
          const min_cost = 20000
          result = result.filter(i => i.report && ((i.report.impression && !i.report.broad_gmv) || (i.report.cost > min_cost && !i.report.broad_cir) || i.report.broad_cir > 0.2))
        }
        if (this.keyword_filter.selected_type === 'low') {
          result = result.filter(i => i.report && (i.report.broad_cir > 0.15 && i.report.broad_cir <= 0.2))
        }
        if (this.keyword_filter.selected_type === 'medium') {
          result = result.filter(i => i.report && (i.report.broad_cir > 0.08 && i.report.broad_cir <= 0.15))
        }
        if (this.keyword_filter.selected_type === 'high') {
          result = result.filter(i => i.report && (i.report.broad_cir > 0 && i.report.broad_cir <= 0.08))
        }
      }

      if (this.selected_keyword_type === 'exact') {
        result = result.filter(i => i.match_type === 0)
      }
      if (this.selected_keyword_type === 'broad') {
        result = result.filter(i => i.match_type === 1)
      }

      // if (this.filter_clone) {
      //   for (const item of this.filter_clone) {
      //     if (item.value) {
      //       item.is_percent === true
      //         ? result = result.filter(i => i.report && eval(`${i.report[item.camel_key] * 100}${item.expression}${item.value}`))
      //         : result = result.filter(i => i.report && eval(`${i.report[item.camel_key]}${item.expression}${item.value}`))
      //     }
      //   }
      // }
      if (this.filter_clone) {
        for (const item of this.filter_clone) {
          if (item.value || (item.expression === '< <' && item.value && item.value2)) {
            result = result.filter(i => {
              const value = item.is_percent === true
                ? i.report[item.camel_key] * 100
                : i.report[item.camel_key]

              return item.expression === '< <'
                ? i.report && eval(`${item.value2} < ${value} && ${value} < ${item.value}`)
                : i.report && eval(`${value}${item.expression}${item.value}`)
            })
          }
        }
      }

      if (this.tag_ids_selected.length) {
        if (this.tag_ids_selected.includes('added')) {
          result = result.filter(i => this.m__check_keyword_has_tag(i))
        } else if (this.tag_ids_selected.includes('not_added')) {
          result = result.filter(i => !this.m__check_keyword_has_tag(i))
        } else {
          result = this.tag_ids_selected.reduce((r, i) => {
            r.push(...result.filter(k => this.m__check_keyword_match(k, i)))
            return r
          }, [])
        }
      }

      if (this.sort_option.order) {
        this.sort_option.order === 'ascending' && (result = _orderBy(result, [this.sort_option.prop], ['asc']))
        this.sort_option.order === 'descending' && (result = _orderBy(result, [this.sort_option.prop], ['desc']))
      }

      const words = this.remove_unicode(this.search_keywords)
      return !this.search_keywords_type
        ? result.filter(i => this.remove_unicode(i.keyword).includes(words))
        : words ? result.filter(i => this.remove_unicode(i.keyword) === words) : result
    },

    c__show_keyword_display_list() {
      const limit = this.keyword_filter.page_size
      const skip = limit * (this.keyword_filter.current_page - 1)

      if (this.campaign && this.campaign.advertisements && this.campaign.advertisements.some(i => i.placement === 20)) {
        return [this.placement20]
      } else {
        if (!this.c__show_keyword_filter_list.length) {
          return []
        }

        try {
          const summary = {
            keyword: '',
            summary: true,
            report: this.clone(this.default_report),
            c_report: this.clone(this.default_report)
          }

          for (const item of this.c__show_keyword_filter_list) {
            for (const key of Object.keys(this.default_report)) {
              summary.report[key] += (item.report && item.report[key] ? +item.report[key] : 0)
              summary.c_report[key] += (item.c_report && item.c_report[key] ? +item.c_report[key] : 0)
            }
          }

          for (const key of ['report', 'c_report']) {
            if (summary[key].atosa_cpc) {
              summary[key].atosa_cpc = summary[key].click
                ? this.m__calculate(summary[key].cost / summary[key].click)
                : 0
            }
            if (summary[key].cpm) {
              summary[key].cpm = summary[key].impression
                ? this.m__calculate(summary[key].cost / summary[key].impression * 1000)
                : 0
            }
            if (summary[key].aov) {
              summary[key].aov = summary[key].broad_order
                ? this.m__calculate(summary[key].broad_gmv / summary[key].broad_order)
                : 0
            }
            if (summary[key].ctr) {
              summary[key].ctr = summary[key].impression
                ? summary[key].click / summary[key].impression
                : 0
            }
            if (summary[key].broad_cir) {
              summary[key].broad_cir = summary[key].broad_gmv
                ? summary[key].cost / summary[key].broad_gmv
                : 0
            }
            if (summary[key].direct_cir) {
              summary[key].direct_cir = summary[key].direct_gmv
                ? summary[key].cost / summary[key].direct_gmv
                : 0
            }
            if (summary[key].broad_roi) {
              summary[key].broad_roi = summary[key].cost
                ? summary[key].broad_gmv / summary[key].cost
                : 0
            }
            if (summary[key].direct_roi) {
              summary[key].direct_roi = summary[key].cost
                ? summary[key].direct_gmv / summary[key].cost
                : 0
            }
            if (summary[key].cr) {
              summary[key].cr = summary[key].click
                ? summary[key].broad_order / summary[key].click
                : 0
            }
            if (summary[key].direct_cr) {
              summary[key].direct_cr = summary[key].click
                ? summary[key].direct_order / summary[key].click
                : 0
            }
            if (summary[key].cpc) {
              summary[key].cpc = summary[key].broad_order
                ? summary[key].cost / summary[key].broad_order
                : 0
            }
            if (summary[key].cpdc) {
              summary[key].cpdc = summary[key].broad_order
                ? summary[key].cost / summary[key].direct_order
                : 0
            }
            if (summary[key].cpm) {
              summary[key].cpm = summary[key].impression
                ? this.m__calculate(summary[key].cost / summary[key].impression * 1000)
                : 0
            }
            if (summary[key].cpa) {
              const impression = summary[key].impression ? summary[key].impression : 0
              const ctr = summary[key].ctr ? summary[key].ctr : 0
              const cr = summary[key].cr ? summary[key].cr : 0
              const action = impression * ctr * cr
              summary[key].cpa = action ? this.m__calculate(summary[key].cost / action) : 0
            }
          }

          return [summary, ..._take(_drop(this.c__show_keyword_filter_list, skip), limit)]
        } catch (e) {
          console.error(e)
          return _take(_drop(this.c__show_keyword_filter_list, skip), limit)
        }
      }
    },

    c__add_keyword_display_list() {
      let result = this.add_keyword

      if (this.add_keyword_filter.sort_option.order) {
        this.add_keyword_filter.sort_option.order === 'ascending' && (result = _orderBy(result, [this.add_keyword_filter.sort_option.prop], ['asc']))
        this.add_keyword_filter.sort_option.order === 'descending' && (result = _orderBy(result, [this.add_keyword_filter.sort_option.prop], ['desc']))
      }

      const limit = this.add_keyword_filter.page_size
      const skip = limit * (this.add_keyword_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__fff_result_display_list() {
      const limit = this.add_keyword_filter.page_size
      const skip = limit * (this.add_keyword_filter.current_page - 1)

      let result = this.fff_result

      // for (const item of result) {
      //   item.keyword = item.keyword.normalize()
      // }
      // result = _uniqBy(result, 'keyword')

      if (this.fff_sort_option.order) {
        this.fff_sort_option.order === 'ascending' && (result = _orderBy(result, [this.fff_sort_option.prop], ['asc']))
        this.fff_sort_option.order === 'descending' && (result = _orderBy(result, [this.fff_sort_option.prop], ['desc']))
      }

      return _take(_drop(result, skip), limit)
    },

    c__added_keyword_display_list() {
      const limit = this.added_keyword_filter.page_size
      const skip = limit * (this.added_keyword_filter.current_page - 1)

      return _take(_drop(this.added_keywords, skip), limit)
    },

    c__excel_keyword_display_list() {
      const limit = this.excel_keyword_filter.page_size
      const skip = limit * (this.excel_keyword_filter.current_page - 1)

      return _take(_drop(this.excel_keyword, skip), limit)
    },

    c__mipee_suggest_keywords_display() {
      let result = this.mipee_suggest_keywords

      if (this.mipee_suggest_keywords_filter.sort_option.order) {
        this.mipee_suggest_keywords_filter.sort_option.order === 'ascending' && (result = _orderBy(result, [this.mipee_suggest_keywords_filter.sort_option.prop], ['asc']))
        this.mipee_suggest_keywords_filter.sort_option.order === 'descending' && (result = _orderBy(result, [this.mipee_suggest_keywords_filter.sort_option.prop], ['desc']))
      }

      const limit = this.mipee_suggest_keywords_filter.page_size
      const skip = limit * (this.mipee_suggest_keywords_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__condition_action_file_filter_list() {
      const keyword = this.remove_unicode(this.condition_action_file_filter)
      return this.condition_action_file_list.filter(i => this.remove_unicode(i.filename.normalize()).includes(this.remove_unicode(keyword)))
    },

    c__reports() {
      if (!this.reports || !this.reports.map) return []

      const total_broad_gmv = this.reports.reduce((acc, cur) => acc + cur.broad_gmv, 0)
      const total_cost = this.reports.reduce((acc, cur) => acc + cur.cost, 0)

      return this.reports.map(i => {
        for (const key of Object.keys(i)) {
          i[key] = Number(i[key])
        }

        i.ctr = i.impression ? +(i.click / i.impression) : 0
        i.broad_cir = +i.broad_gmv ? +(+i.cost / +i.broad_gmv) : 0
        i.broad_roi = +i.cost ? +(+i.broad_gmv / +i.cost).toFixed(1) : 0
        i.atosa_cpc = +i.click ? this.m__calculate(+i.cost / +i.click) : 0
        i.broad_gmv_percent = +i.broad_gmv ? +(+i.broad_gmv / +total_broad_gmv * 100).toFixed(1) : 0
        i.cost_percent = +i.cost ? +(+i.cost / +total_cost * 100).toFixed(1) : 0

        return i
      })
    },

    c__compare_reports() {
      if (!this.compare_reports || !this.compare_reports.map) return []

      const total_broad_gmv = this.compare_reports.reduce((acc, cur) => acc + cur.broad_gmv, 0)
      const total_cost = this.compare_reports.reduce((acc, cur) => acc + cur.cost, 0)

      return this.compare_reports.map(i => {
        for (const key of Object.keys(i)) {
          i[key] = Number(i[key])
        }

        i.ctr = i.impression ? +(i.click / i.impression) : 0
        i.broad_cir = +i.broad_gmv ? +(+i.cost / +i.broad_gmv) : 0
        i.broad_roi = +i.cost ? +(+i.broad_gmv / +i.cost).toFixed(1) : 0
        i.atosa_cpc = +i.click ? this.m__calculate(+i.cost / +i.click) : 0
        i.broad_gmv_percent = +i.broad_gmv ? +(+i.broad_gmv / +total_broad_gmv * 100).toFixed(1) : 0
        i.cost_percent = +i.cost ? +(+i.cost / +total_cost * 100).toFixed(1) : 0

        return i
      })
    }
  },

  methods: {
    m__update_auto_condition_action_detail_config_list_map() {
      if (this.auto_condition_action_detail_config_list && this.auto_condition_action_detail_config_list.length) {
        this.auto_condition_action_detail_config_list_map = new Map()
        for (const item of this.auto_condition_action_detail_config_list) {
          if (!item.config_list) continue
          const config_list = typeof item.config_list === 'string' ? JSON.parse(item.config_list) : item.config_list
          const has_enable_item = config_list.some(i => i.config_list.some(j => j.enable))
          this.auto_condition_action_detail_config_list_map.set(`${item.campaign_detail_id}-${item.keyword}`, {has_enable_item})
        }
      }
    },

    m__get_pricing_type() {
      return this.campaign && this.campaign.advertisements && this.campaign.advertisements.some(i => [3].includes(i.placement)) &&
        this.campaign.advertisements[0].extinfo.pricing_type
    },

    m__show_update_pricing_type() {
      this.pricing_type = this.campaign.advertisements[0].extinfo.pricing_type
      this.show_dialog.update_pricing_type = true
    },

    async m__confirm_update_pricing_type() {
      this.loading.update_pricing_type = true

      await this.sp_user.marketing_pas_update_campaign({
        campaign_id: this.c__campaign_id,
        change_ecpc: {
          ecpc: this.pricing_type === 2
        },
        type: 'change_ecpc',
        header: {}
      }, 'shop')

      for (const ads of this.campaign.advertisements) {
        ads.extinfo.pricing_type = this.pricing_type
      }

      this.show_dialog.update_pricing_type = false
      this.loading.update_pricing_type = false
    },

    async m__show_keyword_metrics_dialog(keyword) {
      this.selected_keyword = keyword
      this.show_dialog.keyword_metrics = true
    },

    m__show_cir_advanced_dialog() {
      this.show_dialog.auto_cir_advanced = true
    },

    m__show_report_analysis_dialog() {
      this.show_dialog.report_analysis = true
    },

    m__style_for_summary({row}) {
      if (row.summary) return {'background-color': '#F5F7FA'}
    },

    async m__delete_atosa_filter(data) {
      try {
        await this.$confirm(this.$t('base.delete_filter_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/filter/delete', {
        filter_id: data._id
      }, this.cf())
      await this.m__get_filter()

      this.ntf_s(this.$t('base.delete_success'))
    },

    m__use_filter(data) {
      for (const item of data.data) {
        const found = this.filter.find(i => i.camel_key === item.camel_key)
        if (found) {
          found.expression = item.expression
          found.value = item.value
          found.value2 = item.value2
        }
      }
      this.show_dialog.filter_list = false
    },

    async m__get_filter() {
      const response = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/filter/get', this.cf())
      this.filter_list = response.body.data
    },

    async m__save_filter() {
      if (!this.filter_name) return

      this.loading.save_filter = true
      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/filter/create', {
        name: this.filter_name,
        data: this.filter
      }, this.cf())
      await this.m__get_filter()

      this.loading.save_filter = false
      this.show_dialog.save_filter = false
      this.ntf_s(this.$t('base.save_success'))
    },

    m__is_show_atosa_index(value) {
      const flag = this.atosa_flag_list.find(i => i.value === value)
      return flag ? flag.checked : false
    },

    async m__set_atosa_flag_list() {
      const flags = this.atosa_flag_list.filter(i => i.checked).map(i => i.value)
      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_flags/set', {
        shop_id: this.shop._id,
        flags
      }, this.cf())
    },

    async m__get_atosa_flag_list() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_flags/get', {shop_id: this.shop._id}, this.cf())

      if (response.body.data && response.body.data.flags && response.body.data.flags.length) {
        for (const flag of response.body.data.flags) {
          const flag_found = this.atosa_flag_list.find(i => i.value === flag)
          if (flag_found) flag_found.checked = true
        }
      }
    },

    m__show_keyword_auto_condition_action_dialog(keyword) {
      this.EB.$emit('open_auto_condition_action_dialog', {
        campaign_detail_id: this.c__campaign_id,
        keyword_list: [keyword]
      })
    },

    m__is_auto_condition_action(keyword) {
      return this.auto_condition_action_detail_config_list_map.has(`${this.c__campaign_id}-${keyword}`)
    },

    m__is_auto_condition_action_running(keyword) {
      return this.auto_condition_action_detail_config_list_map.has(`${this.c__campaign_id}-${keyword}`)
        && this.auto_condition_action_detail_config_list_map.get(`${this.c__campaign_id}-${keyword}`).has_enable_item
    },

    check_config_status(data) {
      return data.configStatus !== 0
    },

    async m__handle_bulk_configuration(command) {
      if (command === 'auto') await this.m__show_config_auto_campaign_multiple();
      if (command === 'anti') await this.m__show_config_anti_click_multiple();
      if (command === 'cir') await this.m__show_multiple_config_auto_cir()

      if (command === 'condition_action') this.EB.$emit('open_auto_condition_action_dialog', {
        campaign_detail_id: this.c__campaign_id,
        keyword_list: this.c__show_keyword_filter_list.filter(i => i.checked).map(i => i.keyword)
      })
    },

    async m__handle_on_off_remove_bulk_configuration(command) {
      if (command === 'auto') await this.m__delete_multiple_config_auto_campaign();
      if (command === 'anti') await this.m__delete_multiple_config_anti_click();
      if (command === 'cir') await this.m__delete_multiple_auto_cir();
      // if (command === 'advanced') await this.m__confirm_delete_multiple_advanced();
      if (command === 'cir_advanced') await this.m__confirm_delete_multiple_cir_advanced();
      if (command === 'auto_condition_action') await this.m__delete_auto_condition_action();

      if (command === 'start_anti_click') await this.m__update_config_status('anti_click', 1)
      if (command === 'stop_anti_click') await this.m__update_config_status('anti_click', 0)

      if (command === 'start_auto') {
        this.m__update_config_status('auto', 1)
          .then((r) => {
            if (r) this.m__update_config_status('auto_cir', 0, false)
          })
      }

      if (command === 'stop_auto') await this.m__update_config_status('auto', 0)

      if (command === 'start_auto_cir') {
        this.m__update_config_status('auto_cir', 1)
          .then((r) => {
            if (r) this.m__update_config_status('auto', 0, false)
          })
      }

      if (command === 'stop_auto_cir') await this.m__update_config_status('auto_cir', 0)

      if (command === 'start_condition_action') await this.m__update_config_status('condition_action', 1)
      if (command === 'stop_condition_action') await this.m__update_config_status('condition_action', 0)
    },

    async m__delete_auto_condition_action() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
      } catch (e) {
        return
      }

      const form = {
        item_ids: [],
        campaign_ids: [],
        campaign_detail_id: this.c__campaign_id,
        keyword_list: this.c__show_keyword_filter_list.filter(i => i.checked).map(i => i.keyword),
        shop_id: this.shop._id.toString()
      }

      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/delete', form, this.cf())
      await this.$emit('reload_auto_condition_action')
      this.ntf_s(this.$t('base.update_success'))
      this.show_dialog.auto_by_condition_list = false
    },

    async m__confirm_delete_multiple_cir_advanced() {
      try {
        this.loading.update_multiple_max_price = true

        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        const campaign = this.campaign

        const auto_cir_response = await this.$http.get(this.API.URL_API_SRV_1 + '/auto_cir', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: campaign.campaign.campaignid
          }
        })

        if (auto_cir_response.body && auto_cir_response.body.length) {
          for (const item of auto_cir_response.body) {
            const keyword_found = this.c__show_keyword_filter_list.filter(i => i.checked).find(i => i.keyword === item.keyword)
            if (!keyword_found) {
              continue
            }

            await this.$http.post(this.API.URL_API_SRV_1 + '/auto_cir', {
              ...item,
              keywords: [item.keyword],
              advancedDays: [],
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: this.c__campaign_id,
              shopId: this.shop._id
            }, this.cf())

            if (keyword_found.auto_cir) {
              keyword_found.auto_cir.advanced_days = []
              keyword_found.auto_cir.advancedDays = []
            }
          }
        }

        // await this.m__load_campaign_detail()
        this.ntf_s(this.$t('base.delete_config_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    async m__update_config_status(type, status, confirm = true, only_keyword = null) {
      try {
        if (confirm) {
          await this.$confirm(this.$t('base.update_config_status_confirm'), this.$t('base.attention'), {
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
            type: 'warning'
          })
        }
      } catch (e) {
        return null
      }

      try {
        if (type === 'auto') {
          let auto_position_ids = []
          for (const keyword of this.c__show_keyword_filter_list) {
            if (keyword.checked && keyword.auto_position) {
              auto_position_ids.push(keyword.auto_position.id)
              keyword.auto_position.configStatus = status
            }
          }
          if (only_keyword && only_keyword.auto_position) {
            auto_position_ids = [only_keyword.auto_position.id]
            only_keyword.auto_position.configStatus = status
          }
          await this.$http.post(this.API.URL_API_SRV_1 + '/shop_ads_position/v2/status', {
            ids: auto_position_ids,
            status: status,
            mipeeUserId: this.$store.state.userInfo.username
          }, this.cf())

          let auto_campaign_ids = []
          for (const keyword of this.c__show_keyword_filter_list) {
            if (keyword.checked && keyword.auto_campaign) {
              auto_campaign_ids.push(keyword.auto_campaign.id)
              keyword.auto_campaign.configStatus = status
            }
          }
          if (only_keyword && only_keyword.auto_campaign) {
            auto_campaign_ids = [only_keyword.auto_campaign.id]
            only_keyword.auto_campaign.configStatus = status
          }
          await this.$http.post(this.API.URL_API_SRV_1 + '/auto_campaigns/v2/status', {
            ids: auto_campaign_ids,
            status: status,
            mipeeUserId: this.$store.state.userInfo.username
          }, this.cf())
        }

        if (type === 'auto_cir') {
          let auto_cir_ids = []
          for (const keyword of this.c__show_keyword_filter_list) {
            if (keyword.checked && keyword.auto_cir) {
              auto_cir_ids.push(keyword.auto_cir.id)
              keyword.auto_cir.configStatus = status
            }
          }
          if (only_keyword && only_keyword.auto_cir) {
            auto_cir_ids = [only_keyword.auto_cir.id]
            only_keyword.auto_cir.configStatus = status
          }

          await this.$http.post(this.API.URL_API_SRV_1 + '/auto_cir/status', {
            ids: auto_cir_ids,
            status: status,
            mipeeUserId: this.$store.state.userInfo.username
          }, this.cf())
        }

        if (type === 'anti_click') {
          let anti_click_ids = []
          for (const keyword of this.c__show_keyword_filter_list) {
            if (keyword.checked && keyword.anti_click) {
              anti_click_ids.push(keyword.anti_click.id)
              keyword.anti_click.configStatus = status
            }
          }
          if (only_keyword && only_keyword.anti_click) {
            anti_click_ids = [only_keyword.anti_click.id]
            only_keyword.anti_click.configStatus = status
          }
          await this.$http.post(this.API.URL_API_SRV_1 + '/anti_click/v2/status', {
            ids: anti_click_ids,
            status: status,
            mipeeUserId: this.$store.state.userInfo.username
          }, this.cf())
        }

        if (type === 'condition_action') {
          for (const keyword of this.c__show_keyword_filter_list.filter(i => i.checked)) {
            const keyword_configs = this.auto_condition_action_detail_config_list.filter(i => i.campaign_detail_id === this.c__campaign_id && i.keyword === keyword.keyword)
            for (const config of keyword_configs) {
              const config_list = typeof config.config_list === 'string' ? JSON.parse(config.config_list) : config.config_list
              for (const item of config_list) {
                for (const sub_item of item.config_list) {
                  sub_item.enable = status === 1
                }
              }
              config.config_list = JSON.stringify(config_list)
              const form = {
                item_ids: [],
                campaign_ids: [],
                campaign_detail_id: this.c__campaign_id,
                keyword_list: [keyword.keyword],
                config_list: config_list,
                shop_id: this.shop._id,
                only_show_me: config.only_show_me
              }
              await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/update', form, this.cf())
            }
          }

          this.m__update_auto_condition_action_detail_config_list_map()
        }

        if (confirm) this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        if (confirm) this.ntf_w(this.$t('base.has_an_occurred'))

        return null
      }

      return 1
    },

    m__back_to_list() {
      this.$emit('back_to_list')
    },

    async m__get_condition_action_list() {
      const response = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/condition_action/get', this.cf())
      this.condition_action_file_list = response.body.data
    },

    async m__delete_condition_action_file(file) {
      try {
        await this.$confirm(this.$t('base.delete_file_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
      } catch (e) {
        return
      }

      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/condition_action/delete', {
        id: file._id
      }, this.cf())

      await this.m__get_condition_action_list()
      this.ntf_s(this.$t('base.update_success'))
    },

    m__confirm_action_select_file(file) {
      const found = file || this.condition_action_file_list.find(i => i._id === this.condition_action_file_selected)
      if (!found) return

      this.condition_action_list = this.clone(found.data)
      this.show_dialog.action_condition_select_file = false

      if (file) this.condition_action_tab = 'main'
    },

    m__show__action_select_file_dialog() {
      this.show_dialog.action_condition_select_file = true
    },

    async m__confirm_action_save_file() {
      this.loading.action_condition_save_file = true
      try {
        if (this.condition_action_radio === '1') {
          if (!this.condition_action_filename) {
            this.ntf_w(this.$t('required.filename'))
            return
          }

          await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/condition_action/save', {
            filename: this.condition_action_filename,
            data: this.condition_action_list
          }, this.cf())
        }

        if (this.condition_action_radio === '2') {
          if (!this.condition_action_file_selected) {
            this.ntf_w(this.$t('required.select_file'))
            return
          }

          const found = this.condition_action_file_list.find(i => i._id === this.condition_action_file_selected)
          await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/condition_action/update', {
            id: found._id,
            filename: found.filename,
            data: this.condition_action_list
          }, this.cf())
        }

        await this.m__get_condition_action_list()
        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.action_condition_save_file = false
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.action_condition_save_file = false
      }
    },

    m__show_condition_action_save_file_dialog() {
      this.show_dialog.action_condition_save_file = true
    },

    async m__confirm_condition_action() {
      this.loading.update_keyword_by_condition = true
      let has_error = false

      for (const item of this.condition_action_list) {
        if (!item.action) {
          item.error_msg = this.$t('required.action_to_handle')
          has_error = true
          continue
        }

        if (['increase', 'reduce'].includes(item.action) && !item.update_price_type) {
          item.error_msg = this.$t('required.i_or_d_type')
          has_error = true
          continue
        }

        if (['increase', 'reduce'].includes(item.action) && !item.update_price_value) {
          item.error_msg = this.$t('required.i_or_d_value')
          has_error = true
          continue
        }

        if (item.action === 'cpc' && !item.cpc_range) {
          item.error_msg = this.$t('required.cpc_duration')
          has_error = true
          continue
        }

        item.error_msg = ''

        for (const condition of item.condition_list) {
          const {
            label,
            expression,
            value
          } = condition
          if (!label || !expression || isNaN(parseFloat(value))) {
            item.error_msg = this.$t('required.full_filter_data')
            has_error = true
            break
          }

          item.error_msg = ''
        }
      }

      if (!has_error) {
        for (const item of this.condition_action_list) {
          item.error_msg = ''
          item.success_msg = ''

          // let keywords = this.c__show_keyword_filter_list.filter(i => i.checked)
          let keywords = this.keywords
          for (const condition of item.condition_list) {
            const found = this.filter.find(i => i.camel_key === condition.label)
            keywords = keywords.filter(i => {
              if (condition.match_type === 'match_type_0' && i.match_type === 1) return false
              if (condition.match_type === 'match_type_1' && i.match_type === 0) return false

              const value = found.is_percent === true
                ? i.report[condition.label] * 100
                : i.report[condition.label]
              return i.report && eval(`${value}${condition.expression}${condition.value}`)
            })
          }

          const update_status_list = []
          for (const keyword of keywords) {
            if (item.action === 'increase') {
              const value = item.update_price_type === 'value'
                ? this.m__calculate(item.update_price_value)
                : this.m__calculate(this.percent_of(+item.update_price_value, keyword.price))
              keyword.price += value
            }
            if (item.action === 'reduce') {
              const value = item.update_price_type === 'value'
                ? this.m__calculate(item.update_price_value)
                : this.m__calculate(this.percent_of(+item.update_price_value, keyword.price))
              keyword.price -= value
            }
            if (item.action === 'cpc') {
              const start_time = this.dayjs(item.cpc_range[0]).startOf('day')
              const end_time = this.dayjs(item.cpc_range[1]).endOf('day')
              const report_response = await this.sp_user.shop_ads_marketing_detail_report_by_keyword(this.campaign.advertisements[0].adsid, start_time.unix(), end_time.unix())
              if (report_response.data) {
                for (const item of report_response.data) {
                  const atosa_cpc = +item.click ? this.m__calculate(+item.cost / +item.click) : 0
                  const keyword_found = keywords.find(i => i.keyword === item.keyword)
                  if (keyword_found) keyword_found.price = atosa_cpc
                }
              }

              // if (+keyword.report.atosa_cpc) {
              //   keyword.price = +keyword.report.atosa_cpc
              // }
            }
            if (item.action === 'match_type_0') {
              keyword.match_type = 0
            }
            if (item.action === 'match_type_1') {
              keyword.match_type = 1
            }
            if (item.action === 'ongoing') {
              if (keyword.status !== 1) {
                keyword.status = 1
                update_status_list.push(keyword)
              }
            }
            if (item.action === 'pause') {
              if (keyword.status !== 0) {
                keyword.status = 0
                update_status_list.push(keyword)
              }
            }

            this.m__prefix_keyword_price(keyword)
          }

          if (['ongoing', 'pause'].includes(item.action)) {
            await this.sp_user.marketing_pas_update_keyword_status(this.c__campaign_id, update_status_list, 'shop')
          } else {
            await this.sp_user.marketing_pas_update_keyword_type(this.c__campaign_id, keywords, 'shop')
            await this.sp_user.marketing_pas_update_keyword_price(this.c__campaign_id, keywords, 'shop')
          }
          this.$http.post(this.API.URL_API_SRV_2 + '/mipee/condition_action/log', {
            condition_list: this.condition_action_list,
            campaign_id: this.c__campaign_id,
            keywords: keywords
          }, this.cf())
            .catch(console.error)

          item.success_msg = this.$t('base.update_keywords_success')
        }

        this.show_dialog.update_keyword_by_condition = false
        this.ntf_s(this.$t('base.update_success'))
      }

      this.loading.update_keyword_by_condition = false
    },

    m__remove_condition(condition_list, index) {
      condition_list.splice(index, 1)
    },

    m__add_condition(condition_list) {
      condition_list.push(this.clone(this.condition_template))
    },

    m__remove_condition_action(index) {
      this.condition_action_list.splice(index, 1)
    },

    m__add_condition_action() {
      const template = this.clone(this.condition_action_template)
      template.condition_list.push(this.clone(this.condition_template))
      this.condition_action_list.push(template)
    },

    m__show_update_keyword_by_condition_dialog() {
      if (!this.condition_action_list.length) {
        const template = this.clone(this.condition_action_template)
        template.condition_list.push(this.clone(this.condition_template))
        this.condition_action_list.push(template)
      }

      this.show_dialog.update_keyword_by_condition = true
    },

    async m__remove_tag_to_keyword(keyword) {
      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/remove_from_keywords', {
          campaign_id: this.c__campaign_id,
          keywords: [keyword.keyword]
        }, this.cf())
        await this.m__get_keyword_tag_match()
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    async m__remove_tag_to_keywords() {
      try {
        const keywords = this.c__show_keyword_filter_list.filter(i => i.checked).map(i => i.keyword)
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/remove_from_keywords', {
          campaign_id: this.c__campaign_id,
          keywords
        }, this.cf())
        await this.m__get_keyword_tag_match()
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    m__check_tag_ids_selected(tag_id) {
      return this.tag_ids_selected.includes(tag_id)
    },

    m__handle_keyword_tag_command(command) {
      const {
        keyword,
        tag_id
      } = JSON.parse(command)
      if (tag_id === 'remove_tag') {
        this.m__remove_tag_to_keyword(keyword)
      } else {
        this.m__add_tag_to_keyword(keyword, tag_id)
      }
    },

    async m__add_tag_to_keyword(keyword, tag_id) {
      if (!tag_id) {
        return
      }

      this.loading.add_tag_to_keywords = true
      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/add_to_keywords', {
          tag_id: tag_id,
          campaign_id: this.c__campaign_id,
          keywords: [keyword.keyword]
        }, this.cf())
        await this.m__get_keyword_tag_match()
        this.show_dialog.add_tag_to_keywords = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.add_tag_to_keywords = false
      }
    },

    m__check_keyword_has_tag(keyword) {
      const match_found = this.keyword_tag_match.find(i => i.keyword === keyword.keyword)
      return !!match_found
    },

    m__check_keyword_match(keyword, tag_id) {
      const match_found = this.keyword_tag_match.find(i => i.keyword === keyword.keyword)
      return match_found && match_found.tag_id === tag_id
    },

    m__map_keyword_tag(keyword) {
      const match_found = this.keyword_tag_match.find(i => i.keyword === keyword.keyword)
      if (match_found) {
        const tag = this.keyword_tag_list.find(i => i._id === match_found.tag_id)
        return tag ? tag.name : null
      }

      return null
    },

    async m__get_keyword_tag_match() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/get_match', {campaign_id: this.c__campaign_id}, this.cf())
      this.keyword_tag_match = response.body.data
    },

    async m__add_tag_to_keywords() {
      if (!this.keyword_tag_id_selected) {
        return
      }

      try {
        const keywords = this.c__show_keyword_filter_list.filter(i => i.checked).map(i => i.keyword)
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/add_to_keywords', {
          tag_id: this.keyword_tag_id_selected,
          campaign_id: this.c__campaign_id,
          keywords
        }, this.cf())
        await this.m__get_keyword_tag_match()
        this.show_dialog.add_tag_to_keywords = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    async m__show_add_tag_to_keyword_dialog() {
      this.show_dialog.add_tag_to_keywords = true
    },

    async m__delete_keyword_tag(tag) {
      try {
        await this.$confirm(this.$t('base.delete_tags_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/delete', {
          _id: tag._id
        }, this.cf())
        await this.m__get_keyword_tag()
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    async m__update_keyword_tag(tag) {
      if (!tag.name || !tag.temp_name) {
        return
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/update', {
          _id: tag._id,
          name: tag.temp_name
        }, this.cf())

        tag.name = tag.temp_name
        tag.editable = false
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    m__toggle_update_keyword_tag(tag, value) {
      tag.temp_name = tag.name
      tag.editable = value
    },

    async m__create_keyword_tag() {
      if (!this.keyword_tag_name) {
        return
      }

      this.loading.create_tag = true
      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/create', {
          name: this.keyword_tag_name,
          color: ''
        }, this.cf())
        await this.m__get_keyword_tag()

        this.loading.create_tag = false
        this.keyword_tag_name = ''
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.create_tag = false
      }
    },

    async m__get_keyword_tag() {
      const response = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/get', this.cf())
      for (const item of response.body.data) {
        item.temp_name = ''
        item.editable = false
      }
      this.keyword_tag_list = response.body.data
    },

    m__show_create_tag_dialog() {
      this.show_dialog.create_tag = true
    },

    m__handle_tag_command(command) {
      if (command === 'create_tag') {
        this.m__show_create_tag_dialog()
      } else if (command === 'add_to_keyword') {
        this.m__show_add_tag_to_keyword_dialog()
      } else if (command === 'remove_from_keyword') {
        this.m__remove_tag_to_keywords()
      } else if (command === 'added') {
        this.tag_ids_selected.includes('added') ? this.tag_ids_selected = [] : this.tag_ids_selected = ['added']
      } else if (command === 'not_added') {
        this.tag_ids_selected.includes('not_added') ? this.tag_ids_selected = [] : this.tag_ids_selected = ['not_added']
      } else {
        this.tag_ids_selected = this.tag_ids_selected.filter(i => !['added', 'not_added'].includes(i))
        if (this.m__check_tag_ids_selected(command)) {
          this.tag_ids_selected = this.tag_ids_selected.filter(i => i !== command)
        } else {
          this.tag_ids_selected.push(command)
        }
      }
    },

    async m__update_shop_ads_image() {
      try {
        const new_image_url = this.shop_ads_image_url_upload

        const form = {
          campaign_id: this.c__campaign_id,
          type: 'change_creative',
          change_creative: {
            image_url: new_image_url,
            is_use_default: false,
            landing_page: 'shop_homepage',
            tagline: this.shop_ads.tagline
          }
        }

        const resp = await this.sp_user.marketing_pas_update_shop_campaign(form)
        if (resp.code === 0) {
          const advertisementPlacement3 = this.campaign.advertisements.find(item => item.placement === 3)
          advertisementPlacement3.extinfo.shop_customisation.image_url = new_image_url
          this.shop_ads_image_url = new_image_url

          this.ntf_s(this.$t('base.update_success'))
          this.show_dialog.upload_image = false
        } else {
          this.ntf_w(`Đã có lỗi xảy ra. Mã lỗi ${resp.data.code}`)
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    async m__upload_shop_ads_image(e) {
      try {
        const file_store = e.target.files || e.dataTransfer.files
        if (file_store.length === 0) {
          return
        }

        const response = await this.sp_user.upload_image(file_store[0])
        if (response && response.data && response.data.data && response.data.data.resource_id) {
          this.shop_ads_image_url_upload = response.data.data.resource_id
          this.show_dialog.upload_image = true
        }
      } catch (e) {
        console.error(e)
      } finally {
        e.target.value = null
      }
    },

    m__show_upload_shop_ads_image() {
      if (this.c__campaign_bidding_type !== 'manual') return
      this.$el.querySelector(`#input_shop_ads_image`).click()
    },

    async m__get_restricted_keywords() {
      try {
        const response = await this.$http.get(this.API.URL_API_SRV_1 + '/restricted_keywords', {
          params: {
            shopId: this.shop._id,
            shShopId: this.shop.shop_id,
            mipeeUserId: this.$store.state.userInfo.username
          },
          ...this.cf()
        })

        this.restricted_keywords_list = response.body
      } catch (e) {
        console.error(e)
      }
    },

    async m__save_update_keyword_log(keyword_list, config = null) {
      const start_time = this.dayjs().startOf('day')
      const end_time = this.dayjs().endOf('day')

      const [campaign_report_resp, ads_report_resp, shop_report_resp, ads_report_resp_v2, campaign_report_resp_v2] = await Promise.all([
        {data: null},
        {data: null},
        this.sp_user.dashboard__key_metrics(start_time.unix(), end_time.unix(), 'real_time'),
        this.sp_user.marketing_get_time_graph('search', start_time.unix(), end_time.unix(), {}),
        this.sp_user.marketing_get_time_graph('shop', start_time.unix(), end_time.unix(), {campaign_id: this.c__campaign_id}, false)
      ])

      const form = {
        keywords: keyword_list,
        mipeeUserId: this.$store.state.userInfo.username,
        campaignId: this.c__campaign_id,
        shopMetrics: JSON.stringify(shop_report_resp.result),
        adsMetrics: ads_report_resp.data ? JSON.stringify(ads_report_resp.data.data) : '',
        campaignReport: campaign_report_resp.data ? JSON.stringify(campaign_report_resp.data.data) : '',
        config: config ? JSON.stringify(config) : null,
        adsMetricsV2: ads_report_resp_v2.data ? JSON.stringify(ads_report_resp_v2.data) : '',
        campaignReportV2: campaign_report_resp_v2.data ? JSON.stringify(campaign_report_resp_v2.data) : ''
      }
      this.$http.post(this.API.URL_API_SRV_1 + '/lg/2.1', form, this.cf()).catch(console.error)
    },

    async m__save_delete_keyword_log(keyword_list) {
      const form = {
        keywords: keyword_list,
        mipeeUserId: this.$store.state.userInfo.username,
        campaignId: this.c__campaign_id
      }
      this.$http.post(this.API.URL_API_SRV_1 + '/lg/4.1', form, this.cf()).catch(console.error)
    },

    m__time_to_text(item) {
      const start_hour = item.start_time.split(':')[0]
      const start_minute = item.start_time.split(':')[1]

      const end_hour = item.end_time.split(':')[0]
      const end_minute = item.end_time.split(':')[1]

      const start_time = this.dayjs().hour(start_hour).minute(start_minute).minute(0)
      const end_time = this.dayjs().hour(end_hour).minute(end_minute).minute(0)

      if (start_time.isBefore(end_time, 'second')) {
        return `${this.$t('base.starting_at')} ${start_hour} ${this.$t('base.hours')} ${start_minute} ${this.$t('base.minutes')} ${this.$t('base.to')} ${end_hour} ${this.$t('base.hours')} ${end_minute} ${this.$t('base.minutes')}`
      } else {
        return `${this.$t('base.starting_at')} ${start_hour} ${this.$t('base.hours')} ${start_minute} ${this.$t('base.minutes')} ${this.$t('base.to')} ${end_hour} ${this.$t('base.hours')} ${end_minute} ${this.$t('base.minutes')} ${this.$t('base.the_next_day')}`
      }
    },

    m__show_config_anti_click_single(keyword) {
      if (!this.check_role(this.shop, 'keyword_ads', 'anti_click')) {
        return
      }

      this.form_anti_click.keywords = [keyword.keyword]

      if (keyword.anti_click) {
        this.form_anti_click.ratio = keyword.anti_click.ratio
        this.form_anti_click.click_number = keyword.anti_click.clickNumber
        this.form_anti_click.order_amount = keyword.anti_click.orderAmount
        this.form_anti_click.click_minimum_number = keyword.anti_click.clickMinimumNumber
        this.form_anti_click.click_maximum_number = keyword.anti_click.clickMaximumNumber
        this.form_anti_click.detect_type = keyword.anti_click.detectType
        this.form_anti_click.detect_value_2 = keyword.anti_click.detectValue2
        this.form_anti_click.detect_value_3 = keyword.anti_click.detectValue3
        this.form_anti_click.type = keyword.anti_click.ratio ? '1' : '2'
        this.form_anti_click.cir = keyword.anti_click.cir
        this.form_anti_click.time_type = keyword.anti_click.timeType
        this.form_anti_click.start_time = keyword.anti_click.startTime ? new Date(keyword.anti_click.startTime) : null
        this.form_anti_click.end_time = keyword.anti_click.endTime ? new Date(keyword.anti_click.endTime) : null
        this.form_anti_click.min_cost = keyword.anti_click.minCost
        this.form_anti_click.max_cost = keyword.anti_click.maxCost
        this.form_anti_click.not_order = !!keyword.anti_click.minCost
        this.form_anti_click.is_direct_cir = keyword.anti_click.isDirectCir
      }

      this.selected_keyword = keyword
      this.show_dialog.config_anti_click = true
      this.config_tab = 4
    },

    async m__confirm_anti_click_single() {
      try {
        if (this.form_anti_click.type === '1') {
          if (!this.form_anti_click.ratio || this.form_anti_click.ratio < 0) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.expected_cir'),
              x: '0'
            }))
            return
          }

          if (!this.form_anti_click.click_minimum_number || this.form_anti_click.click_minimum_number < 1) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.min_clicks'),
              x: '0'
            }))
            return
          }

          if (!this.form_anti_click.click_maximum_number || this.form_anti_click.click_maximum_number < 1) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.max_clicks'),
              x: '0'
            }))
            return
          }
        } else {
          if (!this.form_anti_click.cir || this.form_anti_click.cir < 0) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.ratio'),
              x: '0'
            }))
            return
          }

          if (this.form_anti_click.time_type === 'custom') {
            if (!this.form_anti_click.start_time) {
              this.ntf_w(this.$t('required.start_time'))
              return
            }
            if (!this.form_anti_click.end_time) {
              this.ntf_w(this.$t('required.end_time'))
              return
            }
          }
        }

        if (this.form_anti_click.detect_type === 2 && !this.form_anti_click.detect_value_2) {
          this.ntf_w(this.$t('required.percent'))
          return
        }

        if (this.form_anti_click.detect_type === 3 && !this.form_anti_click.detect_value_3) {
          this.ntf_w(this.$t('required.bid_price'))
          return
        }

        if (this.form_anti_click.not_order && (!this.form_anti_click.min_cost || this.m__calculate(this.form_anti_click.min_cost) === 0)) {
          this.ntf_w(this.$t('required.max_cost_if_gmv_by_0'))
          return
        }

        if (this.form_anti_click.not_order && !this.form_anti_click.min_cost) {
          await this.$confirm(this.$t('ads.anti_click_label.confirm_1'), this.$t('base.attention'), {
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
            type: 'warning'
          })
        } else if (this.form_anti_click.not_order && this.form_anti_click.min_cost < 1000) {
          await this.$confirm(this.$t('ads.anti_click_label.confirm_2'), this.$t('base.attention'), {
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
            type: 'warning'
          })
        }

        this.loading.config_anti_click = true

        const form = {
          keywords: this.form_anti_click.keywords,
          shopId: this.shop._id,
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          clickNumber: this.form_anti_click.click_number,
          orderAmount: this.form_anti_click.order_amount,
          ratio: this.form_anti_click.type === '1' ? this.form_anti_click.ratio : null,
          clickMinimumNumber: this.form_anti_click.click_minimum_number,
          clickMaximumNumber: this.form_anti_click.click_maximum_number,
          detectType: this.form_anti_click.detect_type,
          detectValue2: this.form_anti_click.detect_value_2,
          detectValue3: this.form_anti_click.detect_value_3,
          cir: this.form_anti_click.type === '2' ? this.form_anti_click.cir : null,
          timeType: this.form_anti_click.time_type,
          startTime: this.form_anti_click.start_time ? this.dayjs(this.form_anti_click.start_time).toISOString() : '',
          endTime: this.form_anti_click.end_time ? this.dayjs(this.form_anti_click.end_time).toISOString() : '',
          minCost: this.form_anti_click.not_order ? (this.form_anti_click.min_cost || 0) : null,
          maxCost: this.form_anti_click.max_cost,
          isDirectCir: this.form_anti_click.is_direct_cir
        }
        await this.$http.post(this.API.URL_API_SRV_1 + '/anti_click/v2', form, this.cf())

        for (const keyword of this.form_anti_click.keywords) {
          const find_keyword = this.keywords.find(i => i.keyword === keyword)
          find_keyword.anti_click = {
            ratio: this.form_anti_click.ratio,
            clickNumber: this.form_anti_click.click_number,
            orderAmount: this.form_anti_click.order_amount,
            clickMinimumNumber: this.form_anti_click.click_minimum_number,
            clickMaximumNumber: this.form_anti_click.click_maximum_number,
            detectType: this.form_anti_click.detect_type,
            detectValue2: this.form_anti_click.detect_value_2,
            detectValue3: this.form_anti_click.detect_value_3,
            cir: this.form_anti_click.type === '2' ? this.form_anti_click.cir : null,
            timeType: this.form_anti_click.time_type,
            startTime: this.form_anti_click.start_time ? this.dayjs(this.form_anti_click.start_time).toISOString() : '',
            endTime: this.form_anti_click.end_time ? this.dayjs(this.form_anti_click.end_time).toISOString() : '',
            minCost: this.form_anti_click.not_order ? (this.form_anti_click.min_cost || 0) : null,
            maxCost: this.form_anti_click.max_cost,
            isDirectCir: this.form_anti_click.is_direct_cir,
            createdAt: new Date()
          }
        }

        this.ntf_s(this.$t('base.save_config_success'))
        this.show_dialog.config_anti_click = false
      } catch (e) {
        console.log(e)
        this.ntf_w(e)
      } finally {
        this.loading.config_anti_click = false
      }
    },

    async m__delete_anti_click_single() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.delete'),
          cancelButtonText: this.$t('base.cancel')
        })

        await this.$http.delete(this.API.URL_API_SRV_1 + '/anti_click/v2', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: this.c__campaign_id,
            keyword: this.selected_keyword.keyword
          }
        })
        this.selected_keyword.anti_click = null

        this.ntf_s(this.$t('base.delete_success'))
        this.show_dialog.config_anti_click = false
      } catch (e) {
      }
    },

    async m__show_config_anti_click_multiple() {
      if (!this.check_role(this.shop, 'keyword_ads', 'anti_click')) {
        return
      }

      const config_list = this.keywords.filter(i => i.checked && i.anti_click)
      if (config_list.length) {
        const config = _orderBy(config_list, ['anti_click.createdAt'], ['desc'])
        const keyword = config[0]
        this.form_anti_click.ratio = keyword.anti_click.ratio
        this.form_anti_click.click_number = keyword.anti_click.clickNumber
        this.form_anti_click.order_amount = keyword.anti_click.orderAmount
        this.form_anti_click.click_minimum_number = keyword.anti_click.clickMinimumNumber
        this.form_anti_click.click_maximum_number = keyword.anti_click.clickMaximumNumber
        this.form_anti_click.detect_type = keyword.anti_click.detectType
        this.form_anti_click.detect_value_2 = keyword.anti_click.detectValue2
        this.form_anti_click.detect_value_3 = keyword.anti_click.detectValue3
        this.form_anti_click.type = keyword.anti_click.ratio ? '1' : '2'
        this.form_anti_click.cir = keyword.anti_click.cir
        this.form_anti_click.time_type = keyword.anti_click.timeType
        this.form_anti_click.start_time = keyword.anti_click.startTime ? new Date(keyword.anti_click.startTime) : null
        this.form_anti_click.end_time = keyword.anti_click.endTime ? new Date(keyword.anti_click.endTime) : null
        this.form_anti_click.min_cost = keyword.anti_click.minCost
        this.form_anti_click.max_cost = keyword.anti_click.maxCost
        this.form_anti_click.not_order = !!keyword.anti_click.minCost
        this.form_anti_click.is_direct_cir = keyword.anti_click.isDirectCir
      }

      this.form_anti_click.keywords = this.keywords.filter(i => i.checked).map(i => i.keyword)
      this.show_dialog.config_anti_click = true
      this.config_tab = 4
    },

    async m__delete_multiple_config_anti_click() {
      if (!this.check_role(this.shop, 'keyword_ads', 'anti_click')) {
        return
      }

      try {
        await this.$confirm(this.$t('base.delete_multiple_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        this.loading.delete_all = true
        await this.$http.post(this.API.URL_API_SRV_1 + '/anti_click/v2/delete/multiple', {
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          // keywords: this.keywords.filter(i => i.checked).map(i => i.keyword)
          keywords: this.c__show_keyword_filter_list.filter(i => i.checked).map(i => i.keyword)
        }, this.cf())

        // const selected_keywords = this.keywords.filter(i => i.checked)
        const selected_keywords = this.c__show_keyword_filter_list.filter(i => i.checked)
        for (const item of selected_keywords) {
          item.anti_click = null
        }

        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
      } finally {
        this.loading.delete_all = false
      }
    },

    async m__confirm_save_auto_cir() {
      if (!this.form_config_auto_cir.fromCir) {
        this.ntf_w(this.$t('required.expected_cir'))
        return
      }

      if (!this.form_config_auto_cir.toCir) {
        this.ntf_w(this.$t('required.expected_cir'))
        return
      }

      if (!this.form_config_auto_cir.cirType) {
        this.ntf_w(this.$t('required.cir_type'))
        return
      }

      if (!this.form_config_auto_cir.timeType) {
        this.ntf_w(this.$t('required.check_duration'))
        return
      }

      if (this.form_config_auto_cir.allowBidPrice) {
        if (!this.form_config_auto_cir.price) {
          this.ntf_w(this.$t('required.bonus_amount'))
          return
        }
        if (!this.form_config_auto_cir.maxPrice) {
          this.ntf_w(this.$t('required.max_bid_price'))
          return
        }
      }

      if (this.form_config_auto_cir.allowAtCase1) {
        if (this.form_config_auto_cir.case1Type === 'value' && !this.form_config_auto_cir.case1Value) {
          this.ntf_w(this.$t('input.amount'))
          return
        }
        if (this.form_config_auto_cir.case1Type === 'percent' && !this.form_config_auto_cir.case1Percent) {
          this.ntf_w(this.$t('required.percent'))
          return
        }
      }

      if (this.form_config_auto_cir.allowAtCase2) {
        if (this.form_config_auto_cir.case2Type === 'value' && !this.form_config_auto_cir.case2Value) {
          this.ntf_w(this.$t('input.amount'))
          return
        }
        if (this.form_config_auto_cir.case2Type === 'percent' && !this.form_config_auto_cir.case2Percent) {
          this.ntf_w(this.$t('required.percent'))
          return
        }
      }

      if (!this.form_config_auto_cir.allowBidPrice && !this.form_config_auto_cir.allowAtCase1 && !this.form_config_auto_cir.allowAtCase2) {
        this.ntf_w(this.$t('required.must_select_at_least'))
        return
      }

      try {
        await this.$confirm(this.$t('base.use_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.config_auto_cir = true
      try {
        await this.$http.post(this.API.URL_API_SRV_1 + '/auto_cir', {
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          shopId: this.shop._id,
          ...this.form_config_auto_cir
        }, this.cf())

        for (const keyword of this.form_config_auto_cir.keywords) {
          const found = this.keywords.find(i => i.keyword === keyword)
          if (found) found.auto_cir = this.form_config_auto_cir
        }

        this.ntf_s(this.$t('base.save_config_success'))
        this.show_dialog.config_auto_cir = false
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.config_auto_cir = false
      }
    },

    m__show_config_auto_cir(keyword) {
      this.selected_keyword = keyword

      if (keyword.auto_cir) this.form_config_auto_cir = this.clone(keyword.auto_cir)

      this.form_config_auto_cir.keywords = [keyword.keyword]
      this.show_dialog.config_auto_cir = true
    },

    m__show_multiple_config_auto_cir() {
      this.form_config_auto_cir.keywords = this.c__show_keyword_filter_list.filter(i => i.checked).map(i => i.keyword)
      this.show_dialog.config_auto_cir = true
      this.select_multiple = true

      this.config_tab = 6
    },

    async m__delete_auto_cir() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_1 + '/auto_cir/delete', {
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          shopId: this.shop._id,
          keywords: [this.selected_keyword.keyword]
        }, this.cf())

        this.selected_keyword.auto_cir = null

        this.ntf_s(this.$t('base.delete_config_success'))
        this.show_dialog.config_auto_cir = false
      } catch (e) {
        this.ntf_w(e)
      }
    },

    async m__delete_multiple_auto_cir() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_1 + '/auto_cir/delete', {
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          shopId: this.shop._id,
          keywords: this.c__show_keyword_filter_list.filter(i => i.checked).map(i => i.keyword)
        }, this.cf())

        for (const keyword of this.c__show_keyword_filter_list.filter(i => i.checked)) {
          keyword.auto_cir = null
        }

        this.ntf_s(this.$t('base.delete_config_success'))
        this.show_dialog.config_auto_cir = false
      } catch (e) {
        this.ntf_w(e)
      }
    },

    async m__confirm_update_shop_ads() {
      if (!this.shop_ads.tagline) {
        this.ntf_w(this.$t('required.tagline'))
        return
      }

      if (new RegExp(/[!@^*{};<>]/g).test(this.shop_ads.tagline)) {
        this.ntf_w(this.$t('required.tagline_not_includes'))
        return
      }

      this.loading.update_shop_ads = true
      try {
        const form = {
          campaign_id: this.c__campaign_id,
          type: 'change_creative',
          change_creative: {
            image_url: this.shop_ads_image_url,
            is_use_default: false,
            landing_page: 'shop_homepage',
            tagline: this.shop_ads.tagline
          }
        }

        const resp = await this.sp_user.marketing_pas_update_shop_campaign(form)
        if (resp.code === 0) {
          this.ntf_s(this.$t('base.update_success'))
          this.show_dialog.update_shop_ads = false
        } else {
          this.ntf_w(`${this.$t('base.has_an_occurred')}. ${this.$t('base.error_code')} ${resp.code}`)
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.update_shop_ads = false
      }
    },

    m__show_update_shop_ads_dialog() {
      if (this.campaign && this.campaign.advertisements && this.campaign.advertisements.length) {
        const ads = this.campaign.advertisements[0]
        this.shop_ads.collection_id = ads.extinfo.shop_customisation.collection_id
        this.shop_ads.type = ads.extinfo.shop_customisation.collection_id === 0 ? 0 : 1
        this.shop_ads.radio = ads.extinfo.shop_customisation.collection_id
        this.shop_ads.tagline = this.campaign.campaign.name
        this.shop_ads.image_url = ads.extinfo.shop_customisation.image_url

        const category = this.shop_ads.category_list.find(i => i.id === this.shop_ads.radio)
        if (category) {
          this.shop_ads.collection_name = ': ' + category.name
        }

        this.show_dialog.update_shop_ads = true
      }
    },

    m__confirm_shop_ads_category() {
      const category = this.shop_ads.category_list.find(i => i.id === this.shop_ads.radio)
      this.shop_ads.collection_name = ': ' + category.name
      this.show_dialog.shop_ads_categories = false
      this.shop_ads.type = 1
    },

    m__select_shop_ads_type(e) {
      if (e === 1) {
        this.show_dialog.shop_ads_categories = true
      }
    },

    m__close_shop_ads_category() {
      if (!this.shop_ads.radio) {
        this.shop_ads.type = 0
      }
    },

    async m__get_shop_ads_category() {
      const response = await this.sp_user.shop_ads_get_categories()
      this.shop_ads.category_list = response.data.list.filter(i => i.status === 'active')
    },

    async m__confirm_compare_keyword() {
      this.loading.compare_keyword = true
      this.is_compare_keyword = false

      const start_time = this.dayjs(new Date(this.compare_date_range[0])).startOf('d')
      const end_time = this.dayjs(new Date(this.compare_date_range[1])).endOf('d')

      if (this.campaign.advertisements[0].placement === 3) {
        const new_response = await this.sp_user.marketing_get_report('keyword', 'shop', start_time.unix(), end_time.unix(), {campaign_id: this.c__campaign_id})
        const report_response = this.m__map_search_report_by_key(new_response)
        this.compare_data = report_response.data || {}
        for (const item of this.keywords) {
          const compare_report = this.compare_data.find(i => i.keyword === item.keyword)
          if (compare_report) {
            item.c_report = this.m__map_detail_campaign_report(compare_report)
          } else {
            item.c_report = {...this.default_report}
          }
        }
      }

      if (this.campaign.advertisements[0].placement === 20) {
        const new_response = await this.sp_user.marketing_get_report('auto_strategy', 'shop', start_time.unix(), end_time.unix(), {campaign_id: this.c__campaign_id})
        const report_response = this.m__map_search_report_by_key(new_response)
        const placement20_report = {data: report_response.data ? report_response.data.filter(i => i.keyword === 'auto') : null}
        if (placement20_report.data && placement20_report.data.length) {
          this.compare_auto = this.m__map_detail_campaign_report(placement20_report.data[0])
          this.placement20.c_report = this.compare_auto
        } else {
          this.placement20.c_report = {...this.default_report}
        }
      }

      const graph_response = await this.sp_user.marketing_get_time_graph('shop', this.dayjs(start_time).startOf('day').unix(), this.dayjs(end_time).endOf('day').unix(), {campaign_id: this.c__campaign_id}, false)
      if (!graph_response.data) {
        this.loading.compare_campaign = false
        return
      }
      this.compare_metrics = this.m__map_graph_response(graph_response.data.report_aggregate)
      this.compare_reports = this.m__map_graph_by_time_response(graph_response.data.report_by_time)

      const timeslot = this.compare_reports.map(i => i.timestamp)
      const detail_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/shopee_ads/get_campaign_detail_by_hour', {
        shop_id: this.shop._id,
        campaign_id: this.c__campaign_id,
        timeslot: timeslot
      }, this.cf())

      if (detail_response && detail_response.body && detail_response.body.data) {
        for (const item of detail_response.body.data) {
          const report_found = this.compare_reports.find(i => i.timestamp === item.time)
          if (report_found) Object.assign(report_found, item.data)
        }
        this.compare_reports = this.clone(this.compare_reports)
      }

      this.is_compare_keyword = true
      this.show_dialog.compare_keyword = false
      this.loading.compare_keyword = false
    },

    m__show_compare_keyword() {
      this.show_dialog.compare_keyword = true
    },

    m__show_filter_dialog() {
      this.show_dialog.filter = true
    },

    m__start_filter() {
      let any_change = false
      for (const item of this.filter) {
        if (item.value) {
          any_change = true
          break
        }
      }
      if (!any_change) {
        this.filter_clone = null
      } else {
        this.filter_clone = JSON.parse(JSON.stringify(this.filter))
      }
      this.show_dialog.filter = false
    },

    m__delete_filter() {
      this.filter.forEach(i => {
        i.value = null
        i.expression = '>'
      })
      this.filter_clone = null
      this.show_dialog.filter = false
    },

    async m__load_campaign_detail() {
      this.parent_campaign.loading = true
      try {
        const campaign = this.parent_campaign
        const response = await this.sp_user.marketing_get_campaign_detail(campaign.campaign.campaignid, 'shop')
        response.data.campaign.state = campaign.campaign.state
        this.campaign = {...response.data}

        const advertisementPlacement3 = response.data.advertisements.find(item => item.placement === 3)
        if (advertisementPlacement3) {
          this.shop_ads_image_url = advertisementPlacement3.extinfo.shop_customisation.image_url || 'sg-11134201-7rbk0-louxtq64h8mw49'
          const new_response = await this.sp_user.marketing_get_report('keyword', 'shop', this.dayjs(this.start_date).startOf('d').unix(), this.dayjs(this.end_date).endOf('d').unix(), {campaign_id: this.c__campaign_id})
          const report_response = this.m__map_search_report_by_key(new_response)
          for (const item of advertisementPlacement3.extinfo.keywords) {
            item.price = this.m__calculate(item.price)
            item.checked = this.is_selected_all = this.indeterminate = false

            let report = report_response.data ? report_response.data.find(i => i.keyword === item.keyword) : null
            if (report) {
              report = this.m__map_detail_campaign_report(report)
            } else {
              report = {...this.default_report}
            }
            item.report = report
            item.report.price = item.price

            const compare_report = this.compare_data.find(i => i.keyword === item.keyword)
            if (compare_report) {
              item.c_report = this.m__map_detail_campaign_report(compare_report)
            } else {
              item.c_report = {...this.default_report}
            }
          }

          try {
            const keyword_list = advertisementPlacement3.extinfo.keywords
              .filter(i => i.status === 1)
              .map(item => item.keyword)
            const [auto_campaign_response, auto_position_response, auto_cir_response, anti_click_response] = await Promise.all([
              this.$http.get(this.API.URL_API_SRV_1 + '/auto_campaigns/v2/detail', {
                ...this.cf(),
                params: {
                  mipeeUserId: this.$store.state.userInfo.username,
                  campaignId: campaign.campaign.campaignid
                }
              }),
              this.$http.get(this.API.URL_API_SRV_1 + '/shop_ads_position/v2/detail', {
                ...this.cf(),
                params: {
                  mipeeUserId: this.$store.state.userInfo.username,
                  campaignId: campaign.campaign.campaignid
                }
              }),
              this.$http.get(this.API.URL_API_SRV_1 + '/auto_cir', {
                ...this.cf(),
                params: {
                  mipeeUserId: this.$store.state.userInfo.username,
                  campaignId: campaign.campaign.campaignid
                }
              }),
              this.$http.get(this.API.URL_API_SRV_1 + '/anti_click/v2/detail', {
                ...this.cf(),
                params: {
                  mipeeUserId: this.$store.state.userInfo.username,
                  campaignId: campaign.campaign.campaignid
                }
              })
            ])

            for (const item of advertisementPlacement3.extinfo.keywords) {
              item.config_auto = auto_campaign_response.body.find(i => i.keyword === item.keyword)
              item.auto_position = auto_position_response.body.find(i => i.keyword === item.keyword)
              item.auto_cir = auto_cir_response.body.find(i => i.keyword === item.keyword)
              item.anti_click = anti_click_response.body.find(i => i.keyword === item.keyword)
            }
          } catch (e) {
            console.error(e)
          }
        }

        const advertisementPlacement20 = response.data.advertisements.find(item => item.placement === 20)
        if (advertisementPlacement20) {
          const new_response = await this.sp_user.marketing_get_report('auto_strategy', 'shop', this.dayjs(this.start_date).startOf('d').unix(), this.dayjs(this.end_date).endOf('d').unix(), {campaign_id: this.c__campaign_id})
          const report_response = this.m__map_search_report_by_key(new_response)

          const placement20_report = {data: report_response.data ? report_response.data.filter(i => i.keyword === 'auto') : null}
          if (placement20_report.data && placement20_report.data.length) {
            this.placement20.report = this.m__map_detail_campaign_report(placement20_report.data[0])
          } else {
            this.placement20.report = {...this.default_report}
          }

          if (this.compare_auto) {
            this.placement20.c_report = this.m__map_detail_campaign_report(this.compare_auto)
          } else {
            this.placement20.c_report = {...this.default_report}
          }
        }

        this.campaign = this.clone(this.campaign)

        this.keywords = this.campaign.advertisements.find(item => item.placement === 3)
          ? _orderBy(this.campaign.advertisements.find(item => item.placement === 3).extinfo.keywords, ['report.broad_gmv', 'report.click', 'status'], ['desc', 'desc', 'desc'])
          : []

        await this.m__detail_report_by_time()

        // TODO: Load shopee volume
        if (this.keywords.length) {
          this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
            mipeeUserId: this.$store.state.userInfo.username,
            keyword: this.keywords[0].keyword,
            data: this.keywords.map(i => i.keyword),
            country: this.sp_user.country
          }, this.cf())
            .then(async (resp) => {
              this.is_destroyed = true
              this.is_destroyed = false
              const save_and_result_list = resp.body
              for (const item of this.keywords) {
                if (this.is_destroyed) break

                const found = save_and_result_list.find(i => i.keyword === item.keyword)
                if (found) {
                  item.report.shopee_volume = found.volume
                }
              }

              try {
                const need_to_get_volume_response = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/need_to_get_volume', {
                  keywords: this.keywords.map(i => i.keyword),
                  country: this.sp_user.country
                }, this.cf())

                const get_volume_set = new Set(need_to_get_volume_response.body.data)
                for (const item of this.keywords) {
                  if (this.is_destroyed) break
                  if (!get_volume_set.has(item.keyword)) continue

                  const info = await this.sp_user.marketing_get_keyword_volume(item.keyword, null, '3')
                  if (info && info.search_volume > 0) item.report.shopee_volume = info.search_volume

                  await this.sleep(2000)
                }

                await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/complete', {
                  mipeeUserId: this.$store.state.userInfo.username,
                  data: this.keywords.map(i => ({
                    keyword: i.keyword,
                    volume: i.report.shopee_volume
                  })),
                  country: this.sp_user.country
                }, this.cf())
              } catch (e) {
                console.error(e)
              }
            })
            .catch(console.error)
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('ads.error_with_getting_campaign_detail'))
      } finally {
        this.parent_campaign.loading = false
      }
    },

    async m__load_report() {
      try {
        this.parent_campaign.loading = true
        const placement3 = this.campaign.advertisements.find(i => i.placement === 3)

        if (this.keywords.length && placement3) {
          const start_time = this.dayjs(this.start_date).startOf('day')
          const end_time = this.dayjs(this.end_date).endOf('day')
          const new_response = await this.sp_user.marketing_get_report('keyword', 'shop', start_time.unix(), end_time.unix(), {campaign_id: this.c__campaign_id})
          const report_response = this.m__map_search_report_by_key(new_response)
          for (const item of this.keywords) {
            let report = report_response.data ? report_response.data.find(i => i.keyword === item.keyword) : null
            if (report) {
              report = this.m__map_detail_campaign_report(report)
            } else {
              report = {...this.default_report}
            }
            // item.report = report
            Object.assign(item.report, report)

            const compare_report = this.compare_data.find(i => i.keyword === item.keyword)
            if (compare_report) {
              item.c_report = this.m__map_detail_campaign_report(compare_report)
            } else {
              item.c_report = {...this.default_report}
            }
          }
        }

        await this.m__detail_report_by_time()
      } catch (e) {
        console.error(e)
      } finally {
        this.parent_campaign.loading = false
      }
    },

    m__checked_by_page() {
      this.is_selected_all = false
      this.indeterminate = true
      const start_index = (this.keyword_filter.current_page - 1) * this.keyword_filter.page_size
      const end_index = start_index + this.keyword_filter.page_size - 1

      for (const [index, keyword] of this.c__show_keyword_filter_list.entries()) {
        keyword.checked = index >= start_index && index <= end_index
      }
    },

    async m__detail_report_by_time() {
      const start_time = this.dayjs(this.start_date).startOf('day').unix()
      const end_time = this.dayjs(this.end_date).endOf('day').unix()
      const response = await this.sp_user.marketing_get_time_graph('shop', start_time, end_time, {campaign_id: this.c__campaign_id}, false)
      if (response.data) {
        this.metrics = this.m__map_graph_response(response.data.report_aggregate)
        this.reports = this.m__map_graph_by_time_response(response.data.report_by_time)

        const timeslot = this.reports.map(i => i.timestamp)
        const detail_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/shopee_ads/get_campaign_detail_by_hour', {
          shop_id: this.shop._id,
          campaign_id: this.c__campaign_id,
          timeslot: timeslot
        }, this.cf())

        if (detail_response && detail_response.body && detail_response.body.data) {
          for (const item of detail_response.body.data) {
            const report_found = this.reports.find(i => i.timestamp === item.time)
            if (report_found) Object.assign(report_found, item.data)
          }
          this.reports = this.clone(this.reports)
        }
      }
    },

    m__show_update_added_keyword_dialog() {
      this.show_dialog.update_added_keyword_price = true
    },

    m__update_added_keyword_price() {
      if (this.form_update_multiple_added_keyword_price.update_type === 1 && this.form_update_multiple_added_keyword_price.update_by_cost_value) {
        this.added_keywords.forEach(i => {
          if (this.form_update_multiple_added_keyword_price.update_by_cost === 'increase') {
            i.recommend_price += this.m__calculate(this.form_update_multiple_added_keyword_price.update_by_cost_value)
          }

          if (this.form_update_multiple_added_keyword_price.update_by_cost === 'reduce') {
            i.recommend_price -= this.m__calculate(this.form_update_multiple_added_keyword_price.update_by_cost_value)
          }
        })
      }

      if (this.form_update_multiple_added_keyword_price.update_type === 2 && this.form_update_multiple_added_keyword_price.update_by_percent_value) {
        this.added_keywords.forEach(i => {
          if (this.form_update_multiple_added_keyword_price.update_by_percent === 'increase') {
            i.recommend_price += (i.recommend_price * this.m__calculate(this.form_update_multiple_added_keyword_price.update_by_percent_value) / 100)
          }

          if (this.form_update_multiple_added_keyword_price.update_by_percent === 'reduce') {
            i.recommend_price -= (i.recommend_price * this.m__calculate(this.form_update_multiple_added_keyword_price.update_by_percent_value) / 100)
          }
        })
      }

      if (this.form_update_multiple_added_keyword_price.update_type === 3) {
        this.added_keywords.forEach(i => {
          i.recommend_price = this.m__calculate(this.form_update_multiple_added_keyword_price.price)
        })
      }

      this.show_dialog.update_added_keyword_price = false
    },

    m__prefix_keyword_price(keyword) {
      if (!keyword.price) keyword.price = 400

      if (keyword.match_type === 0 && keyword.price < this.MATCH_TYPE_0_MIN) {
        keyword.price = this.MATCH_TYPE_0_MIN
      }
      if (keyword.match_type === 1 && keyword.price < this.MATCH_TYPE_1_MIN) {
        keyword.price = this.MATCH_TYPE_1_MIN
      }
    },

    m__is_allow_delete_keyword() {
      const pack = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing')
      return pack && pack.package && pack.package.extra_data && pack.package.extra_data.marketing && pack.package.extra_data.marketing.delete_keyword
    },

    m__toggle_select_index() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      this.show_dialog.select_index = !this.show_dialog.select_index
    },

    m__is_show_index(value) {
      const flag = this.flag_list.find(i => i.value === value)
      if (flag) {
        return flag.checked
      } else {
        return false
      }
    },

    async m__get_flag_list() {
      const report_config_response = await this.sp_user.marketing_pas_get_report_config()
      if (report_config_response.data && report_config_response.data.selected_metric && report_config_response.data.selected_metric['product_manual']) {
        for (const flag of this.flag_list) {
          flag.checked = report_config_response.data.selected_metric['shop_manual'].metric_list.includes(flag.value)
        }
      }
      if (!this.flag_list.some(i => i.checked)) {
        for (const flag of this.flag_list) {
          if (['impression', 'click', 'ctr', 'cost', 'broad_gmv'].includes(flag.value)) flag.checked = true
        }
      }
    },

    async m__update_flag_list() {
      if (this.flag_list.filter(i => i.checked === true).length <= 0) {
        return
      }
      const data = {
        metric_list: this.flag_list.reduce((r, i) => {
          if (i.checked) r.push(i.value)
          return r
        }, []),
        page: 'shop_manual'
      }
      await this.sp_user.marketing_pas_update_metric_config(data)
    },

    m__add_all() {
      let source = []

      if (this.radio === '1') {
        source = this.shopee_suggest_keywords
      }
      if (this.radio === '2') {
        // source = this.mipee_suggest_keywords
        const data = JSON.parse(JSON.stringify(this.mipee_suggest_keywords))
        source = data.map(i => {
          i.recommend_price = this.form_add_new_campaign && this.form_add_new_campaign.price_type === 'mipee' ? i.price : i.recommend_price
          return i
        })
      }
      if (this.radio === '3') {
        source = this.add_keyword
      }
      if (this.radio === '4') {
        source = this.fff_result.slice(0, 100)
      }
      if (this.radio === '5') {
        source = this.excel_keyword
      }

      if (source) {
        for (let i = 0; i < source.length; i++) {
          const keyword = source[i]

          if (this.omit_duplicated_keyword) {
            if (
              !this.keywords.find(e => e.keyword.normalize() === keyword.keyword.normalize()) &&
              !this.added_keywords.find(e => e.keyword.normalize() === keyword.keyword.normalize())
            ) {
              this.added_keywords.push({
                ...keyword,
                recommend_price: keyword.input_price || this.MATCH_TYPE_0_MIN,
                volume: keyword.volume
              })
            }
          } else {
            if (
              !this.keywords.find(e => e.keyword === source[i].keyword) &&
              !this.added_keywords.find(e => e.keyword === source[i].keyword)
            ) {
              this.added_keywords.push({
                ...keyword,
                recommend_price: keyword.input_price || this.MATCH_TYPE_0_MIN,
                volume: keyword.volume
              })
            }
          }
        }
      }
    },

    m__is_allow_keyword_tool() {
      const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing') : null
      if (extent_package) {
        return !!(this.dayjs().isBefore(this.dayjs(new Date(extent_package.license_to)), 's') &&
          extent_package.package.extra_data && extent_package.package.extra_data.marketing &&
          extent_package.package.extra_data.marketing.keyword_tool)
      } else {
        return false
      }
    },

    async m__get_keyword_file() {
      const response = await this.$http.get(this.API.marketing.keyword_file.list, this.cf())
      this.keyword_file_list = response.body.data
    },

    async m__get_keyword_file_detail() {
      if (!this.selected_keyword_file) return

      const response = await this.$http.get(this.API.marketing.keyword_file.detail.replace('_id', this.selected_keyword_file), this.cf())
      const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
        mipeeUserId: this.$store.state.userInfo.username,
        keyword: response.body.data.keyword_json[0].keyword,
        data: response.body.data.keyword_json.map(i => i.keyword),
        country: this.sp_user.country
      }, this.cf())
      for (const item of response.body.data.keyword_json) {
        const found = resp.body.find(i => i.keyword === item.keyword)
        if (found) {
          item.now_volume = item.sp_volume = found.volume || item.sp_volume
          item.recommend_price = item.now_price = item.sp_price = this.m__calculate(found.recommendPrice || item.sp_price)
        }
        // this.m__get_keyword_sp_info(item).catch(console.error)
      }
      this.mipee_suggest_keywords = response.body.data.keyword_json
    },

    async m__get_keyword_sp_info(keyword) {
      try {
        if (keyword.sp_volume) {
          keyword.now_volume = keyword.sp_volume
          keyword.recommend_price = keyword.now_price = this.m__calculate(keyword.sp_price)
        } else {
          const info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, null, '3')
          keyword.now_volume = keyword.sp_volume = info.search_volume
          keyword.recommend_price = keyword.now_price = keyword.sp_price = this.m__calculate(info.recommend_price)
        }
      } catch (error) {
        console.log(error)
      }

      // try {
      //   let info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, null, 3)
      //   if (info) {
      //     keyword.search_volume = keyword.now_volume = info.search_volume
      //     keyword.recommend_price = keyword.now_price = this.m__calculate(info.recommend_price)
      //   }
      // } catch (error) {
      //   console.log(error)
      // }
    },

    m__select_all() {
      this.indeterminate = false
      if (this.is_selected_all) {
        this.c__show_keyword_filter_list.forEach(i => {
          i.checked = true
        })
      } else {
        this.keywords.forEach(i => {
          i.checked = false
        })
      }
    },

    m__indeterminate() {
      if (this.keywords.filter(i => i.checked === true).length === this.keywords.length) {
        this.is_selected_all = true
        this.indeterminate = false
      } else if (this.keywords.filter(i => i.checked === true).length === 0) {
        this.is_selected_all = false
        this.indeterminate = false
      } else {
        this.is_selected_all = false
        this.indeterminate = true
      }
    },

    async m__change_keyword() {
      const advertisements = [...this.campaign.advertisements]
      // console.log(advertisements)
      const placement3 = advertisements.find(i => i.placement === 3)
      const MAX_LENGTH = ADS_CONSTANTS.MAX_KEYWORDS_LENGTH
      placement3.extinfo.keywords = _uniqBy(placement3.extinfo.keywords, 'keyword').slice(0, MAX_LENGTH)

      return await this.sp_user.marketing_update_campaign({
        ads_audit_event: null,
        campaign_ads_list: [{
          advertisements: advertisements,
          campaign: this.campaign.campaign
        }]
      })
    },

    async m__change_keyword_type(keyword) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_keyword')) {
        return
      }

      this.loading.update_data = true
      await this.sp_user.marketing_pas_update_keyword_type(this.c__campaign_id, [keyword], 'shop')
      this.loading.update_data = false
    },

    m__show_update_keyword_price(keyword) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_keyword')) {
        return
      }

      this.selected_keyword = keyword
      this.selected_keyword.old_price = this.selected_keyword.price = this.m__calculate(this.selected_keyword.price)
      this.show_dialog.update_keyword_price = true
    },

    async m__update_keyword_price() {
      this.loading.update_data = true

      if (!this.selected_keyword.price) {
        this.ntf_w(this.$t('required.bid_price'))
        return
      }

      this.m__prefix_keyword_price(this.selected_keyword)

      this.loading.update_keyword_price = true
      await this.sp_user.marketing_pas_update_keyword_price(this.c__campaign_id, [this.selected_keyword], 'shop')
      this.loading.update_keyword_price = false
      this.show_dialog.update_keyword_price = false
      this.loading.update_data = false

      const list = [{
        keyword: this.selected_keyword.keyword,
        oldPrice: this.selected_keyword.old_price,
        newPrice: this.selected_keyword.price,
        recommendPrice: this.selected_keyword.recommend_price,
        keywordReport: this.selected_keyword.report ? JSON.stringify(this.selected_keyword.report) : '',
      }]
      this.m__save_update_keyword_log(list).catch(console.error)
    },

    async m__pause_keyword(keyword) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_keyword')) {
        return
      }

      // keyword.status = 0
      // await this.m__change_keyword()

      this.loading.update_data = true
      keyword.status = 0
      await this.sp_user.marketing_pas_update_keyword_status(this.c__campaign_id, [keyword], 'shop')
      this.loading.update_data = false

      this.m__update_config_status('auto_position', 0, false, keyword).catch(console.error)
      this.m__update_config_status('auto_cir', 0, false, keyword).catch(console.error)
      this.m__update_config_status('anti_click', 0, false, keyword).catch(console.error)
    },

    async m__delete_keyword(keyword) {
      if (!this.m__is_allow_delete_keyword()) {
        this.cfm_w(this.$t('base.need_up_to_pro_package'))
        return
      }

      if (!this.check_role(this.shop, 'keyword_ads', 'delete_keyword')) {
        return
      }

      try {
        await this.$confirm(this.$t('keyword.delete_x_confirm', {x: keyword.keyword}), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        this.keywords = this.keywords.filter(i => i.keyword !== keyword.keyword)

        const advertisements = this.campaign.advertisements
        const advertisementsPlacement3 = advertisements.find(i => i.placement === 3)
        if (advertisementsPlacement3) {
          advertisementsPlacement3.extinfo.keywords = advertisementsPlacement3.extinfo.keywords.filter(i => i.keyword !== keyword.keyword)

          if (advertisementsPlacement3.extinfo.shop_customisation && advertisementsPlacement3.extinfo.shop_customisation.collection_id) {
            advertisementsPlacement3.extinfo.shop_customisation.collection_id = 0
          }
        }

        const update_resp = await this.sp_user.marketing_update_campaign({
          ads_audit_event: null,
          campaign_ads_list: [{
            advertisements: advertisements,
            campaign: this.campaign.campaign
          }]
        })

        if (update_resp.data && update_resp.data.code === 0) {
          await this.m__save_delete_keyword_log([keyword.keyword])
        }

        await this.m__change_keyword()
      } catch (e) {
      }
    },

    async m__recovery_keyword(keyword) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_keyword')) {
        return
      }

      this.loading.update_data = true
      keyword.status = 1
      await this.sp_user.marketing_pas_update_keyword_status(this.c__campaign_id, [keyword], 'shop')
      this.loading.update_data = false
    },

    async m__show_add_keywords_dialog() {
      if (!this.check_role(this.shop, 'keyword_ads', 'add_keyword')) {
        return
      }

      this.loading.show_add_keyword = true
      this.added_keywords = []

      const advertisementPlacement3 = this.campaign.advertisements.find(item => item.placement === 3)
      if (advertisementPlacement3) {
        // const response = await this.sp_user.marketing_suggest_keyword(null, 3)
        const response = await this.sp_user.shop_ads_get_suggest_keyword_price(null)
        console.log(response)
        this.shopee_suggest_keywords = response.data

        this.show_dialog.add_keywords = true
      }

      this.loading.show_add_keyword = false
    },

    m__can_add(keyword) {
      return !this.keywords.filter(i => i.status === 1).find(i => i.keyword.toLowerCase() === keyword.keyword.toLowerCase()) && !this.added_keywords.find(i => i.keyword.toLowerCase() === keyword.keyword.toLowerCase())
    },

    m__add_keyword(keyword) {
      if (this.omit_duplicated_keyword) {
        if (
          !this.keywords.find(e => e.keyword.normalize() === keyword.keyword.normalize()) &&
          !this.added_keywords.find(e => e.keyword.normalize() === keyword.keyword.normalize())
        ) {
          this.added_keywords.push({
            ...keyword,
            recommend_price: keyword.input_price || this.MATCH_TYPE_0_MIN,
            volume: keyword.volume
          })
        }
      } else {
        this.added_keywords.push({
          ...keyword,
          recommend_price: keyword.input_price || this.MATCH_TYPE_0_MIN,
          volume: keyword.volume
        })
      }
    },

    m__remove_keyword(keyword) {
      this.added_keywords = this.added_keywords.filter(i => i.keyword !== keyword.keyword)
    },

    async m__confirm_add_keyword() {
      if (!this.added_keywords.length) {
        this.ntf_w(this.$t('required.must_select_at_least_keyword'))
        return
      }

      this.loading.confirm_add_keywords = true

      const restricted_keywords = this.selected_restricted_keywords
        ? this.restricted_keywords_list.find(i => i.id === this.selected_restricted_keywords).keywords
        : []

      const MIN_PRICE = this.MATCH_TYPE_0_MIN
      this.added_keywords.forEach(i => {
        i.keyword = i.keyword.trim().normalize()
        if (!i.recommend_price || Number.isNaN(i.recommend_price) || i.recommend_price < MIN_PRICE) i.recommend_price = MIN_PRICE
      })
      this.added_keywords = _uniqBy(this.added_keywords, 'keyword')

      const MAX_LIMIT = 500
      let active_keywords = this.keywords.filter(i => i.status === 1).length
      for (const keyword of this.added_keywords) {
        if (restricted_keywords.includes(keyword.keyword)) continue

        if (active_keywords++ > MAX_LIMIT) break

        const add_keyword = {
          'status': 1,
          'price': keyword.recommend_price,
          'match_type': keyword.match_type !== undefined && keyword.match_type !== null ? keyword.match_type : this.added_keywords_type,
          'keyword': keyword.keyword.toLowerCase(),
          'algorithm': 'kwrcmdv2'
        }
        await this.sp_user.marketing_pas_add_keyword(this.c__campaign_id, [add_keyword], 'shop')
        await this.sleep(500)
      }

      this.$http.post(this.API.URL_API_SRV_1 + '/lg/1.1', {
        data: this.added_keywords.map(i => ({
          keyword: i.keyword,
          price: +i.recommend_price
        })),
        campaignId: this.c__campaign_id,
        mipeeUserId: this.$store.state.userInfo.username
      }, this.cf()).catch(console.error)

      await this.m__load_campaign_detail()

      this.$t('base.add_keyword_success')
      this.loading.confirm_add_keywords = false
      this.show_dialog.add_keywords = false
    },

    m__show_update_multiple_keyword_price() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_keyword')) {
        return
      }

      this.show_dialog.update_multiple_keyword_price = true
    },

    async m__update_multiple_keyword_price() {
      this.loading.update_data = true

      this.loading.update_multiple_keyword_price = true

      const checked_list = this.c__show_keyword_filter_list.filter(i => i.checked)
      const old_keyword = this.clone(checked_list)

      try {
        if (this.form_update_multiple_keyword_price.update_type === 1) {
          if (!this.form_update_multiple_keyword_price.update_by_cost_value) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.bid_price'),
              x: '0'
            }))
            return
          } else {
            checked_list.forEach(i => {
              if (this.form_update_multiple_keyword_price.update_by_cost === 'increase') {
                i.price = this.m__calculate(i.price) + this.m__calculate(this.form_update_multiple_keyword_price.update_by_cost_value)

                const max = +this.form_update_multiple_keyword_price.update_by_cost_value_max
                if (max && max < i.price) i.price = max
              }

              if (this.form_update_multiple_keyword_price.update_by_cost === 'reduce') {
                i.price = this.m__calculate(i.price) - this.m__calculate(this.form_update_multiple_keyword_price.update_by_cost_value)

                const min = +this.form_update_multiple_keyword_price.update_by_cost_value_min
                if (min && min > i.price) i.price = min
              }
            })
          }
        }

        if (this.form_update_multiple_keyword_price.update_type === 2) {
          if (!this.form_update_multiple_keyword_price.update_by_percent_value) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.bid_price'),
              x: '0'
            }))
            return
          } else {
            checked_list.forEach(i => {
              if (this.form_update_multiple_keyword_price.update_by_percent === 'increase') {
                i.price = this.m__calculate(i.price) + (this.m__calculate(i.price) * this.m__calculate(this.form_update_multiple_keyword_price.update_by_percent_value) / 100)

                const max = +this.form_update_multiple_keyword_price.update_by_percent_value_max
                if (max && max < i.price) i.price = max
              }

              if (this.form_update_multiple_keyword_price.update_by_percent === 'reduce') {
                i.price = this.m__calculate(i.price) - (this.m__calculate(i.price) * this.m__calculate(this.form_update_multiple_keyword_price.update_by_percent_value) / 100)

                const min = +this.form_update_multiple_keyword_price.update_by_percent_value_min
                if (min && min > i.price) i.price = min
              }
            })
          }
        }

        if (this.form_update_multiple_keyword_price.update_type === 3) {
          if (!this.form_update_multiple_keyword_price.update_by_suggest_cost_value) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.bid_price'),
              x: '0'
            }))
            return
          } else {
            checked_list.forEach(i => {
              const temp = this.form_update_multiple_keyword_price.type === 'suggest'
                ? i.recommend_price
                : +i.report.atosa_cpc

              if (this.form_update_multiple_keyword_price.update_by_suggest_cost === 'increase') {
                i.price = temp + this.m__calculate(this.form_update_multiple_keyword_price.update_by_suggest_cost_value)

                const max = +this.form_update_multiple_keyword_price.update_by_suggest_cost_value_max
                if (max && max < i.price) i.price = max
              }

              if (this.form_update_multiple_keyword_price.update_by_suggest_cost === 'reduce') {
                i.price = temp - this.m__calculate(this.form_update_multiple_keyword_price.update_by_suggest_cost_value)

                const min = +this.form_update_multiple_keyword_price.update_by_suggest_cost_value_min
                if (min && min > i.price) i.price = min
              }

              if (this.form_update_multiple_keyword_price.type === 'cpc' && !+i.report.atosa_cpc) {
                i.price = +this.form_update_multiple_keyword_price.default_cpc
              }
            })
          }
        }

        if (this.form_update_multiple_keyword_price.update_type === 4) {
          if (!this.form_update_multiple_keyword_price.update_by_suggest_percent_value) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.bid_price'),
              x: '0'
            }))
            return
          } else {
            checked_list.forEach(i => {
              const temp = this.form_update_multiple_keyword_price.type === 'suggest'
                ? i.recommend_price
                : +i.report.atosa_cpc

              if (this.form_update_multiple_keyword_price.update_by_suggest_percent === 'increase') {
                i.price = temp + (temp * this.m__calculate(this.form_update_multiple_keyword_price.update_by_suggest_percent_value) / 100)

                const max = +this.form_update_multiple_keyword_price.update_by_suggest_percent_value_max
                if (max && max < i.price) i.price = max
              } else {
                i.price = temp - (temp * this.m__calculate(this.form_update_multiple_keyword_price.update_by_suggest_percent_value) / 100)

                const min = +this.form_update_multiple_keyword_price.update_by_suggest_percent_value_min
                if (min && min > i.price) i.price = min
              }

              if (this.form_update_multiple_keyword_price.type === 'cpc' && !+i.report.atosa_cpc) {
                i.price = +this.form_update_multiple_keyword_price.default_cpc
              }
            })
          }
        }

        if (this.form_update_multiple_keyword_price.update_type === 5) {
          if (!this.form_update_multiple_keyword_price.cost_value) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.bid_price'),
              x: '0'
            }))
            return
          } else {
            checked_list.forEach(i => {
              i.price = this.m__calculate(this.form_update_multiple_keyword_price.cost_value)
            })
          }
        }

        if (this.form_update_multiple_keyword_price.update_type === 6) {

          checked_list.forEach(i => {
            if (!i.algorithm) i.algorithm = 'kwrcmdv2'
            i.price = this.form_update_multiple_keyword_price.type === 'suggest' ? i.recommend_price : (+i.report.atosa_cpc || 400)
          })
        }

        checked_list.forEach(i => {
          this.m__prefix_keyword_price(i)
        })

        await this.sp_user.marketing_pas_update_keyword_price(this.c__campaign_id, checked_list, 'shop')

        const keyword_list = []
        for (const old of old_keyword) {
          const found = checked_list.find(i => i.keyword === old.keyword)
          if (found) {
            keyword_list.push({
              keyword: old.keyword,
              oldPrice: old.price,
              newPrice: found.price,
              recommendPrice: found.recommend_price,
              keywordReport: found.report ? JSON.stringify(found.report) : ''
            })
          }
        }
        this.m__save_update_keyword_log(keyword_list, this.form_update_multiple_keyword_price).catch(console.error)

        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.update_multiple_keyword_price = false
      } catch (e) {
        console.log(e)
      } finally {
        this.loading.update_multiple_keyword_price = false
        this.loading.update_data = false
      }
    },

    m__show_update_multiple_keyword_match_type() {
      this.show_dialog.update_multiple_keyword_match_type = true
    },

    async m__update_multiple_keyword_match_type() {
      this.loading.update_data = true

      this.loading.update_multiple_keyword_match_type = true

      // const selected_keywords = this.keywords.filter(i => i.checked)
      const selected_keywords = this.c__show_keyword_filter_list.filter(i => i.checked)
      selected_keywords.forEach(i => {
        i.match_type = this.form_update_multiple_keyword_price.match_type
      })

      await this.sp_user.marketing_pas_update_keyword_type(this.c__campaign_id, selected_keywords, 'shop')
      this.$t('base.update_success')
      this.show_dialog.update_multiple_keyword_match_type = false
      this.loading.update_multiple_keyword_match_type = false
      this.loading.update_data = false
    },

    async m__update_multiple_keyword_status() {
      this.loading.update_data = true

      this.loading.update_multiple_keyword_status = true

      // const selected_keywords = this.keywords.filter(i => i.checked)
      const selected_keywords = this.c__show_keyword_filter_list.filter(i => i.checked && i.status !== this.form_update_multiple_keyword_price.status)
      selected_keywords.forEach(i => {
        i.status = this.form_update_multiple_keyword_price.status
      })

      await this.sp_user.marketing_pas_update_keyword_status(this.c__campaign_id, selected_keywords, 'shop')
      this.$t('base.update_success')
      this.show_dialog.update_multiple_keyword_status = false
      this.loading.update_multiple_keyword_status = false
      this.loading.update_data = false

      if (this.form_update_multiple_keyword_price.status === 0) {
        this.m__update_config_status('auto_position', 0, false).catch(console.error)
        this.m__update_config_status('auto_cir', 0, false).catch(console.error)
        this.m__update_config_status('anti_click', 0, false).catch(console.error)
      }
    },

    async m__remove_multiple_keyword() {
      if (!this.check_role(this.shop, 'keyword_ads', 'delete_keyword')) {
        return
      }

      try {
        const checked_count = this.c__show_keyword_filter_list.reduce((total, item) => {
          if (item.checked) total++
          return total
        }, 0)
        if (checked_count === this.keywords.length) {
          this.ntf_w(this.$t('keyword.cannot_delete_all_keywords'))
          return
        }

        this.loading.remove_multiple_keyword = true
        await this.$confirm(this.$t('keyword.delete_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })

        const placement3 = this.campaign.advertisements.find(item => item.placement === 3)
        if (placement3) {
          // placement3.extinfo.keywords = this.keywords.filter(i => !i.checked)
          // await this.m__change_keyword()
          placement3.extinfo.keywords = placement3.extinfo.keywords.filter(i => !this.c__show_keyword_filter_list.some(ii => ii.keyword === i.keyword && i.checked))

          if (placement3.extinfo.shop_customisation && placement3.extinfo.shop_customisation.collection_id) {
            placement3.extinfo.shop_customisation.collection_id = 0
          }

          const update_resp = await this.sp_user.marketing_update_campaign({
            ads_audit_event: null,
            campaign_ads_list: [{
              advertisements: this.campaign.advertisements,
              campaign: this.campaign.campaign
            }]
          })

          if (update_resp.data && update_resp.data.code === 0) {
            await this.m__save_delete_keyword_log(this.c__show_keyword_filter_list.filter(i => i.checked).map(i => i.keyword))
          }

          this.keywords = placement3.extinfo.keywords
        }
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
      } finally {
        this.loading.remove_multiple_keyword = false
      }
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    async m__suggest_keyword(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      let hint_keywords = await this.sp_user.marketing_get_hint_keyword(queryString)
      cb(hint_keywords.map(e => ({value: e.keyword})))
    },

    async m__search_sp_keyword(keyword) {
      this.add_keyword = []

      const search_keyword = keyword && keyword.value ? keyword.value : this.keyword
      if (!search_keyword) return

      let count = 0, max_count = 5
      let suggest_keywords_resp = await this.sp_user.shop_ads_search_keywords(search_keyword)
      while (!suggest_keywords_resp || !suggest_keywords_resp.data) {
        await this.sleep(1000)
        suggest_keywords_resp = await this.sp_user.shop_ads_search_keywords(search_keyword)

        count++
        if (count >= max_count) return
      }

      for (const item of suggest_keywords_resp.data) {
        this.add_keyword.push({
          ...item,
          checked: false,
          sp_volume: item.search_volume,
          sp_price: this.m__calculate(item.recommend_price)
        })
      }
    },

    async m__get_sp_keyword_info(keyword) {
      try {
        try {
          let info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, null, '3')
          if (info !== null) {
            keyword.sp_volume = info.search_volume
            keyword.sp_price = keyword.recommend_price = this.m__calculate(info.recommend_price)
          }
        } catch (e) {
        }
      } catch (e) {
      }
    },

    async m__save_config_auto_campaign(state) {
      this.loading.config_auto_campaign = true

      try {
        if (!this.m__check_times(this.form_config_auto_campaign.times)) {
          this.ntf_w(this.$t('required.select_runtime'))
          return
        }

        const form = {
          keywords: this.form_config_auto_campaign.keywords,
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          shopId: this.shop._id,
          times: this.form_config_auto_campaign.times.map(i => {
            return {
              startTime: i.start_time,
              endTime: i.end_time
            }
          }),
          quotaType: this.form_config_auto_campaign.quota_type,
          reduceValue: this.form_config_auto_campaign.reduce_value,
          increaseValue: this.form_config_auto_campaign.increase_value,
          note: '',
          state: state,
          notExceed2: this.form_config_auto_campaign.not_exceed_2,
          notExceed2Value: this.form_config_auto_campaign.not_exceed_2_value,
          notExceed3: this.form_config_auto_campaign.not_exceed_3,
          notExceed3Value: this.form_config_auto_campaign.not_exceed_3_value,
          notExceed4: this.form_config_auto_campaign.not_exceed_4,
          notExceed4Value: this.form_config_auto_campaign.not_exceed_4_value,
          notExceed5: this.form_config_auto_campaign.not_exceed_5,
          notExceed5Value: this.form_config_auto_campaign.not_exceed_5_value,
          notExceed6: this.form_config_auto_campaign.not_exceed_6,
          notExceed6Value: this.form_config_auto_campaign.not_exceed_6_value,
          stopAction: this.form_config_auto_campaign.stop_action,
          stopAction2: this.form_config_auto_campaign.stop_action_2,
          stopAction3: this.form_config_auto_campaign.stop_action_3,
          isCPC: this.form_config_auto_campaign.type === 'cpc',
          cpcTime: this.form_config_auto_campaign.time
        }
        // await this.$http.post(this.API.URL_API_SRV_1 + '/auto_campaigns/v2', form)

        await this.$confirm(this.$t('ads.just_select_only_one_2'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })

        await this.$http.post(this.API.URL_API_SRV_1 + '/auto_campaigns/v2', form, this.cf())

        for (const keyword of this.form_config_auto_campaign.keywords) {
          await this.$http.delete(this.API.URL_API_SRV_1 + '/shop_ads_position/v2', {
            ...this.cf(),
            params: {
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: this.c__campaign_id,
              keyword: keyword
            }
          })
        }

        this.$t('base.save_config_success')

        this.form_config_auto_campaign.state = state

        this.form_config_auto_campaign.keywords.forEach(i => {
          const k = this.keywords.find(kw => kw.keyword === i)
          if (k) {
            k.config_auto = {
              ...form,
              createdAt: new Date()
            }
            k.auto_position = null
          }
        })
        this.show_dialog.config_auto_campaign = false
      } catch (e) {
        console.log(e)
        this.ntf_w(e)
      } finally {
        this.loading.config_auto_campaign = false
      }
    },

    async m__show_config_auto_campaign_multiple() {
      if (!this.check_role(this.shop, 'keyword_ads', 'auto_campaign')) {
        return
      }

      this.select_multiple = true

      const config_list = this.keywords.filter(i => i.checked && i.auto_position)
      if (config_list.length) {
        const config = _orderBy(config_list, ['auto_position.createdAt'], ['asc'])
        const keyword = config[0]
        console.log(keyword)
        if (keyword.auto_position) {
          this.config_tab = 2
          this.form_config_auto_position = {
            ...keyword.auto_position,
            times: keyword.auto_position.times.map(i => {
              return {
                start_time: i.startTime,
                end_time: i.endTime
              }
            }),
            stop_action: keyword.auto_position.stopAction || 0,
            stop_action_2: keyword.auto_position.stopAction2,
            stop_action_3: keyword.auto_position.stopAction3,
            advanced_times: [],
            advanced_days: [],
            advanced_start_time: '',
            advanced_end_time: '',
            advanced: keyword.auto_position.advanced || false,
            advanced_day: '',
            advanced_day_number: null,
            advanced_max_value: null,
            advanced_max_price: null,
            advanced_start_price: null,

            device: keyword.auto_position.device || 'web',
            reduce_if: keyword.auto_position.reduceIf
          }
        }
      } else {
        const config_list = this.keywords.filter(i => i.checked && i.config_auto)
        if (config_list.length) {
          const config = _orderBy(config_list, ['config_auto.createdAt'], ['asc'])
          const keyword = config[0]
          if (keyword.config_auto) {
            this.config_tab = 1
            this.form_config_auto_campaign = {
              type: keyword.config_auto.isCPC ? 'cpc' : 'suggest',
              time: keyword.config_auto.cpcTime || 'week',
              times: keyword.config_auto.times.map(i => {
                return {
                  start_time: i.startTime,
                  end_time: i.endTime
                }
              }),
              start_time: '',
              end_time: '',
              quota_type: keyword.config_auto.quotaType,
              reduce_value: keyword.config_auto.reduceValue,
              increase_value: keyword.config_auto.increaseValue,
              state: keyword.config_auto.state,
              not_exceed_2: keyword.config_auto.notExceed2,
              not_exceed_2_value: keyword.config_auto.notExceed2Value,
              not_exceed_3: keyword.config_auto.notExceed3,
              not_exceed_3_value: keyword.config_auto.notExceed3Value,
              not_exceed_4: keyword.config_auto.notExceed4,
              not_exceed_4_value: keyword.config_auto.notExceed4Value,
              not_exceed_5: keyword.config_auto.notExceed5,
              not_exceed_5_value: keyword.config_auto.notExceed5Value,
              not_exceed_6: keyword.config_auto.notExceed6,
              not_exceed_6_value: keyword.config_auto.notExceed6Value,
              stop_action: keyword.config_auto.stopAction || 0,
              stop_action_2: keyword.config_auto.stopAction2,
              stop_action_3: keyword.config_auto.stopAction3
            }
          }
        }
      }

      this.form_config_auto_campaign.keywords = this.keywords.filter(i => i.checked).map(i => i.keyword)

      this.form_config_auto_position.keywords = this.keywords.filter(i => i.checked).map(i => i.keyword)

      this.show_dialog.config_auto_campaign = true
    },

    async m__show_config_auto_campaign(keyword) {
      if (!this.check_role(this.shop, 'keyword_ads', 'auto_campaign')) {
        return
      }

      this.select_multiple = false
      this.selected_keyword = keyword

      if (keyword.config_auto) {
        this.config_tab = 1

        this.form_config_auto_campaign = {
          type: keyword.config_auto.isCPC ? 'cpc' : 'suggest',
          time: keyword.config_auto.cpcTime || 'week',
          keywords: [keyword.keyword],
          times: keyword.config_auto.times.map(i => {
            return {
              start_time: i.startTime,
              end_time: i.endTime
            }
          }),
          start_time: '',
          end_time: '',
          quota_type: keyword.config_auto.quotaType,
          reduce_value: keyword.config_auto.reduceValue,
          increase_value: keyword.config_auto.increaseValue,
          state: keyword.config_auto.state,
          not_exceed_2: keyword.config_auto.notExceed2,
          not_exceed_2_value: keyword.config_auto.notExceed2Value,
          not_exceed_3: keyword.config_auto.notExceed3,
          not_exceed_3_value: keyword.config_auto.notExceed3Value,
          not_exceed_4: keyword.config_auto.notExceed4,
          not_exceed_4_value: keyword.config_auto.notExceed4Value,
          not_exceed_5: keyword.config_auto.notExceed5,
          not_exceed_5_value: keyword.config_auto.notExceed5Value,
          not_exceed_6: keyword.config_auto.notExceed6,
          not_exceed_6_value: keyword.config_auto.notExceed6Value,
          stop_action: keyword.config_auto.stopAction || 0,
          stop_action_2: keyword.config_auto.stopAction2,
          stop_action_3: keyword.config_auto.stopAction3
        }
        this.form_config_auto_position.keywords = [keyword.keyword]
      } else if (keyword.auto_position) {
        this.config_tab = 2
        this.form_config_auto_position = {
          ...keyword.auto_position,
          keywords: [keyword.keyword],
          times: keyword.auto_position.times.map(i => {
            return {
              start_time: i.startTime,
              end_time: i.endTime
            }
          }),
          stop_action: keyword.auto_position.stopAction || 0,
          stop_action_2: keyword.auto_position.stopAction2,
          stop_action_3: keyword.auto_position.stopAction3,
          advanced_times: [],
          advanced_days: [],
          advanced_start_time: '',
          advanced_end_time: '',
          advanced: keyword.auto_position.advanced || false,
          advanced_day: '',
          advanced_day_number: null,
          advanced_max_value: null,
          advanced_max_price: null,
          advanced_start_price: null,

          device: keyword.auto_position.device || 'web',
          reduce_if: keyword.auto_position.reduceIf
        }

        try {
          this.form_config_auto_position.advanced_times = keyword.auto_position.advancedTimes
            ? keyword.auto_position.advancedTimes.map(i => {
              return {
                advanced_start_time: i.split('-')[0],
                advanced_end_time: i.split('-')[1]
              }
            })
            : [
              {
                advanced_start_time: '00:00',
                advanced_end_time: '02:00'
              },
              {
                advanced_start_time: '06:00',
                advanced_end_time: '24:00'
              }
            ]

          this.form_config_auto_position.advanced_days = keyword.auto_position.advancedDays
            ? keyword.auto_position.advancedDays.map(i => JSON.parse(i))
            : []
        } catch (e) {
        }

        this.form_config_auto_campaign.keywords = [keyword.keyword]
      } else {
        this.config_tab = 1
        this.form_config_auto_campaign = {
          type: 'suggest',
          time: 'week',
          keywords: [keyword.keyword],
          times: [],
          start_time: '',
          end_time: '',
          quota_type: 5,
          reduce_value: 1,
          increase_value: 1,
          not_exceed_2: false,
          not_exceed_2_value: 0,
          not_exceed_3: false,
          not_exceed_3_value: 0,
          not_exceed_4: false,
          not_exceed_4_value: 0,
          not_exceed_5: false,
          not_exceed_5_value: 0,
          not_exceed_6: false,
          not_exceed_6_value: 0,
          stop_action: 0,
          stop_action_2: null,
          stop_action_3: null
        }

        this.form_config_auto_position = {
          keywords: [keyword.keyword],
          times: [],
          type: 'search',
          fromValue: null,
          toValue: null,
          upValue: null,
          downValue: null,
          minValue: null,
          maxValue: null,
          minPrice: null,
          maxPrice: null,
          start_time: '',
          end_time: '',
          stop_action: 0,
          stop_action_2: null,
          stop_action_3: null,
          advanced: false,
          advanced_start_time: '',
          advanced_end_time: '',
          advanced_times: [
            {
              advanced_start_time: '00:00',
              advanced_end_time: '02:00'
            },
            {
              advanced_start_time: '06:00',
              advanced_end_time: '24:00'
            }
          ],
          advanced_days: [],
          advanced_day: '',
          advanced_day_number: null,
          advanced_max_value: null,
          advanced_max_price: null,
          advanced_start_price: null,

          device: 'web',
          reduce_if: null
        }
      }

      // if (this.selected_keyword) {
      //   this.form_config_auto_position.advanced_start_price = this.selected_keyword.price
      // }

      // this.selected_campaign = campaign
      this.show_dialog.config_auto_campaign = true
    },

    async m__delete_config_auto_campaign() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        await this.$http.delete(this.API.URL_API_SRV_1 + '/auto_campaigns/v2', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: this.c__campaign_id,
            keyword: this.selected_keyword.keyword
          }
        })
        this.ntf_s(this.$t('base.delete_success'))
        this.selected_keyword.config_auto = null
        this.show_dialog.config_auto_campaign = false
      } catch (e) {
        console.log(e)
      }
    },

    async m__save_config_auto_position() {
      this.loading.auto_position = true
      try {
        if (!this.m__check_times(this.form_config_auto_position.times)) {
          this.ntf_w(this.$t('required.select_runtime'))
          return
        }

        if (!this.form_config_auto_position.maxValue) {
          this.ntf_w(this.$t('required.bonus_amount'))
          return
        }

        if (!this.form_config_auto_position.maxPrice) {
          this.ntf_w(this.$t('required.max_bid_price'))
          return
        }

        if (this.form_config_auto_position.stop_action === 2 && !this.form_config_auto_position.stop_action_2) {
          this.ntf_w(this.$t('required.percent_of_recommend_price'))
          return
        }

        if (this.form_config_auto_position.stop_action === 3 && !this.form_config_auto_position.stop_action_3) {
          this.ntf_w(this.$t('required.bid_price'))
          return
        }

        await this.$confirm(this.$t('ads.just_select_only_one_3'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })

        await this.$http.post(this.API.URL_API_SRV_1 + '/shop_ads_position/v2', {
          ...this.form_config_auto_position,
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          shopId: this.shop._id,
          times: this.form_config_auto_position.times.map(i => {
            i.startTime = i.start_time
            i.endTime = i.end_time
            return i
          }),
          stopAction: this.form_config_auto_position.stop_action,
          stopAction2: this.form_config_auto_position.stop_action_2,
          stopAction3: this.form_config_auto_position.stop_action_3,

          advanced: this.form_config_auto_position.advanced,
          advancedTimes: this.form_config_auto_position.advanced_times.map(i => `${i.advanced_start_time}-${i.advanced_end_time}`),
          advancedDays: this.form_config_auto_position.advanced_days.map(i => JSON.stringify(i)),

          device: this.form_config_auto_position.device,
          reduceIf: this.form_config_auto_position.reduce_if
        }, this.cf())

        await this.$http.post(this.API.URL_API_SRV_1 + '/auto_campaigns/v2/delete/multiple', {
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          keywords: this.form_config_auto_position.keywords
        }, this.cf())

        this.form_config_auto_position.keywords.forEach(i => {
          const k = this.keywords.find(kw => kw.keyword === i)
          if (k) {
            k.config_auto = null
            k.auto_position = {
              ...this.form_config_auto_position,
              stopAction: this.form_config_auto_position.stop_action,
              stopAction2: this.form_config_auto_position.stop_action_2,
              stopAction3: this.form_config_auto_position.stop_action_3,
              advanced: this.form_config_auto_position.advanced,
              advancedTimes: this.form_config_auto_position.advanced_times.map(i => `${i.advanced_start_time}-${i.advanced_end_time}`),
              advancedDays: this.form_config_auto_position.advanced_days.map(i => JSON.stringify(i)),
              device: this.form_config_auto_position.device,
              reduceIf: this.form_config_auto_position.reduce_if,
              createdAt: new Date()
            }
          }
        })

        this.ntf_s(this.$t('base.save_config_success'))
        this.show_dialog.config_auto_campaign = false
      } catch (e) {
        console.log(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.auto_position = false
      }
    },

    async m__delete_config_auto_position() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        await this.$http.delete(this.API.URL_API_SRV_1 + '/shop_ads_position/v2', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: this.c__campaign_id,
            keyword: this.selected_keyword.keyword
          }
        })
        this.ntf_s(this.$t('base.delete_success'))
        this.selected_keyword.auto_position = null
        this.show_dialog.config_auto_campaign = false
      } catch (e) {
        console.log(e)
      }
    },

    m__sort_change({
                     prop,
                     order
                   }) {
      this.sort_option.order = order
      this.sort_option.prop = prop
    },

    async m__handle_dropdown(command) {
      if (command === '1') {
        await this.m__export_excel()
      }

      if (command === '2') {
        await this.m__export_shopee()
      }

      if (command === '3') {
        await this.m__export_excel(true)
      }

      if (command === '4') {
        await this.m__export_metrics()
      }
    },

    async m__handle_dropdown2(command) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_keyword')) {
        return
      }

      if (command === '1') {
        this.m__show_update_multiple_keyword_match_type()
      }

      if (command === '2') {
        this.m__show_update_multiple_keyword_status()
      }

      if (command === '3') {
        this.m__show_update_keyword_by_condition_dialog()
      }
    },

    m__show_update_multiple_keyword_status() {
      this.show_dialog.update_multiple_keyword_status = true
    },

    async m__export_metrics() {
      const column_labels = this.$refs['main-table-detail'].columns.filter(i => i.property).map(i => i.label)
      column_labels.push(this.$t('base.date'))

      const data = []
      for (const keyword of this.c__show_keyword_filter_list) {
        const item = []
        for (const col of this.$refs['main-table-detail'].columns.filter(i => i.property)) {
          if (col.property === 'match_type') {
            if (keyword[col.property] === 0) item.push(this.$t('base.exact'))
            else if (keyword[col.property] === 1) item.push(this.$t('base.broad'))
            else item.push('')

            continue
          }

          item.push(this.get_value_by_path(keyword, col.property))
        }
        item.push(this.dayjs(this.start_date).startOf('d').format('DD/MM/YYYY'))
        data.push(item)
      }

      const filename = `report_${this.c__campaign_id}_${this.dayjs().format('DDMMYYYY')}.xlsx`
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        filename,
        data: [column_labels, ...data]
      }, {
        ...this.cf(),
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },

    async m__export_excel(is_checked = false) {
      // const keywords = is_checked ? this.keywords.filter(i => i.checked) : this.keywords
      const keywords = is_checked ? this.c__show_keyword_filter_list.filter(i => i.checked) : this.keywords
      if (!keywords.length) {
        this.ntf_w(this.$t('keyword.not_found'))
        return
      }

      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        data: keywords.map(i => {
          return [i.keyword, i.price, i.keyword === i.keyword.normalize('NFC') ? this.$t('base.precomposed') : this.$t('base.combining')]
        }),
        filename: `keyword-${keywords[0].keyword}-${this.dayjs().unix()}.xlsx`
      }, {
        ...this.cf(),
        responseType: 'blob'
      })

      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `keyword-${keywords[0].keyword}-${this.dayjs().unix()}.xlsx`)
      document.body.appendChild(link)
      link.click()
    },

    async m__export_shopee() {
      this.loading.export_report = true
      const start_time = this.dayjs(this.start_date).startOf('d').unix()
      const end_time = this.dayjs(this.end_date).endOf('d').unix()

      const trigger_response = await this.sp_user.marketing_pas_report_trigger_or_get_previous({
        start_time,
        end_time,
        header: {},
        report_type: 'shop_manual__single_detail',
        campaign_id: this.c__campaign_id
      })
      if (trigger_response && trigger_response.data && trigger_response.data.export_id) {
        const {export_id} = trigger_response.data

        let report_result = await this.sp_user.marketing_pas_report_get_single_result(export_id)
        while (report_result && report_result.data && ['waiting', 'processing'].includes(report_result.data.status)) {
          await this.sleep(1000)
          report_result = await this.sp_user.marketing_pas_report_get_single_result(export_id)
        }

        if (report_result && report_result.data && report_result.data.status === 'success') {
          const download_response = await this.sp_user.marketing_pas_report_download(export_id)
          const anchor = document.createElement('a')
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(download_response.data.content)
          anchor.target = '_blank'
          anchor.download = `${this.shop.username}.-${download_response.data.file_name}.csv`
          anchor.click()
        } else {
          this.ntf_w(this.$t('base.cannot_export_report'))
        }
      } else {
        this.ntf_w(this.$t('base.cannot_export_report'))
      }

      this.loading.export_report = false
    },

    async m__enter_input() {
      if (!this.fff_loading) {
        await this.m__try_get_keyword_result()
      }
    },

    async m__try_get_keyword_result() {
      this.fff_loading = true
      let keyword_list = await this.m__get_suggestion_keyword(this.base_keyword)
      let result = await this.fff.get_keyword_result(keyword_list, 5000, this.base_keyword)
      if (result === null) {
        await this.$nextTick(() => {
          this.ntf_w(this.$t('keyword.error_while_get_data'))
        })
      } else if (!result.data.keywords || !result.data.keywords.length) {
        this.ntf_w(`${this.$t('base.keywords_result_not_found')} "${this.base_keyword}"`)
      } else {
        let temp = result.data.keywords.map(e => {
          return {
            ...e,
            results: Math.round(e.results) || 0,
            checked: false,
            sp_volume: 0,
            loading: false,
            sp_price: 0
          }
        })
        if (!temp.some(i => i.keyword === this.base_keyword)) {
          const base_item = {
            keyword: this.base_keyword,
            results: 0,
            sp_volume: 0,
            sp_price: 0,
            relevance: 0,
            checked: false,
            loading: false
          }
          temp.unshift(base_item)
        }

        if (temp[0].keyword !== this.base_keyword) {
          const index = temp.findIndex(i => i.keyword === this.base_keyword)
          const temp_item = temp[index]
          temp.splice(index, 1)
          temp.unshift(temp_item)
        }

        const first = temp.shift()
        this.fff_result = _take(_orderBy(temp, ['results'], ['desc']), 500)
        this.fff_result.unshift(first)

        const keyword = this.base_keyword
        const extend_resp = await this.sp_user.marketing_suggest_keywords(keyword, null)
        if (extend_resp && extend_resp.data) {
          let index_splice = 1
          for (const item of extend_resp.data) {
            // if (keyword !== item.keyword && keyword === item.keyword.normalize()) {
            if (this.contain_at_least(keyword, item.keyword)) {
              const keyword = {
                keyword: item.keyword,
                results: 0,
                sp_volume: item.search_volume,
                sp_price: item.recommend_price,
                relevance: item.relevance,
                checked: false,
                loading: false
              }
              if (!this.fff_result.some(i => i.keyword === item.keyword)) {
                this.fff_result.splice(index_splice++, 0, keyword)
              }
            }
          }
        }

        try {
          const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
            mipeeUserId: this.$store.state.userInfo.username,
            keyword: this.base_keyword,
            data: this.fff_result.map(i => i.keyword),
            country: this.sp_user.country
          }, this.cf())
          this.save_and_result_list = resp.body
        } catch (e) {
          console.error(e)
        }

        // for (const item of this.fff_result) {
        //   item.keyword = item.keyword.normalize()
        // }
        this.result = _uniqBy(this.fff_result, 'keyword')

        this.fetch_index = 0
        this.fetch_keyword = this.base_keyword
        await this.m__start_get_sp_keyword()
      }

      this.fff_loading = false
    },

    async m__start_get_sp_keyword() {
      console.log('Bắt đầu lấy keyword trên shopee')
      this.fetch_loading = true
      for (const item of this.fff_result) {
        if (this.fetch_keyword !== this.base_keyword) {
          break
        }

        if (item.sp_volume && item.sp_price) continue

        const found = this.save_and_result_list.find(i => i.keyword === item.keyword)
        if (found) {
          item.relevance = found.relevance
          item.sp_volume = found.volume
          item.sp_price = item.recommend_price = this.m__calculate(found.recommendPrice)
        } else {
          // await this.m__get_sp_keyword_info(item)
        }
      }

      this.fff_clone = JSON.parse(JSON.stringify(this.fff_result))
      this.fetch_loading = false
    },

    async m__get_suggestion_keyword(keyword) {
      const hint_keywords = await this.sp_user.marketing_list_keyword_hint(keyword, null, 3)
      return hint_keywords.data.map(i => i.keyword)
    },

    m__fff_sort_change({
                         prop,
                         order
                       }) {
      this.fff_sort_option.order = order
      this.fff_sort_option.prop = prop
    },

    async m__pause_campaign() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      this.campaign.campaign.state = 'paused'
      await this.sp_user.marketing_pas_update_shop_campaign({
        campaign_id: this.c__campaign_id,
        header: {},
        type: 'pause'
      })
      this.$emit('change_state', 'paused')
    },

    async m__ongoing_campaign() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      this.campaign.campaign.state = 'ongoing'
      await this.sp_user.marketing_pas_update_shop_campaign({
        campaign_id: this.c__campaign_id,
        header: {},
        type: 'resume'
      })
      this.$emit('change_state', 'ongoing')
    },

    async m__restart_campaign() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      this.campaign.campaign.state = 'ongoing'

      const form = {
        reference_id: make_uuid(),
        campaign: {
          campaign_id: this.c__campaign_id,
          daily_budget: +this.campaign.campaign.daily_quota * 100000,
          creative: {
            is_use_default: false,
            landing_page: 'shop_homepage',
            image_url: this.campaign.advertisements.length ? this.campaign.advertisements[0].extinfo.shop_customisation.image_url : '',
            tagline: this.campaign.advertisements.length ? this.campaign.advertisements[0].extinfo.shop_customisation.display_title : ''
          },
          bidding_strategy: 'manual',
          start_time: this.dayjs().startOf('day').unix(),
          end_time: 0,
          name: this.campaign.campaign.name
        },
        header: {}
      }

      const placement3 = this.campaign.advertisements.find(i => i.placement === 3)
      if (placement3) {
        form.campaign.bidding_strategy = 'manual'
        form.campaign.keyword_list = this.keywords
          .filter(i => i.status === 1)
          .map(keyword => {
            keyword.price = this.m__calculate(keyword.recommend_price)
            this.m__prefix_keyword_price(keyword)

            return {
              keyword: keyword.keyword,
              bid_price: keyword.price * 100000,
              match_type: keyword.match_type === 0 ? 'exact' : 'broad'
            }
          })
      }

      const placement20 = this.campaign.advertisements.find(i => i.placement === 20)
      if (placement20) {
        form.campaign.bidding_strategy = 'auto'
        form.campaign.target_broad_roi = placement20.extinfo.target_broad_roi
      }

      const create_response = await this.sp_user.marketing_pas_publish_campaign(form, 'shop')
      console.log(create_response)

      this.$emit('change_state', 'ongoing')
    },

    async m__stop_campaign() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      this.campaign.campaign.state = 'ended'
      await this.sp_user.marketing_pas_update_shop_campaign({
        campaign_id: this.c__campaign_id,
        header: {},
        type: 'stop'
      })
      this.$emit('change_state', 'ended')
    },

    async m__delete_campaign() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      try {
        await this.$confirm(this.$t('base.delete_campaign_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.campaign.campaign.state = 'deleted'
      await this.sp_user.marketing_pas_update_shop_campaign({
        campaign_id: this.c__campaign_id,
        header: {},
        type: 'delete'
      })
      this.$emit('change_state', 'deleted')
      this.ntf_s(this.$t('base.delete_success'))
    },

    m__initial_save_keyword_file(is_added_keyword = false) {
      if (!this.m__is_allow_keyword_tool()) {
        this.ntf_w(this.$t('package.not_for_trial'))
        return
      }

      if (is_added_keyword) {
        if (this.added_keywords.length > 0) {
          this.save_keyword_file.filename = `${this.$t('keyword.file')} ${this.added_keywords[0].keyword} (${this.added_keywords.length} ${this.$t('base.keyword')} - ${this.$t('base.at')} ${this.timeFormat(new Date())})`
          this.save_keyword_file.show = true
        } else {
          this.ntf_w(this.$t('keyword.empty_to_save'))
        }
      } else {
        if (this.keywords.length > 0) {
          this.save_keyword_file.filename = `${this.$t('keyword.file')} ${this.keywords[0].keyword} (${this.keywords.length} ${this.$t('base.keyword')} - ${this.$t('base.at')} ${this.timeFormat(new Date())})`
          this.save_keyword_file.show = true
        } else {
          this.ntf_w(this.$t('keyword.empty_to_save'))
        }
      }

      this.is_save_added_keywords = is_added_keyword
    },

    async m__try_save_keyword_file() {
      let keyword_list = this.is_save_added_keywords ? this.added_keywords : this.keywords
      if (!this.is_save_added_keywords && this.save_keyword_type === 'selected') {
        keyword_list = keyword_list.filter(i => i.checked)
      }

      if (this.save_keyword_file_type === 'add') {
        this.confirm(this.$t('keyword.confirm_save_file_x_name', {x: this.save_keyword_file.filename}), () => {
          this.save_keyword_file.loading = true

          this.$http.post(this.API.marketing.keyword_file.add, {
            filename: this.save_keyword_file.filename,
            keyword_json: keyword_list.map(i => {
              return {
                checked: true,
                keyword: i.keyword,
                keyword_source_type: 0,
                price: i.price || i.recommend_price,
                record_type: 0,
                rnum: 0,
                sp_price: i.price || i.recommend_price,
                sp_volume: 0,
                match_type: i.match_type
              }
            })
          }, this.cf())
            .then(async (resp) => {
              this.ntf_s(resp)
              this.save_keyword_file.loading = false
              this.save_keyword_file.show = false

              this.$emit('m__reload_saved_keyword')
            })
            .catch(error => {
              console.log(error)
              this.ntf_w(error)
              this.save_keyword_file.loading = false
            })
        })
      }

      if (this.save_keyword_file_type === 'update') {
        if (!this.selected_keyword_file) return
        try {
          await this.$confirm(this.$t('base.update_file_confirm'), this.$t('base.attention'), {
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
            type: 'warning'
          })
        } catch (e) {
          return
        }

        this.save_keyword_file.loading = true
        const current_file = this.keyword_file_list.find(i => i._id === this.selected_keyword_file)
        // console.log(current_file)

        const detail_response = await this.$http.get(this.API.marketing.keyword_file.detail.replace('_id', this.selected_keyword_file), this.cf())
        // console.log(detail_response.body.data.keyword_json)
        if (detail_response.body && detail_response.body.data && detail_response.body.data.keyword_json) {
          for (const keyword of keyword_list) {
            const found = detail_response.body.data.keyword_json.find(i => i.keyword === keyword.keyword)
            if (!found) {
              detail_response.body.data.keyword_json.push({
                checked: true,
                keyword: keyword.keyword,
                keyword_source_type: 0,
                price: keyword.price || keyword.recommend_price,
                record_type: 0,
                rnum: 0,
                sp_price: keyword.price || keyword.recommend_price,
                sp_volume: keyword.report ? keyword.report.search_volume : 0,
                match_type: keyword.match_type
              })
            }
          }

          const update_response = await this.$http.put(this.API.marketing.keyword_file.update.replace('_id', this.selected_keyword_file), {
            ...current_file,
            keyword_count: detail_response.body.data.keyword_json.length,
            keyword_json: detail_response.body.data.keyword_json
          }, this.cf())
          this.ntf_s(update_response)
          this.save_keyword_file.loading = false
          this.save_keyword_file.show = false
          this.$emit('m__reload_saved_keyword')
        }

        this.save_keyword_file.loading = false
      }
    },

    async m__delete_multiple_config_auto_campaign() {
      if (!this.check_role(this.shop, 'keyword_ads', 'auto_campaign')) {
        return
      }

      try {
        await this.$confirm(this.$t('base.delete_multiple_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        this.loading.delete_all = true
        await this.$http.post(this.API.URL_API_SRV_1 + '/auto_campaigns/v2/delete/multiple', {
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          // keywords: this.keywords.filter(i => i.checked).map(i => i.keyword)
          keywords: this.c__show_keyword_filter_list.filter(i => i.checked).map(i => i.keyword)
        }, this.cf())
        await this.$http.post(this.API.URL_API_SRV_1 + '/shop_ads_position/v2/delete/multiple', {
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          // keywords: this.keywords.filter(i => i.checked).map(i => i.keyword)
          keywords: this.c__show_keyword_filter_list.filter(i => i.checked).map(i => i.keyword)
        }, this.cf())

        // const selected_keywords = this.keywords.filter(i => i.checked)
        const selected_keywords = this.c__show_keyword_filter_list.filter(i => i.checked)
        for (const item of selected_keywords) {
          item.config_auto = null
          item.auto_position = null
        }

        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
      } finally {
        this.loading.delete_all = false
      }
    },

    m__show_import_excel_file() {
      this.$el.querySelector(`#input_control_detail`).click()
    },

    async m__import_excel_file(e) {
      try {
        const file_store = e.target.files || e.dataTransfer.files
        if (file_store.length === 0) {
          return
        }

        const raw = await readXlsxFile(file_store[0])
        for (const row of raw) {
          if (row && row[0] && typeof row[0] === 'string' && !this.excel_keyword.some(i => i.keyword === row[0].toLowerCase())) {
            this.excel_keyword.push({
              keyword: row[0],
              recommend_price: 0,
              search_volume: 0,
              input_price: row[1] && !Number.isNaN(+row[1]) ? +row[1] : null
            })
          }
        }

        if (this.excel_keyword.length) {
          try {
            const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
              mipeeUserId: this.$store.state.userInfo.username,
              keyword: this.excel_keyword[0].keyword,
              data: this.excel_keyword.map(i => i.keyword),
              country: this.sp_user.country
            }, this.cf())
            this.save_and_result_list = resp.body
          } catch (e) {
            console.error(e)
          }

          for (const keyword of this.excel_keyword) {
            if (keyword.recommend_price) continue

            const found = this.save_and_result_list.find(i => i.keyword === keyword.keyword)
            if (found) {
              keyword.search_volume = found.volume
              if (keyword.recommend_price === 0) keyword.recommend_price = this.m__calculate(found.recommendPrice)
            } else {
              const info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, null, '3')
              keyword.search_volume = this.m__calculate(info.search_volume)
              keyword.algorithm = info.algorithm
              if (keyword.recommend_price === 0) keyword.recommend_price = this.m__calculate(info.recommend_price)
            }
          }
        }
      } catch (e) {
        console.log(e)
        this.ntf_w(this.$t('base.error_reading_file'))
      } finally {
        e.target.value = null
      }
    },

    m__show_update_campaign_date() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      if (this.campaign.campaign.state === 'ended' || this.campaign.campaign.state === 'closed') {
        return
      }

      if (this.campaign.campaign.end_time === 0) {
        this.campaign_time.start_time = new Date(this.campaign.campaign.start_time * 1000)
        this.selected_time_type = 'unlimited'
      } else {
        this.selected_time_type = 'from_to'
        this.campaign_time.start_time = new Date()
        this.campaign_time.end_time = new Date(this.campaign.campaign.end_time * 1000)
      }
      this.show_dialog.update_campaign_date = true
    },

    m__show_update_campaign_quota() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      if (this.campaign.campaign.state === 'ended' || this.campaign.campaign.state === 'closed') {
        return
      }

      if (this.m__calculate(this.campaign.campaign.daily_quota) === 0 && this.m__calculate(this.campaign.campaign.total_quota) === 0) {
        this.selected_quota_type = '1'
      } else {
        this.selected_quota_type = '2'
        if (this.m__calculate(this.campaign.campaign.daily_quota) > 0) {
          this.campaign_quota.quota = this.m__calculate(this.campaign.campaign.daily_quota)
          this.campaign_quota.type = 'daily'
        } else {
          this.campaign_quota.quota = this.m__calculate(this.campaign.campaign.total_quota)
          this.campaign_quota.type = 'total'
        }
      }

      this.show_dialog.update_campaign_quota = true
    },

    async m__update_campaign_quota() {
      this.loading.update_campaign_quota = true

      const parent_campaign = this.parent_campaign.campaign
      const campaign = this.campaign.campaign
      const body = {
        campaign_id: campaign.campaignid,
        type: 'change_budget',
        change_budget: {
          daily_budget: 0,
          total_budget: 0,
          budget_log_key: 'budget_log_' + make_uuid()
        }
      }

      const log = {
        campaignId: campaign.campaignid,
        mipeeUserId: this.$store.state.userInfo.username,
        shopId: this.shop._id + '_single',
        oldDailyQuota: +campaign.daily_quota,
        oldCampaign: JSON.stringify(campaign),
        newDailyQuota: null,
        newCampaign: null
      }

      if (this.selected_quota_type === '1') {
        parent_campaign.daily_quota = campaign.daily_quota = body.change_budget.daily_budget = 0
        parent_campaign.total_quota = campaign.total_quota
      } else {
        if (this.campaign_quota.type === 'daily') {
          if (this.campaign_quota.quota < this.DAILY_BUDGET_MIN) {
            this.ntf_w(this.$t('base.y_gte_than_x', {
              y: this.$t('base.budget'),
              x: this.DAILY_BUDGET_MIN
            }))
            this.loading.update_campaign_quota = false
            return
          } else {
            parent_campaign.daily_quota = campaign.daily_quota = body.change_budget.daily_budget = this.campaign_quota.quota
            parent_campaign.total_quota = campaign.total_quota
          }
        }

        if (this.campaign_quota.type === 'total') {
          if (this.campaign_quota.quota < this.DAILY_BUDGET_MIN * 10) {
            this.ntf_w(this.$t('base.y_gte_than_x', {
              y: this.$t('base.budget'),
              x: this.DAILY_BUDGET_MIN * 10
            }))
            this.loading.update_campaign_quota = false
            return
          } else {
            parent_campaign.total_quota = campaign.total_quota
            parent_campaign.daily_quota = campaign.daily_quota = body.change_budget.daily_budget = 0
          }
        }
      }

      body.change_budget.daily_budget *= 100000
      await this.sp_user.marketing_pas_update_campaign(body, 'shop')

      log.newDailyQuota = +campaign.daily_quota
      log.newCampaign = JSON.stringify(campaign)
      this.$http.post(this.API.URL_API_SRV_1 + '/lg/5.1', log, this.cf()).catch(console.error)

      this.ntf_s(this.$t('base.update_success'))

      this.loading.update_campaign_quota = false
      this.show_dialog.update_campaign_quota = false
    },

    async m__update_campaign_date() {
      this.loading.update_campaign_date = true

      if (this.selected_time_type === 'unlimited') {
        this.parent_campaign.campaign.end_time = this.campaign.campaign.end_time = 0
      } else {
        if (!this.campaign_time.start_time) {
          this.ntf_w(this.$t('required.start_time'))
          return
        }
        if (!this.campaign_time.end_time) {
          this.$t('required.end_time')
          return
        }
        if (this.campaign_time.end_time.getTime() <= this.campaign_time.start_time.getTime()) {
          this.ntf_w(this.$t('base.y_gt_than_x', {
            y: this.$t('base.start_time'),
            x: this.$t('base.end_time'),
          }))
          return
        }

        this.parent_campaign.campaign.start_time = this.campaign.campaign.start_time = this.dayjs(this.campaign_time.start_time).startOf('d').unix()
        this.parent_campaign.campaign.end_time = this.campaign.campaign.end_time = this.dayjs(this.campaign_time.end_time).endOf('d').unix()
      }

      await this.m__change_keyword()
      this.ntf_s(this.$t('base.update_success'))

      this.loading.update_campaign_date = false
      this.show_dialog.update_campaign_date = false
    }
  }
}
</script>

<style>
.dialog-height .el-dialog {
  min-height: 90%;
}

.shop-ads-image:hover .shop-ads-image-hover {
  display: block !important;
  z-index: 999;
}

#main-table-detail-fixed-header {
  position: fixed;
  top: 0;
  z-index: -1;

  .el-table__empty-block {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pas/detail/shop.vue